import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.string.trim-start.js";
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, {
  enumerable: true,
  configurable: true,
  writable: true,
  value
}) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) for (var prop of __getOwnPropSymbols(b)) {
    if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) for (var prop of __getOwnPropSymbols(source)) {
    if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
  }
  return target;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = value => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = value => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = x => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};

// src/library/components/context-providers/cart/CartContext.ts
import { createContext } from "react";
var CartQueryMutationKey = /* @__PURE__ */(CartQueryMutationKey2 => {
  CartQueryMutationKey2["addLineItem"] = "addLineItem";
  CartQueryMutationKey2["removeLineItem"] = "removeLineItem";
  CartQueryMutationKey2["updateLineItem"] = "updateLineItem";
  CartQueryMutationKey2["createCart"] = "createCart";
  CartQueryMutationKey2["deleteCart"] = "deleteCart";
  CartQueryMutationKey2["recalculateCart"] = "recalculateCart";
  CartQueryMutationKey2["addCoupon"] = "addCoupon";
  CartQueryMutationKey2["removeCoupon"] = "removeCoupon";
  CartQueryMutationKey2["duplicateLineItem"] = "duplicateLineItem";
  CartQueryMutationKey2["getCart"] = "getCart";
  CartQueryMutationKey2["addQuoteToCart"] = "addQuoteToCart";
  CartQueryMutationKey2["setReferenceLabel"] = "setReferenceLabel";
  CartQueryMutationKey2["setPurchaseorderNumber"] = "setPurchaseorderNumber";
  CartQueryMutationKey2["reOrderLineItems"] = "reOrderLineItems";
  CartQueryMutationKey2["setPaymentMethod"] = "setPaymentMethod";
  CartQueryMutationKey2["getShippingOptions"] = "getShippingOptions";
  CartQueryMutationKey2["placeOrder"] = "placeOrder";
  CartQueryMutationKey2["editLineItem"] = "editLineItem";
  CartQueryMutationKey2["changeDeliveryOption"] = "changeDeliveryOption";
  CartQueryMutationKey2["setPickupPoint"] = "setPickupPoint";
  CartQueryMutationKey2["setShippingAddress"] = "setShippingAddress";
  CartQueryMutationKey2["setSplitShipment"] = "setSplitShipment";
  CartQueryMutationKey2["setBillingAddress"] = "setBillingAddress";
  return CartQueryMutationKey2;
})(CartQueryMutationKey || {});
var defaultValue = {
  cartId: void 0,
  cart: void 0,
  setCartId() {},
  invalidateCart() {},
  setCartData() {},
  locallyRemoveCart() {},
  errors: /* @__PURE__ */new Map(),
  addError() {},
  removeError() {},
  removeAllErrors() {},
  notifications: /* @__PURE__ */new Map(),
  addNotification() {},
  removeNotification() {},
  resetNotifications() {},
  expiredQuotesError: void 0
};
var CartContext = createContext(defaultValue);
var CartContext_default = CartContext;

// src/library/components/order/context-provider/OrderContext.ts
var OrderQueryMutationKey = /* @__PURE__ */(OrderQueryMutationKey2 => {
  OrderQueryMutationKey2["patchOrder"] = "patchOrder";
  OrderQueryMutationKey2["orderSetPoNumber"] = "orderSetPoNumber";
  OrderQueryMutationKey2["orderSetReference"] = "orderSetReference";
  OrderQueryMutationKey2["getOrder"] = "getOrder";
  OrderQueryMutationKey2["cancelOrder"] = "cancelOrder";
  OrderQueryMutationKey2["getOrders"] = "getOrders";
  OrderQueryMutationKey2["getLatestSelection"] = "getLatestSelection";
  OrderQueryMutationKey2["patchLineItem"] = "patchLineItem";
  OrderQueryMutationKey2["getOrderStats"] = "getOrderStats";
  OrderQueryMutationKey2["setBillingAddress"] = "setBillingAddress";
  OrderQueryMutationKey2["orderLineItemSetShippingAddress"] = "orderLineItemSetShippingAddress";
  return OrderQueryMutationKey2;
})(OrderQueryMutationKey || {});

// src/library/hooks/cart/useCart.ts
import { useContext } from "react";
function useCart() {
  const cartContext = useContext(CartContext_default);
  if (!cartContext.queries) {
    throw new Error("Cannot use cart hook when cart queries have not been provided. Make sure the application is wrapped in a CartProvider.");
  }
  return cartContext;
}

// src/library/queries/line-item/useRemoveLineItemMutation.ts
import { useMutation } from "@tanstack/react-query";

// src/library/http-clients/ShoppingCartHttpClient.ts
import axios from "axios";
import { getFeatureManagementUserId } from "@printdeal/feature-management/react";
import { configurationProvider } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor } from "@printdeal/authentication";

// src/library/http-clients/CartVersionMismatchPreventionHelpers.ts
import { useEffect, useState } from "react";
var pendingCartMutations = [];
function isCartMutationPending() {
  return pendingCartMutations.length > 0;
}
var stateChangeSubscriptions = /* @__PURE__ */new Set();
function onStateChange(subscription) {
  stateChangeSubscriptions.add(subscription);
  return () => {
    stateChangeSubscriptions.delete(subscription);
  };
}
function notifyStateChangeSubscriptions() {
  stateChangeSubscriptions.forEach(subscription => {
    subscription({
      isCartMutationPending: isCartMutationPending()
    });
  });
}
function executeNextCartMutation() {
  const nextCartMutation = pendingCartMutations.length > 0 ? pendingCartMutations[0] : void 0;
  nextCartMutation == null ? void 0 : nextCartMutation.cartMutation().then(value => {
    nextCartMutation.resolve(value);
  }).catch(reason => {
    nextCartMutation.reject(reason);
  }).finally(() => {
    pendingCartMutations.shift();
    notifyStateChangeSubscriptions();
    if (pendingCartMutations.length) {
      executeNextCartMutation();
    }
  });
  notifyStateChangeSubscriptions();
}
function preventCartVersionMismatch(cartMutation) {
  return new Promise((resolve, reject) => {
    const wrappedCartMutation = {
      resolve,
      reject,
      cartMutation
    };
    pendingCartMutations.push(wrappedCartMutation);
    if (pendingCartMutations.length === 1) {
      executeNextCartMutation();
    }
  });
}
function useCartVersionMismatchPrevention() {
  const [state, setState] = useState({
    isCartMutationPending: isCartMutationPending()
  });
  useEffect(() => {
    const unsubscribe = onStateChange(currentState => {
      setState(currentState);
    });
    return () => {
      unsubscribe();
    };
  }, []);
  return state;
}

// src/library/http-clients/ShoppingCartHttpClient.ts
var ShoppingCartHttpClient = class {
  get client() {
    var _a;
    if (!this.httpClient) {
      const baseURL = configurationProvider.getValue("ECOMMERCE_CART_API_BASE_URL");
      this.httpClient = axios.create({
        baseURL,
        headers: {
          "Feature-Management-User-Id": (_a = getFeatureManagementUserId()) != null ? _a : ""
        }
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor);
    }
    return this.httpClient;
  }
  getCart(cartId) {
    return __async(this, null, function* () {
      return this.client.get("/cart/".concat(cartId));
    });
  }
  removeLineItem(cartId, data) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.delete("/cart/".concat(cartId, "/lineitems/").concat(data.lineItemId)));
    });
  }
  updateLineItem(_0, _1) {
    return __async(this, arguments, function (cartId, _ref) {
      var _this = this;
      let {
        payload,
        lineItemId
      } = _ref;
      return function* () {
        return preventCartVersionMismatch(() => _this.client.patch("cart/".concat(cartId, "/lineitems/").concat(lineItemId), payload));
      }();
    });
  }
  patchCart(cartId, payload) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.patch("/cart/".concat(cartId), payload));
    });
  }
  deleteCart(cartId) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.delete("/cart/".concat(cartId)));
    });
  }
  addLineItem(cartId, payload) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart/".concat(cartId, "/lineitems"), payload));
    });
  }
  createCart() {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart"));
    });
  }
  addQuoteLineItem(cartId, payload) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart/".concat(cartId, "/lineitems/quotes"), payload));
    });
  }
  placeOrder(cartId) {
    return __async(this, null, function* () {
      return preventCartVersionMismatch(() => this.client.post("/cart/".concat(cartId, "/order")));
    });
  }
  getLineItemOptions(cartId, lineItemId) {
    return __async(this, null, function* () {
      return this.client.get("/cart/".concat(cartId, "/lineitems/").concat(lineItemId, "/options"));
    });
  }
  searchPickupPoints(cartId, lineItemId, payload) {
    return __async(this, null, function* () {
      return this.client.post("/cart/".concat(cartId, "/lineitems/").concat(lineItemId, "/search-pickup-points"), payload);
    });
  }
};
var shoppingCartHttpClient = new ShoppingCartHttpClient();
var ShoppingCartHttpClient_default = shoppingCartHttpClient;

// src/library/queries/line-item/useRemoveLineItemMutation.ts
function useRemoveLineItemMutation(_ref2) {
  let {
    onSuccess,
    onError
  } = _ref2;
  const {
    cartId,
    invalidateCart
  } = useCart();
  const mutationKey = "removeLineItem" /* removeLineItem */;
  return useMutation({
    mutationKey: [mutationKey],
    mutationFn: _0 => __async(this, [_0], function (_ref3) {
      let {
        lineItemId
      } = _ref3;
      return function* () {
        if (!cartId) {
          throw new Error("Cannot remove line item without cart id");
        }
        if (!lineItemId) {
          throw new Error("Cannot remove line item without line item id");
        }
        const {
          data
        } = yield ShoppingCartHttpClient_default.removeLineItem(cartId, {
          lineItemId
        });
        return data;
      }();
    }),
    retry: false,
    onSuccess: data => {
      invalidateCart();
      if (typeof onSuccess === "function") {
        onSuccess(data, mutationKey);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/queries/line-item/useAddLineItemMutation.ts
import { useMutation as useMutation3 } from "@tanstack/react-query";
import { addDataLayerEntry } from "@printdeal/data-layer-manager";
import { ErrorManagement } from "@printdeal/error-management/react";

// src/library/queries/cart/useCreateCartMutation.ts
import { useMutation as useMutation2 } from "@tanstack/react-query";
function useCreateCartMutation() {
  let {
    onSuccess,
    onError
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    setCartData
  } = useCart();
  const mutationKey = "createCart" /* createCart */;
  return useMutation2({
    mutationKey: [mutationKey],
    mutationFn: () => __async(this, null, function* () {
      const {
        data
      } = yield ShoppingCartHttpClient_default.createCart();
      return data;
    }),
    retry: false,
    onSuccess: data => {
      setCartData(data);
      if (typeof onSuccess === "function") {
        onSuccess(data, mutationKey);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/queries/line-item/useAddLineItemMutation.ts
function useAddLineItemMutation() {
  let {
    onSuccess,
    onError
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    cartId,
    setCartData,
    cart
  } = useCart();
  const createCartMutation = useCreateCartMutation({
    onError
  });
  const mutationKey = "addLineItem" /* addLineItem */;
  return useMutation3({
    mutationKey: [mutationKey],
    mutationFn: payload => __async(this, null, function* () {
      payload.lineItems.forEach(lineItem => {
        if (!lineItem.product.userSelection["Delivery Type"]) {
          ErrorManagement.exception({
            exception: "Attempting to add line item to cart without Delivery Type attribute",
            tags: {
              fileLocation: "AddLineItemHelper",
              featureFunction: "buildLineItemShape"
            },
            fingerprint: ["missing-delivery-type"]
          });
        }
      });
      cart == null ? void 0 : cart.lineItems.forEach(lineItem => {
        var _a2, _b, _c, _d, _e, _f, _g;
        if (((_b = (_a2 = lineItem.custom) == null ? void 0 : _a2.fields.mcpDocumentsSource) == null ? void 0 : _b.length) && ((_f = (_e = (_d = (_c = payload.lineItems[0]) == null ? void 0 : _c.files) == null ? void 0 : _d.mcp) == null ? void 0 : _e.mcpDocumentsSource) == null ? void 0 : _f.length) && lineItem.custom.fields.mcpDocumentsSource[0] === ((_g = payload.lineItems[0]) == null ? void 0 : _g.files.mcp.mcpDocumentsSource[0])) {
          ErrorManagement.exception({
            exception: "Attempting to add line item to cart that matches the doc ref of an existing cart line item",
            tags: {
              fileLocation: "AddLineItemHelper",
              featureFunction: "buildLineItemShape"
            },
            fingerprint: ["add-to-cart-duplicate-line-item"]
          });
        }
      });
      let newCartId = cartId;
      if (!newCartId) {
        const newCart = yield createCartMutation.mutateAsync();
        newCartId = newCart.id;
      }
      const _a = payload,
        {
          dataLayer
        } = _a,
        requestBody = __objRest(_a, ["dataLayer"]);
      const {
        data
      } = yield ShoppingCartHttpClient_default.addLineItem(newCartId, requestBody);
      return data;
    }),
    retry: 1,
    onSuccess: (newCart, payload) => {
      setCartData(newCart);
      if (typeof onSuccess === "function") {
        onSuccess(newCart, mutationKey);
      }
      if (!payload.dataLayer) {
        return;
      }
      addDataLayerEntry("add_to_cart", __spreadValues({
        items: [{
          item_id: payload.dataLayer.productPage.parentProduct.key,
          item_name: payload.dataLayer.productPage.parentProduct.productName,
          variant_id: payload.dataLayer.productPage.variant.sku,
          variant_name: payload.dataLayer.productPage.productNameOriginal || payload.dataLayer.productPage.productName,
          contentfulId: payload.dataLayer.productPage.contentful_id,
          price: Number((payload.dataLayer.price.centAmount / 100).toFixed(2)),
          currency: payload.dataLayer.price.currencyCode,
          item_list_name: payload.dataLayer.item_list_name
        }],
        cartId,
        lineItemIds: newCart.lineItems.map(lineItem => lineItem.id)
      }, payload.dataLayer.printQtemplateId && {
        printQtemplate_id: payload.dataLayer.printQtemplateId
      }));
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/views/CartView.tsx
import { Alert as Alert5, Button as Button7, Container, Panel as Panel7 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage23, useIntl as useIntl9 } from "react-intl";
import { EntityHelper as EntityHelper7 } from "@printdeal/ecommerce-helpers";
import { useAuthentication as useAuthentication8 } from "@printdeal/authentication";
import { useContext as useContext9, useEffect as useEffect15 } from "react";
import { addDataLayerEntry as addDataLayerEntry7 } from "@printdeal/data-layer-manager";
import { StoreToggle as StoreToggle2 } from "@printdeal/feature-management/react";
import { usePrefetchAddresses } from "@printdeal/address-frontend";

// src/library/components/cart/CartQuery.tsx
import { FormattedMessage as FormattedMessage3, useIntl as useIntl2 } from "react-intl";
import { Heading as Heading2, Panel, Spinner } from "@printdeal/ui-library";
import { useAuthentication } from "@printdeal/authentication";
import { EntityHelper } from "@printdeal/ecommerce-helpers";

// src/library/queries/cart/useGetCartQuery.ts
import { useQuery } from "@tanstack/react-query";
import { useEffect as useEffect2 } from "react";
function useGetCartQuery() {
  let {
    enabled
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const {
    cartId,
    setCartData
  } = useCart();
  const queryKey = "getCart" /* getCart */;
  const getCartQuery = useQuery({
    queryKey: [queryKey, cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get cart without a cart id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.getCart(cartId);
      return data;
    }),
    retry: false,
    enabled
  });
  useEffect2(() => {
    if (getCartQuery.status === "success") {
      setCartData(getCartQuery.data);
    }
  }, [getCartQuery.data, getCartQuery.status, setCartData]);
  return getCartQuery;
}

// src/library/components/cart/error-handling/CartErrorNotifications.tsx
import { defineMessages, useIntl } from "react-intl";
import { useEffect as useEffect4 } from "react";

// src/library/hooks/error/useError.ts
import { useContext as useContext2 } from "react";
function useError() {
  const cartContext = useContext2(CartContext_default);
  return cartContext;
}

// src/library/components/design-system/error-handling/ErrorAlert.tsx
import { FormattedMessage as FormattedMessage2 } from "react-intl";
import useDeepCompareEffect from "use-deep-compare-effect";
import { ErrorManagement as ErrorManagement2 } from "@printdeal/error-management/react";
import { Alert, Collapsible } from "@printdeal/ui-library";

// src/library/components/design-system/scrolling/ScrollIntoView.tsx
import { useEffect as useEffect3, useRef } from "react";
import { jsx } from "react/jsx-runtime";
var ScrollIntoView = _ref4 => {
  let {
    children,
    scrollIntoView = true,
    scrollIntoViewTrigger,
    scrollIntoViewOptions = {
      behavior: "smooth",
      block: "nearest",
      inline: "nearest"
    },
    onUnmount
  } = _ref4;
  const ref = useRef(null);
  useEffect3(() => {
    var _a;
    if (scrollIntoView && typeof ((_a = ref.current) == null ? void 0 : _a.scrollIntoView) === "function") {
      ref.current.scrollIntoView(scrollIntoViewOptions);
    }
  }, [scrollIntoView, scrollIntoViewOptions, scrollIntoViewTrigger]);
  useEffect3(() => () => {
    if (onUnmount) {
      onUnmount();
    }
  }, [onUnmount]);
  return /* @__PURE__ */jsx("div", {
    ref,
    children
  });
};
var ScrollIntoView_default = ScrollIntoView;

// src/library/components/design-system/error-handling/NextStepsForUserAfterError.tsx
import { FormattedMessage } from "react-intl";
import { Button, Heading, LinkAsButton, useCopyToClipboard } from "@printdeal/ui-library";
import { getDebugId } from "@printdeal/error-management/react";
import { Fragment, jsx as jsx2, jsxs } from "react/jsx-runtime";
var NextStepsForUserAfterError = _ref5 => {
  let {
    showDebugId,
    showRetryOption = false
  } = _ref5;
  const [copiedText, copyToClipboard] = useCopyToClipboard();
  const reload = () => window.location.reload();
  const debugId = getDebugId();
  return /* @__PURE__ */jsxs("div", {
    className: "pd:text-sm",
    children: [showRetryOption && /* @__PURE__ */jsxs(Fragment, {
      children: [/* @__PURE__ */jsx2(Heading, {
        as: "span",
        variant: "display",
        size: "3",
        className: "pd:mb-2",
        children: /* @__PURE__ */jsx2(FormattedMessage, {
          id: "general.errorBoundary.v2.option.try_again.header",
          defaultMessage: "Try again"
        })
      }), /* @__PURE__ */jsx2("p", {
        children: /* @__PURE__ */jsx2(FormattedMessage, {
          id: "general.errorBoundary.v2.option.try_again.body",
          defaultMessage: "\n                  If the problem occurred for the first time, you could try again what you were doing on this page,\n                  or return to the homepage:\n                "
        })
      }), /* @__PURE__ */jsx2("div", {
        className: "pd:mt-3 pd:flex pd:flex-wrap pd:gap-3",
        children: /* @__PURE__ */jsx2(Button, {
          type: "button",
          onClick: reload,
          variant: "primary",
          iconBefore: "refresh",
          children: /* @__PURE__ */jsx2(FormattedMessage, {
            id: "general.errorBoundary.v2.option.try_again.button_try_again_on_this_page",
            defaultMessage: "Try again on this page"
          })
        })
      })]
    }), /* @__PURE__ */jsxs("div", {
      className: showRetryOption ? "pd:mt-6" : "",
      children: [/* @__PURE__ */jsx2(Heading, {
        as: "span",
        variant: "display",
        size: "3",
        className: "pd:mb-2",
        children: /* @__PURE__ */jsx2(FormattedMessage, {
          id: "general.errorBoundary.v2.option.contact_customer_care.header",
          defaultMessage: "If the problem keeps occurring"
        })
      }), /* @__PURE__ */jsx2("p", {
        className: "pd:my-1",
        children: /* @__PURE__ */jsx2(FormattedMessage, {
          id: "general.errorBoundary.v2.option.contact_customer_care.body",
          defaultMessage: "Contact our customer care service, via phone or e-mail:"
        })
      }), showDebugId && /* @__PURE__ */jsxs("div", {
        className: "pd:mt-6 pd:flex pd:flex-col pd:gap-2",
        children: [/* @__PURE__ */jsx2(FormattedMessage, {
          id: "general.errorBoundary.debug.contact_customer_care.body",
          defaultMessage: "To serve you well, we ask you to pass this unique error code to the customer service:"
        }), /* @__PURE__ */jsx2(LinkAsButton, {
          onClick: () => copyToClipboard(debugId),
          variant: "secondary",
          iconAfter: copiedText ? "check" : "copy",
          children: debugId
        })]
      })]
    })]
  });
};
var NextStepsForUserAfterError_default = NextStepsForUserAfterError;

// src/library/components/design-system/error-handling/ErrorAlert.tsx
import { jsx as jsx3, jsxs as jsxs2 } from "react/jsx-runtime";
var ErrorAlert = _ref6 => {
  let {
    children,
    scrollIntoView = true,
    scrollIntoViewTrigger,
    className,
    exception
  } = _ref6;
  useDeepCompareEffect(() => {
    if (exception) {
      if (Array.isArray(exception)) {
        exception.forEach(error => {
          ErrorManagement2.exception(error);
        });
      } else {
        ErrorManagement2.exception(exception);
      }
    }
  }, [
  // Use {} as fallback value so that useDeepCompareEffect will not crash on a null value.
  exception || {}]);
  return /* @__PURE__ */jsxs2(ScrollIntoView_default, {
    scrollIntoView,
    scrollIntoViewTrigger,
    children: [/* @__PURE__ */jsx3(Alert, {
      variant: "error",
      className: "".concat(className, " pd:mb-3"),
      children: children || /* @__PURE__ */jsx3(FormattedMessage2, {
        id: "checkout.generic.error",
        defaultMessage: "An error occurred."
      })
    }), /* @__PURE__ */jsxs2(Collapsible, {
      id: "customer-care-dropdown-on-error",
      className: "pd:text-sm",
      children: [/* @__PURE__ */jsx3(Collapsible.Header, {
        title: /* @__PURE__ */jsx3(FormattedMessage2, {
          id: "general.errorHandling.contactIfProblemPersists",
          defaultMessage: "Please contact us if the problem persists"
        }),
        className: "pd:p-3 pd:text-left pd:text-md"
      }), /* @__PURE__ */jsx3(Collapsible.Panel, {
        className: "pd:p-3",
        children: /* @__PURE__ */jsx3(NextStepsForUserAfterError_default, {
          showDebugId: Boolean(exception)
        })
      })]
    })]
  });
};
var ErrorAlert_default = ErrorAlert;

// src/library/components/cart/error-handling/CartErrorNotifications.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var errorMessages = defineMessages({
  ["removeLineItem" /* removeLineItem */]: {
    id: "checkout.errorMessage.errorWhileRemovingLineItem",
    defaultMessage: "Something went wrong when trying to remove the product."
  },
  ["deleteCart" /* deleteCart */]: {
    id: "checkout.errorMessage.errorWhileDeletingCart",
    defaultMessage: "Something went wrong when trying to delete the cart."
  },
  ["addCoupon" /* addCoupon */]: {
    id: "checkout.errorMessage.errorWhileAddingCoupon",
    defaultMessage: "Something went wrong when trying to add the coupon to the cart."
  },
  ["removeCoupon" /* removeCoupon */]: {
    id: "checkout.errorMessage.errorWhileRemovingCoupon",
    defaultMessage: "Something went wrong when trying to remove the coupon to the cart."
  },
  ["addLineItem" /* addLineItem */]: {
    id: "checkout.errorMessage.errorWhileAddingLineItem",
    defaultMessage: "Something went wrong when trying to add the product to the cart."
  },
  ["updateLineItem" /* updateLineItem */]: {
    id: "checkout.errorMessage.errorWhileUpdatingLineItem",
    defaultMessage: "Something went wrong when trying to update the line item."
  },
  ["createCart" /* createCart */]: {
    id: "checkout.errorMessage.errorWhileCreatingCart",
    defaultMessage: "Something went wrong when trying to create the cart."
  },
  ["recalculateCart" /* recalculateCart */]: {
    id: "checkout.errorMessage.errorWhileRecalculatingCart",
    defaultMessage: "Something went wrong when trying to recalculate the cart."
  },
  ["duplicateLineItem" /* duplicateLineItem */]: {
    id: "checkout.errorMessage.errorWhileDuplicatingLineItem",
    defaultMessage: "Something went wrong when trying to duplicate the product."
  },
  ["getCart" /* getCart */]: {
    id: "checkout.errorMessage.errorWhileGettingCart",
    defaultMessage: "Something went wrong when trying to get the cart."
  },
  ["addQuoteToCart" /* addQuoteToCart */]: {
    id: "checkout.errorMessage.errorWhileAddingQuoteToCart",
    defaultMessage: "Something went wrong when trying to add the quote to the cart."
  },
  ["setPurchaseorderNumber" /* setPurchaseorderNumber */]: {
    id: "checkout.errorMessage.errorSetPurchaseOrderNumber",
    defaultMessage: "Something went wrong when trying to set or to update the purchase order number to the cart."
  },
  ["setReferenceLabel" /* setReferenceLabel */]: {
    id: "checkout.errorMessage.errorSetReferenceLabel",
    defaultMessage: "Something went wrong when trying to set or to update the reference label to the cart."
  },
  ["reOrderLineItems" /* reOrderLineItems */]: {
    id: "checkout.errorMessage.errorWhileReOrderingLineItems",
    defaultMessage: "Something went wrong when trying to re-order the line items."
  },
  ["setPaymentMethod" /* setPaymentMethod */]: {
    id: "checkout.errorMessage.errorWhileSettingPaymentMethod",
    defaultMessage: "Something went wrong when trying to set the payment method."
  },
  ["getShippingOptions" /* getShippingOptions */]: {
    id: "checkout.errorMessage.errorWhileGettingShippingOptions",
    defaultMessage: "Something went wrong when trying to get the shipping options."
  },
  ["placeOrder" /* placeOrder */]: {
    id: "checkout.errorMessage.errorWhilePlacingOrder",
    defaultMessage: "Something went wrong when trying to place the order."
  },
  ["editLineItem" /* editLineItem */]: {
    id: "checkout.errorMessage.errorWhileEditingLineItem",
    defaultMessage: "Something went wrong when trying to edit the line item."
  },
  ["changeDeliveryOption" /* changeDeliveryOption */]: {
    id: "checkout.errorMessage.errorWhileChangingDeliveryOption",
    defaultMessage: "Something went wrong when trying to change the delivery option."
  },
  ["setPickupPoint" /* setPickupPoint */]: {
    id: "checkout.errorMessage.errorWhileSettingPickupPoint",
    defaultMessage: "Something went wrong when trying to set the pickup point."
  },
  ["setShippingAddress" /* setShippingAddress */]: {
    id: "checkout.errorMessage.errorWhileSettingShippingAddress",
    defaultMessage: "Something went wrong when trying to set the shipping address."
  },
  ["setSplitShipment" /* setSplitShipment */]: {
    id: "checkout.errorMessage.errorWhileSettingSplitShipment",
    defaultMessage: "Something went wrong when trying to set the split shipment."
  },
  ["setBillingAddress" /* setBillingAddress */]: {
    id: "checkout.errorMessage.errorWhileSettingBillingAddress",
    defaultMessage: "Something went wrong when trying to set the billing address."
  }
});
var CartErrorNotifications = _ref7 => {
  let {
    fileLocation
  } = _ref7;
  const intl = useIntl();
  const {
    errors: errorsMap,
    removeAllErrors
  } = useError();
  const errors = Array.from(errorsMap, _ref8 => {
    let [key, value] = _ref8;
    return {
      key,
      value
    };
  });
  useEffect4(() => () => {
    if (errors.length > 0) {
      removeAllErrors();
    }
  }, [errors.length, removeAllErrors]);
  return errors.length > 0 && /* @__PURE__ */jsx4(ErrorAlert_default, {
    className: "pd:mb-4",
    exception: errors.map(errorObject => ({
      exception: errorObject.value.error,
      tags: {
        fileLocation,
        featureFunction: errorObject.key
      },
      fingerprint: ["".concat(fileLocation, "-").concat(errorObject.key.toLowerCase(), "-error}")]
    })),
    children: errors.map(errorObject => /* @__PURE__ */jsx4("div", {
      children: intl.formatMessage(errorMessages[errorObject.key])
    }))
  });
};
var CartErrorNotifications_default = CartErrorNotifications;

// src/library/components/cart/CartQuery.tsx
import { jsx as jsx5, jsxs as jsxs3 } from "react/jsx-runtime";
var CartQuery = _ref9 => {
  let {
    children
  } = _ref9;
  const intl = useIntl2();
  const cartQuery = useGetCartQuery();
  const {
    isUserLoggedIn
  } = useAuthentication();
  const loadingMessage = intl.formatMessage({
    id: "checkout.spinnerLabel.loadingCart",
    defaultMessage: "Loading your cart"
  });
  if (cartQuery.isLoading) {
    return /* @__PURE__ */jsx5("div", {
      className: "pd:flex pd:justify-center",
      children: /* @__PURE__ */jsxs3("div", {
        className: "pd:flex pd:flex-col pd:items-center pd:py-32",
        children: [/* @__PURE__ */jsx5(Spinner, {
          size: "lg",
          screenReaderLabel: loadingMessage
        }), /* @__PURE__ */jsx5(Heading2, {
          as: "h3",
          className: "pd:mt-4",
          children: loadingMessage
        })]
      })
    });
  }
  if (!cartQuery.data || EntityHelper.getMainLineItems(cartQuery.data).length === 0) {
    return /* @__PURE__ */jsx5(Panel, {
      children: isUserLoggedIn ? /* @__PURE__ */jsx5(FormattedMessage3, {
        id: "checkout.emptyCart",
        defaultMessage: "Your shopping cart is empty."
      }) : /* @__PURE__ */jsx5(FormattedMessage3, {
        id: "checkout.emptyCart.notLoggedIn",
        defaultMessage: "Your shopping cart is empty. Did you recently add products to your cart? Log in to view them."
      })
    });
  }
  if (cartQuery.isError) {
    return /* @__PURE__ */jsx5(ErrorAlert_default, {
      exception: {
        exception: cartQuery.error,
        tags: {
          fileLocation: "CartQuery.tsx",
          featureFunction: "cartQuery"
        },
        fingerprint: ["checkout-frontend", "cart-query"]
      },
      children: /* @__PURE__ */jsx5(FormattedMessage3, __spreadValues({}, errorMessages.getCart))
    });
  }
  return /* @__PURE__ */jsx5("div", {
    children: children(cartQuery.data)
  });
};
var CartQuery_default = CartQuery;

// src/library/components/design-system/checkout/CheckoutSummary.tsx
import { Brand, Link, Panel as Panel2, Heading as Heading3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage5, useIntl as useIntl3 } from "react-intl";
import { useContext as useContext3 } from "react";
import { StoreToggle } from "@printdeal/feature-management/react";

// src/library/components/design-system/money/Money.tsx
import { FormattedNumber } from "react-intl";
import { jsx as jsx6 } from "react/jsx-runtime";
var Money = _a => {
  var _b = _a,
    {
      value,
      currency = "EUR",
      style = "currency"
    } = _b,
    rest = __objRest(_b, ["value", "currency", "style"]);
  return /* @__PURE__ */jsx6(FormattedNumber, __spreadValues({
    value: value / 100,
    currency,
    style,
    currencyDisplay: "symbol"
  }, rest));
};
var Money_default = Money;

// src/library/components/context-providers/checkout-view/CheckoutViewContext.ts
import { useLocation } from "@gatsbyjs/reach-router";
import { createContext as createContext2 } from "react";
var defaultSystemPage = {
  page: "",
  path: "",
  title: ""
};
var defaultValue2 = {
  navigate: (path, options) => __async(void 0, null, function* () {
    console.warn("CheckoutViewContext.navigate() not implemented. More details:\n".concat(JSON.stringify({
      path,
      options
    }, null, 2)), {
      path,
      options
    });
    yield Promise.resolve();
  }),
  useLocation: () => useLocation(),
  paths: {
    cartPage: defaultSystemPage,
    deliveryPage: defaultSystemPage,
    paymentMethodPage: defaultSystemPage,
    thanksForOrderPage: defaultSystemPage,
    accountDashboardPage: defaultSystemPage,
    loginPage: defaultSystemPage
  },
  location: void 0,
  kiyohScore: void 0
};
var CheckoutViewContext = createContext2(defaultValue2);
var CheckoutViewContext_default = CheckoutViewContext;

// src/library/components/design-system/checkout/DiscountSummary.tsx
import { FormattedMessage as FormattedMessage4 } from "react-intl";
import { jsx as jsx7, jsxs as jsxs4 } from "react/jsx-runtime";
var DiscountSummary = _ref10 => {
  let {
    entityTotal
  } = _ref10;
  var _a, _b, _c, _d, _e, _f;
  return /* @__PURE__ */jsxs4("div", {
    className: "pd:flex pd:flex-col pd:gap-2",
    children: [((_a = entityTotal == null ? void 0 : entityTotal.discounts) == null ? void 0 : _a.reseller) && /* @__PURE__ */jsxs4("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsx7("span", {
        children: /* @__PURE__ */jsx7(FormattedMessage4, {
          id: "discountPlatformDiscount.reseller",
          defaultMessage: "Reseller Discount"
        })
      }), /* @__PURE__ */jsx7(Money_default, {
        value: -entityTotal.discounts.reseller.totalNet.centAmount,
        currency: entityTotal.discounts.reseller.totalNet.currencyCode
      })]
    }, "reseller-discount"), ((_c = (_b = entityTotal == null ? void 0 : entityTotal.discounts) == null ? void 0 : _b.product) == null ? void 0 : _c.totalNet.centAmount) && entityTotal.discounts.product.totalNet.centAmount > 0 && /* @__PURE__ */jsxs4("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsx7("span", {
        children: /* @__PURE__ */jsx7(FormattedMessage4, {
          id: "discountPlatformDiscount.product",
          defaultMessage: "Product Discount"
        })
      }), /* @__PURE__ */jsx7(Money_default, {
        value: -entityTotal.discounts.product.totalNet.centAmount,
        currency: entityTotal.discounts.product.totalNet.currencyCode
      })]
    }, "product-discount"), ((_e = (_d = entityTotal == null ? void 0 : entityTotal.discounts) == null ? void 0 : _d.unCategorized) == null ? void 0 : _e.totalNet.centAmount) && entityTotal.discounts.unCategorized.totalNet.centAmount > 0 && /* @__PURE__ */jsxs4("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsx7("span", {
        children: /* @__PURE__ */jsx7(FormattedMessage4, {
          id: "discountPlatformDiscount.remainingDiscount",
          defaultMessage: "Discount"
        })
      }), /* @__PURE__ */jsx7(Money_default, {
        value: -entityTotal.discounts.unCategorized.totalNet.centAmount,
        currency: entityTotal.discounts.unCategorized.totalNet.currencyCode
      })]
    }, "remaining-discount"), ((_f = entityTotal == null ? void 0 : entityTotal.customerDiscount) == null ? void 0 : _f.totalNet.centAmount) && entityTotal.customerDiscount.totalNet.centAmount < 0 && /* @__PURE__ */jsxs4("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs4("span", {
        children: [/* @__PURE__ */jsx7(FormattedMessage4, {
          id: "checkout.customerDiscountPrice",
          defaultMessage: "Customer Discount"
        }), ":"]
      }), /* @__PURE__ */jsx7(Money_default, {
        value: entityTotal.customerDiscount.totalNet.centAmount,
        currency: entityTotal.customerDiscount.totalNet.currencyCode
      })]
    }, "customer-discount"), (entityTotal == null ? void 0 : entityTotal.couponCodes) && entityTotal.couponCodes.length > 0 && entityTotal.couponCodes.map(couponCode => /* @__PURE__ */jsxs4("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs4("span", {
        children: [/* @__PURE__ */jsx7(FormattedMessage4, {
          id: "checkout.couponCodeLabel",
          defaultMessage: "Coupon code"
        }), " ", "(", couponCode.code, "):"]
      }), /* @__PURE__ */jsx7(Money_default, {
        value: -couponCode.centAmount,
        currency: couponCode.currencyCode
      })]
    }, "coupon-".concat(couponCode.code)))]
  });
};
var DiscountSummary_default = DiscountSummary;

// src/library/hooks/calculations/useEntityTotals.ts
import { useEffect as useEffect5, useState as useState2 } from "react";

// src/library/helpers/Pricing.ts
import { EntityHelper as EntityHelper2 } from "@printdeal/ecommerce-helpers";
var isGroupedLineItem = lineItem => {
  var _a, _b, _c;
  if (((_a = lineItem.custom) == null ? void 0 : _a.fields.groupId) !== void 0) {
    return true;
  }
  if (((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup) !== void 0) {
    return true;
  }
  return ((_c = lineItem.custom) == null ? void 0 : _c.fields.reviewGroup) !== void 0;
};
var getMultipleDesignsGroupLineItems = _ref11 => {
  let {
    multipleDesignsGroup,
    cartOrOrder
  } = _ref11;
  return cartOrOrder.lineItems.filter(lineItem => {
    var _a;
    return ((_a = lineItem.custom) == null ? void 0 : _a.fields.multipleDesignsGroup) === multipleDesignsGroup;
  });
};
var isLineItemCancelled = lineItem => {
  var _a;
  const [state] = lineItem.state;
  return Boolean(((_a = state == null ? void 0 : state.state.obj) == null ? void 0 : _a.key) === "Cancelled");
};
var getLineItemById = _ref12 => {
  let {
    lineItemId,
    cartOrOrder,
    includeCancelledLineItem = true
  } = _ref12;
  const foundLineItem = cartOrOrder.lineItems.find(lineItem => lineItem.id === lineItemId);
  if (!foundLineItem) {
    return foundLineItem;
  }
  if (includeCancelledLineItem) {
    return foundLineItem;
  }
  return isLineItemCancelled(foundLineItem) ? void 0 : foundLineItem;
};
var getGroupedLineItems = _ref13 => {
  let {
    lineItemId,
    cartOrOrder,
    includeCancelledLineItem = true
  } = _ref13;
  var _a, _b, _c;
  const lineItems = [];
  const firstLineItem = getLineItemById({
    lineItemId,
    cartOrOrder,
    includeCancelledLineItem
  });
  if (!firstLineItem) {
    throw Error("Line item ".concat(lineItemId, " not found in cart or order ").concat(cartOrOrder.id));
  }
  if (!isGroupedLineItem(firstLineItem)) {
    return lineItems;
  }
  const groupId = (_a = firstLineItem.custom) == null ? void 0 : _a.fields.groupId;
  const reviewGroup = (_b = firstLineItem.custom) == null ? void 0 : _b.fields.reviewGroup;
  const multipleDesignsGroup = (_c = firstLineItem.custom) == null ? void 0 : _c.fields.multipleDesignsGroup;
  if (groupId) {
    return cartOrOrder.lineItems.filter(lineItem => {
      var _a2;
      return ((_a2 = lineItem.custom) == null ? void 0 : _a2.fields.groupId) === groupId;
    });
  }
  if (multipleDesignsGroup) {
    return getMultipleDesignsGroupLineItems({
      multipleDesignsGroup,
      cartOrOrder
    });
  }
  const reviewGroupLineItems = cartOrOrder.lineItems.filter(lineItem => {
    var _a2;
    return ((_a2 = lineItem.custom) == null ? void 0 : _a2.fields.reviewGroup) === reviewGroup;
  });
  if (includeCancelledLineItem) {
    return reviewGroupLineItems;
  }
  return reviewGroupLineItems.filter(lineItem => !isLineItemCancelled(lineItem));
};
var getCustomLineItemsOfType = _ref14 => {
  let {
    cartOrOrder,
    customLineItemType,
    lineItemIds = []
  } = _ref14;
  const foundCustomLineItems = cartOrOrder.customLineItems.filter(customLineItem => {
    var _a;
    return ((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemType) === customLineItemType;
  }).filter(customLineItem => {
    var _a;
    if (!lineItemIds.length) {
      return true;
    }
    return ((_a = customLineItem.custom) == null ? void 0 : _a.fields.lineItemReference) && lineItemIds.includes(customLineItem.custom.fields.lineItemReference);
  });
  return foundCustomLineItems.filter(_ref15 => {
    let {
      state
    } = _ref15;
    var _a;
    return state.length === 0 || ((_a = state[0].state.obj) == null ? void 0 : _a.key) !== "Cancelled";
  });
};
var calculateTaxPortions = lineItems => {
  const taxPortions = [];
  lineItems.filter(_ref16 => {
    let {
      taxedPrice
    } = _ref16;
    return (taxedPrice == null ? void 0 : taxedPrice.taxPortions) !== void 0;
  }).forEach(lineItem => {
    lineItem.taxedPrice.taxPortions.forEach(lineItemTaxPortion => {
      const foundPortion = taxPortions.find(portion => portion.rate === lineItemTaxPortion.rate);
      if (!foundPortion) {
        taxPortions.push(lineItemTaxPortion);
        return;
      }
      const index = taxPortions.indexOf(foundPortion);
      if (index === -1 || !taxPortions[index]) {
        return;
      }
      const currentPortion = taxPortions[index];
      taxPortions[index] = __spreadProps(__spreadValues({}, currentPortion), {
        amount: __spreadProps(__spreadValues({}, currentPortion.amount), {
          centAmount: currentPortion.amount.centAmount + lineItemTaxPortion.amount.centAmount
        })
      });
    });
  });
  return taxPortions;
};
var getBasePrice = _ref17 => {
  let {
    lineItems
  } = _ref17;
  const {
    currencyCode
  } = lineItems[0].taxedPrice.totalGross;
  const totalGross = lineItems.reduce((total, _ref18) => {
    let {
      taxRate,
      custom: lineItemCustomField,
      taxedPrice: lineItemTaxedPrice
    } = _ref18;
    var _a;
    const centAmount = (_a = lineItemCustomField == null ? void 0 : lineItemCustomField.fields.baseProductPriceValue) == null ? void 0 : _a.centAmount;
    const gross = centAmount ? Math.round(centAmount * (1 + taxRate.amount)) : lineItemTaxedPrice.totalGross.centAmount;
    return total + gross;
  }, 0);
  const totalTax = lineItems.reduce((total, _ref19) => {
    let {
      taxRate,
      taxedPrice: lineItemTaxedPrice,
      custom: lineItemCustomField
    } = _ref19;
    var _a, _b;
    const centamount = (_a = lineItemCustomField == null ? void 0 : lineItemCustomField.fields.baseProductPriceValue) == null ? void 0 : _a.centAmount;
    let tax = 0;
    if ((_b = lineItemTaxedPrice.totalTax) == null ? void 0 : _b.centAmount) {
      tax = centamount ? Math.round(centamount * taxRate.amount) : lineItemTaxedPrice.totalTax.centAmount;
    } else {
      tax = Math.round(lineItemTaxedPrice.totalGross.centAmount - lineItemTaxedPrice.totalNet.centAmount);
    }
    return total + tax;
  }, 0);
  return {
    totalNet: {
      centAmount: totalGross - totalTax,
      currencyCode
    },
    totalGross: {
      centAmount: totalGross,
      currencyCode
    },
    totalTax: {
      centAmount: totalTax,
      currencyCode
    },
    taxPortions: calculateTaxPortions(lineItems)
  };
};
var getPrice = _ref20 => {
  let {
    lineItems
  } = _ref20;
  const {
    currencyCode
  } = lineItems[0].taxedPrice.totalGross;
  return {
    totalNet: {
      centAmount: lineItems.reduce((total, lineItem) => total + lineItem.taxedPrice.totalNet.centAmount, 0),
      currencyCode
    },
    totalGross: {
      centAmount: lineItems.reduce((total, lineItem) => total + lineItem.taxedPrice.totalGross.centAmount, 0),
      currencyCode
    },
    totalTax: {
      centAmount: lineItems.reduce((total, lineItem) => {
        var _a, _b;
        if ((_b = (_a = lineItem.taxedPrice) == null ? void 0 : _a.totalTax) == null ? void 0 : _b.centAmount) {
          return total + lineItem.taxedPrice.totalTax.centAmount;
        }
        const diff = Math.round(lineItem.taxedPrice.totalGross.centAmount - lineItem.taxedPrice.totalNet.centAmount);
        return total + diff;
      }, 0),
      currencyCode
    },
    taxPortions: calculateTaxPortions(lineItems)
  };
};
var getDiscounts = _ref21 => {
  let {
    lineItems,
    discountTags = []
  } = _ref21;
  const {
    currencyCode
  } = lineItems[0].taxedPrice.totalGross;
  const {
    amount: taxRate
  } = lineItems[0].taxRate;
  const discounts = {};
  discountTags.push("unCategorized");
  let remainingDiscount = 0;
  lineItems.forEach(lineItem => {
    var _a, _b, _c, _d, _e, _f, _g;
    if (!((_a = lineItem.custom) == null ? void 0 : _a.fields.eCommerceDiscounts)) {
      const discountedProductPriceValue = (_d = (_c = (_b = lineItem.custom) == null ? void 0 : _b.fields.discountedProductPriceValue) == null ? void 0 : _c.centAmount) != null ? _d : 0;
      const baseProductPriceValue = (_g = (_f = (_e = lineItem.custom) == null ? void 0 : _e.fields.baseProductPriceValue) == null ? void 0 : _f.centAmount) != null ? _g : 0;
      const diff = discountedProductPriceValue - baseProductPriceValue;
      if (diff === 0) {
        return;
      }
      remainingDiscount += Math.round(diff / (1 + taxRate));
      return;
    }
    const eCommerceDiscounts = JSON.parse(lineItem.custom.fields.eCommerceDiscounts);
    eCommerceDiscounts.forEach(_ref22 => {
      let {
        amount: {
          centAmount
        },
        tags: [firstTag] = []
      } = _ref22;
      const tax = Math.round(centAmount * taxRate);
      if (firstTag && discountTags.includes(firstTag)) {
        if (!discounts[firstTag]) {
          discounts[firstTag] = {
            tag: firstTag,
            totalGross: {
              centAmount: 0,
              currencyCode
            },
            totalNet: {
              centAmount: 0,
              currencyCode
            },
            totalTax: {
              centAmount: 0,
              currencyCode
            },
            taxPortions: []
          };
        }
        const discount = discounts[firstTag];
        discount.totalNet.centAmount += centAmount;
        discount.totalTax.centAmount += tax;
        discount.totalGross.centAmount += centAmount + tax;
      } else {
        remainingDiscount += centAmount;
      }
    });
  });
  if (remainingDiscount > 0) {
    discounts.unCategorized = {
      tag: "unCategorized",
      totalGross: {
        centAmount: 0,
        currencyCode
      },
      totalNet: {
        centAmount: 0,
        currencyCode
      },
      totalTax: {
        centAmount: 0,
        currencyCode
      },
      taxPortions: []
    };
    discounts.unCategorized.totalNet.centAmount += remainingDiscount;
    discounts.unCategorized.totalTax.centAmount += Math.round(remainingDiscount * taxRate);
    discounts.unCategorized.totalGross.centAmount += Math.round(remainingDiscount * (1 + taxRate));
  }
  return Object.keys(discounts).length ? discounts : void 0;
};
var calculateProductTotals = _ref23 => {
  let {
    lineItems,
    discountTags = []
  } = _ref23;
  const [lineItem] = lineItems;
  const price = getPrice({
    lineItems
  });
  const basePrice = getBasePrice({
    lineItems
  });
  return {
    id: lineItem.id,
    sku: "productKey" in lineItem ? lineItem.productKey : void 0,
    taxRate: {
      amount: lineItem.taxRate.amount,
      country: lineItem.taxRate.country
    },
    basePrice,
    price,
    discounts: getDiscounts({
      lineItems,
      discountTags
    }),
    totalDiscount: {
      totalTax: {
        centAmount: basePrice.totalTax.centAmount - price.totalTax.centAmount,
        currencyCode: basePrice.totalTax.currencyCode
      },
      totalNet: {
        centAmount: basePrice.totalNet.centAmount - price.totalNet.centAmount,
        currencyCode: basePrice.totalNet.currencyCode
      },
      totalGross: {
        centAmount: basePrice.totalGross.centAmount - price.totalGross.centAmount,
        currencyCode: basePrice.totalGross.currencyCode
      }
    },
    taxPortions: calculateTaxPortions(lineItems),
    quantity: lineItems.reduce((total, current) => total + current.quantity, 0)
  };
};
var calculateCustomLineItemsOfType = _ref24 => {
  let {
    lineItems,
    cartOrOrder,
    discountTags,
    customLineItemType
  } = _ref24;
  const customLineItems = getCustomLineItemsOfType({
    cartOrOrder,
    lineItemIds: lineItems.map(_ref25 => {
      let {
        id
      } = _ref25;
      return id;
    }),
    customLineItemType
  });
  if (!customLineItems.length) {
    return void 0;
  }
  const [customLineItem] = customLineItems;
  return {
    taxRate: customLineItem.taxRate,
    basePrice: getBasePrice({
      lineItems: customLineItems
    }),
    price: getPrice({
      lineItems: customLineItems
    }),
    discounts: getDiscounts({
      lineItems: customLineItems,
      discountTags
    }),
    quantity: customLineItem.quantity,
    taxPortions: customLineItem.taxedPrice.taxPortions
  };
};
var calculateCouponTotals = _ref26 => {
  let {
    cartOrOrder: {
      discountCodes,
      lineItems
    }
  } = _ref26;
  return discountCodes == null ? void 0 : discountCodes.filter(code => code.discountCode.obj).map(discountCode => {
    var _a, _b;
    const code = (_a = discountCode.discountCode.obj) == null ? void 0 : _a.code;
    const discountIds = (_b = discountCode.discountCode.obj) == null ? void 0 : _b.cartDiscounts.map(_ref27 => {
      let {
        id
      } = _ref27;
      return id;
    });
    const totalDiscount = lineItems.filter(lineItem => lineItem.discountedPricePerQuantity.some(discountedPricePerQuantity => discountedPricePerQuantity.discountedPrice.includedDiscounts.some(includedDiscount => discountIds == null ? void 0 : discountIds.includes(includedDiscount.discount.id)))).reduce((prevLineItem, lineItem) => {
      const discount = lineItem.discountedPricePerQuantity.reduce((prevDiscountedPricePerQuantity, discountedPricePerQuantity) => {
        const totalDiscountedPricePerQuantity = discountedPricePerQuantity.discountedPrice.includedDiscounts.reduce((prevIncludedDiscount, includedDiscounts) => {
          if (!(discountIds == null ? void 0 : discountIds.includes(includedDiscounts.discount.id))) {
            return prevIncludedDiscount;
          }
          const {
            preciseAmount
          } = includedDiscounts.discountedAmount;
          return Math.round(preciseAmount * discountedPricePerQuantity.quantity / __pow(10, 5)) + prevIncludedDiscount;
        }, 0);
        return prevDiscountedPricePerQuantity + totalDiscountedPricePerQuantity;
      }, 0);
      return prevLineItem + discount;
    }, 0);
    return {
      centAmount: totalDiscount,
      currencyCode: "EUR",
      code
    };
  }).filter(Boolean);
};
var getLineItemId = lineItem => {
  var _a, _b;
  return (_b = (_a = lineItem.custom) == null ? void 0 : _a.fields.artworkItemId) != null ? _b : lineItem.id;
};
var calculateServiceTotals = _ref28 => {
  let {
    lineItems,
    cartOrOrder,
    discountTags
  } = _ref28;
  return getCustomLineItemsOfType({
    cartOrOrder,
    lineItemIds: lineItems.map(lineItem => getLineItemId(lineItem)),
    customLineItemType: "service"
  }).map(serviceCustomLineItem => {
    var _a, _b;
    return {
      sku: (_a = serviceCustomLineItem.custom) == null ? void 0 : _a.fields.serviceKey,
      taxRate: serviceCustomLineItem.taxRate,
      basePrice: getBasePrice({
        lineItems: [serviceCustomLineItem]
      }),
      price: getPrice({
        lineItems: [serviceCustomLineItem]
      }),
      discounts: getDiscounts({
        lineItems: [serviceCustomLineItem],
        discountTags
      }),
      quantity: serviceCustomLineItem.quantity,
      serviceName: (_b = serviceCustomLineItem.custom) == null ? void 0 : _b.fields.serviceName,
      taxPortions: serviceCustomLineItem.taxedPrice.taxPortions
    };
  });
};
var lineItemPrices = _ref29 => {
  let {
    lineItemId,
    cartOrOrder,
    calculateGroup = true,
    discountTags = []
  } = _ref29;
  let lineItems = [];
  const lineItem = getLineItemById({
    lineItemId,
    cartOrOrder,
    includeCancelledLineItem: false
  });
  if (!lineItem) {
    return {};
  }
  if (calculateGroup && isGroupedLineItem(lineItem)) {
    lineItems = getGroupedLineItems({
      lineItemId,
      cartOrOrder
    });
  } else {
    lineItems.push(lineItem);
  }
  if (!lineItems.length) {
    return {};
  }
  return {
    product: calculateProductTotals({
      lineItems,
      discountTags
    }),
    shipping: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "shipping"
    }),
    services: calculateServiceTotals({
      lineItems,
      cartOrOrder,
      discountTags
    }),
    additionalAddressCosts: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "additional-address-costs"
    }),
    deliveryService: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "deliveryService"
    }),
    courierService: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "courierService"
    }),
    customerDiscount: calculateCustomLineItemsOfType({
      lineItems,
      cartOrOrder,
      discountTags,
      customLineItemType: "customerDiscount"
    })
  };
};
var calculateDiscount = _ref30 => {
  let {
    totalDiscounts,
    discounts
  } = _ref30;
  var _a;
  if (!discounts) {
    return totalDiscounts;
  }
  const sum = (_a = structuredClone(totalDiscounts)) != null ? _a : {};
  Object.keys(discounts).forEach(key => {
    const discount = discounts[key];
    if (!sum[key] && discount) {
      sum[key] = discount;
      return;
    }
    if (sum[key] && discount) {
      sum[key].totalTax.centAmount += discount.totalTax.centAmount;
      sum[key].totalNet.centAmount += discount.totalNet.centAmount;
      sum[key].totalGross.centAmount += discount.totalGross.centAmount;
    }
  });
  return sum;
};
var calculateTotal = _ref31 => {
  let {
    total,
    current,
    calculateTaxedPortions = false
  } = _ref31;
  if (!total) {
    return current;
  }
  const sum = structuredClone(total);
  if (calculateTaxedPortions) {
    current.taxPortions.forEach(taxPortion => {
      const foundPortion = sum.taxPortions.find(sumPortion => sumPortion.rate === taxPortion.rate);
      if (!foundPortion) {
        sum.taxPortions.push(taxPortion);
      } else {
        const index = sum.taxPortions.indexOf(foundPortion);
        sum.taxPortions[index].amount = __spreadProps(__spreadValues({}, sum.taxPortions[index].amount), {
          centAmount: sum.taxPortions[index].amount.centAmount + taxPortion.amount.centAmount
        });
      }
    });
  }
  sum.totalTax.centAmount += current.totalTax.centAmount;
  sum.totalNet.centAmount += current.totalNet.centAmount;
  sum.totalGross.centAmount += current.totalGross.centAmount;
  return sum;
};
var cartOrOrderTotals = _ref32 => {
  let {
    cartOrOrder,
    calculateGroup = true,
    discountTags = [],
    lineItemIds = []
  } = _ref32;
  var _a, _b, _c, _d, _e, _f;
  let givenLineItemIds = lineItemIds;
  if (!lineItemIds.length) {
    givenLineItemIds = EntityHelper2.getMainGroupedLineItems(cartOrOrder).map(lineItem => lineItem.id);
  }
  const totals = {
    product: {
      basePrice: void 0,
      price: void 0
    },
    discounts: void 0,
    shipping: {
      basePrice: void 0,
      price: void 0
    },
    additionalAddressCosts: {
      basePrice: void 0,
      price: void 0,
      quantity: 0
    },
    services: {
      basePrice: void 0,
      price: void 0,
      quantity: 0,
      services: {}
    },
    customerDiscount: void 0,
    deliveryService: {
      basePrice: void 0,
      price: void 0,
      quantity: 0
    },
    courierService: {
      basePrice: void 0,
      price: void 0,
      quantity: 0
    },
    couponCodes: calculateCouponTotals({
      cartOrOrder
    }),
    totalPrice: {
      taxPortions: [],
      totalGross: {
        centAmount: 0,
        currencyCode: (_b = (_a = cartOrOrder.taxedPrice) == null ? void 0 : _a.totalGross.currencyCode) != null ? _b : "EUR"
      },
      totalTax: {
        centAmount: 0,
        currencyCode: (_d = (_c = cartOrOrder.taxedPrice) == null ? void 0 : _c.totalGross.currencyCode) != null ? _d : "EUR"
      },
      totalNet: {
        centAmount: 0,
        currencyCode: (_f = (_e = cartOrOrder.taxedPrice) == null ? void 0 : _e.totalNet.currencyCode) != null ? _f : "EUR"
      }
    }
  };
  const lineItemTotals = givenLineItemIds.map(lineItemId => lineItemPrices({
    lineItemId,
    cartOrOrder,
    discountTags,
    calculateGroup
  }));
  const services = /* @__PURE__ */new Map();
  lineItemTotals.filter(total => Object.keys(total).length > 0).forEach(total => {
    var _a2, _b2, _c2;
    if ((_a2 = total.product) == null ? void 0 : _a2.discounts) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: total.product.discounts
      });
    }
    if ((_b2 = total.product) == null ? void 0 : _b2.basePrice) {
      totals.product.basePrice = calculateTotal({
        total: totals.product.basePrice,
        current: total.product.basePrice
      });
      totals.product.price = calculateTotal({
        total: totals.product.price,
        current: total.product.price
      });
      totals.totalPrice = calculateTotal({
        total: totals.totalPrice,
        current: total.product.price,
        calculateTaxedPortions: true
      });
    }
    if (total.shipping) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: total.shipping.discounts || {}
      });
      totals.shipping.basePrice = calculateTotal({
        total: totals.shipping.basePrice,
        current: total.shipping.basePrice
      });
      totals.shipping.price = calculateTotal({
        total: totals.shipping.price,
        current: total.shipping.price
      });
      totals.totalPrice = calculateTotal({
        total: totals.totalPrice,
        current: total.shipping.price,
        calculateTaxedPortions: true
      });
    }
    if (total.additionalAddressCosts) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: total.additionalAddressCosts.discounts || {}
      });
      totals.additionalAddressCosts.price = calculateTotal({
        total: totals.additionalAddressCosts.price,
        current: total.additionalAddressCosts.price
      });
      totals.additionalAddressCosts.basePrice = calculateTotal({
        total: totals.additionalAddressCosts.basePrice,
        current: total.additionalAddressCosts.basePrice
      });
      totals.additionalAddressCosts.quantity += total.additionalAddressCosts.quantity;
      totals.totalPrice = calculateTotal({
        total: totals.totalPrice,
        current: total.additionalAddressCosts.price,
        calculateTaxedPortions: true
      });
    }
    if (total.customerDiscount) {
      totals.customerDiscount = calculateTotal({
        total: totals.customerDiscount,
        current: total.customerDiscount.price
      });
      totals.totalPrice = calculateTotal({
        total: totals.totalPrice,
        current: total.customerDiscount.price,
        calculateTaxedPortions: true
      });
    }
    if (total.deliveryService) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: total.deliveryService.discounts || {}
      });
      totals.deliveryService.price = calculateTotal({
        total: totals.deliveryService.price,
        current: total.deliveryService.price
      });
      totals.deliveryService.basePrice = calculateTotal({
        total: totals.deliveryService.basePrice,
        current: total.deliveryService.basePrice
      });
      totals.deliveryService.quantity += total.deliveryService.quantity;
      totals.totalPrice = calculateTotal({
        total: totals.totalPrice,
        current: total.deliveryService.price,
        calculateTaxedPortions: true
      });
    }
    if (total.courierService) {
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: total.courierService.discounts || {}
      });
      totals.courierService.price = calculateTotal({
        total: totals.courierService.price,
        current: total.courierService.price
      });
      totals.courierService.basePrice = calculateTotal({
        total: totals.courierService.basePrice,
        current: total.courierService.basePrice
      });
      totals.courierService.quantity += total.courierService.quantity;
      totals.totalPrice = calculateTotal({
        total: totals.totalPrice,
        current: total.courierService.price,
        calculateTaxedPortions: true
      });
    }
    (_c2 = total.services) == null ? void 0 : _c2.forEach(service => {
      if (!services.has(service.sku)) {
        services.set(service.sku, service);
      } else {
        const serviceSet = services.get(service.sku);
        const serviceFromSet = structuredClone(serviceSet);
        const newService = __spreadProps(__spreadValues({}, serviceFromSet), {
          quantity: serviceFromSet.quantity + service.quantity,
          price: calculateTotal({
            total: serviceFromSet.price,
            current: service.price
          }),
          basePrice: calculateTotal({
            total: serviceFromSet.basePrice,
            current: service.basePrice
          })
        });
        services.set(service.sku, newService);
      }
      totals.discounts = calculateDiscount({
        totalDiscounts: totals.discounts,
        discounts: service.discounts || {}
      });
      totals.services.price = calculateTotal({
        total: totals.services.price,
        current: service.price
      });
      totals.services.basePrice = calculateTotal({
        total: totals.services.basePrice,
        current: service.basePrice
      });
      totals.services.quantity += service.quantity;
      totals.services.services = Object.fromEntries(services);
      totals.totalPrice = calculateTotal({
        total: totals.totalPrice,
        current: service.price,
        calculateTaxedPortions: true
      });
    });
  });
  return totals;
};

// src/library/hooks/calculations/useEntityTotals.ts
function useEntityTotals(_ref33) {
  let {
    entity
  } = _ref33;
  const [entityTotal, setEntityTotal] = useState2(void 0);
  const [lineItemsTotal, setLineItemsTotal] = useState2(void 0);
  useEffect5(() => {
    if (entity) {
      setEntityTotal(cartOrOrderTotals({
        cartOrOrder: entity,
        discountTags: ["product", "reseller", "endUser"]
      }));
      const lineTotals = /* @__PURE__ */new Map();
      entity.lineItems.forEach(lineItem => {
        lineTotals.set(lineItem.id, lineItemPrices({
          lineItemId: lineItem.id,
          cartOrOrder: entity,
          discountTags: ["product", "reseller", "endUser"]
        }));
      });
      setLineItemsTotal(lineTotals);
    }
  }, [entity]);
  return {
    entityTotal,
    lineItemsTotal
  };
}

// src/library/components/design-system/checkout/CheckoutSummary.tsx
import { jsx as jsx8, jsxs as jsxs5 } from "react/jsx-runtime";
var CheckoutSummary = _ref34 => {
  let {
    nextStepButton,
    isKiyohEnabled = false
  } = _ref34;
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l, _m, _n, _o, _p;
  const {
    locale
  } = useIntl3();
  const {
    kiyohScore
  } = useContext3(CheckoutViewContext_default);
  const {
    cart
  } = useCart();
  const {
    entityTotal
  } = useEntityTotals({
    entity: cart
  });
  const hasDeliveryCosts = Boolean(((_b = (_a = entityTotal == null ? void 0 : entityTotal.deliveryService.basePrice) == null ? void 0 : _a.totalNet.centAmount) != null ? _b : 0) > 0);
  const hasCourierCosts = Boolean(((_d = (_c = entityTotal == null ? void 0 : entityTotal.courierService.basePrice) == null ? void 0 : _c.totalNet.centAmount) != null ? _d : 0) > 0);
  const last12MonthAverageRating = kiyohScore == null ? void 0 : kiyohScore.last12MonthAverageRating;
  const last12MonthNumberReviews = kiyohScore == null ? void 0 : kiyohScore.last12MonthNumberReviews;
  const reviewUrl = (_f = (_e = kiyohScore == null ? void 0 : kiyohScore.reviewURLs) == null ? void 0 : _e.find(element => element.locale === locale)) == null ? void 0 : _f.reviewUrl;
  return /* @__PURE__ */jsxs5(Panel2, {
    className: "pd:flex pd:flex-col pd:gap-2 pd:p-4 pd:text-sm",
    children: [/* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5("span", {
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.lineItemProductPrice",
          defaultMessage: "Product price"
        }), ":"]
      }), /* @__PURE__ */jsx8(Money_default, {
        value: (_h = (_g = entityTotal == null ? void 0 : entityTotal.product.basePrice) == null ? void 0 : _g.totalNet.centAmount) != null ? _h : 0,
        currency: (_i = entityTotal == null ? void 0 : entityTotal.product.basePrice) == null ? void 0 : _i.totalNet.currencyCode
      })]
    }, "total-price"), ((_j = entityTotal == null ? void 0 : entityTotal.services.basePrice) == null ? void 0 : _j.totalNet.centAmount) !== void 0 && /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5("span", {
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.servicesCosts",
          defaultMessage: "Services costs"
        }), ":"]
      }), /* @__PURE__ */jsx8(Money_default, {
        value: entityTotal.services.basePrice.totalNet.centAmount
      })]
    }, "services-costs"), !hasDeliveryCosts && !hasCourierCosts && /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5("span", {
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.shippingCosts",
          defaultMessage: "Shipping costs"
        }), ":"]
      }), ((_k = entityTotal == null ? void 0 : entityTotal.shipping.basePrice) == null ? void 0 : _k.totalNet.centAmount) === void 0 || entityTotal.shipping.basePrice.totalNet.centAmount === 0 ? /* @__PURE__ */jsx8("span", {
        className: "pd:text-success-600",
        children: /* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.freeShipping",
          defaultMessage: "Free"
        })
      }) : /* @__PURE__ */jsx8(Money_default, {
        value: entityTotal.shipping.basePrice.totalNet.centAmount,
        currency: entityTotal.shipping.basePrice.totalNet.currencyCode
      })]
    }, "shipping-price"), ((_l = entityTotal == null ? void 0 : entityTotal.deliveryService.basePrice) == null ? void 0 : _l.totalNet.centAmount) !== void 0 && /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5("span", {
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.timedDeliveryPrice",
          defaultMessage: "Timed delivery costs"
        }), ":"]
      }), /* @__PURE__ */jsx8(Money_default, {
        value: entityTotal.deliveryService.basePrice.totalNet.centAmount,
        currency: entityTotal.deliveryService.basePrice.totalNet.currencyCode
      })]
    }, "timed-delivery-costs"), ((_m = entityTotal == null ? void 0 : entityTotal.courierService.basePrice) == null ? void 0 : _m.totalNet.centAmount) !== void 0 && /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5("span", {
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.courierServicePrice",
          defaultMessage: "Courier service costs"
        }), ":"]
      }), /* @__PURE__ */jsx8(Money_default, {
        value: entityTotal.courierService.basePrice.totalNet.centAmount,
        currency: entityTotal.courierService.basePrice.totalNet.currencyCode
      })]
    }, "courier-service-costs"), ((_n = entityTotal == null ? void 0 : entityTotal.additionalAddressCosts.basePrice) == null ? void 0 : _n.totalNet.centAmount) !== void 0 && /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5("span", {
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.additionalAddressPrice",
          defaultMessage: "Additional address costs"
        }), ":"]
      }), /* @__PURE__ */jsx8(Money_default, {
        value: entityTotal.additionalAddressCosts.basePrice.totalNet.centAmount,
        currency: entityTotal.additionalAddressCosts.basePrice.totalNet.currencyCode
      })]
    }, "additional-address-costs"), /* @__PURE__ */jsx8(DiscountSummary_default, {
      entityTotal
    }), /* @__PURE__ */jsx8("hr", {}), /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5("span", {
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.subTotalPrice",
          defaultMessage: "Subtotal"
        }), ":"]
      }), /* @__PURE__ */jsx8(Money_default, {
        value: (_o = entityTotal == null ? void 0 : entityTotal.totalPrice.totalNet.centAmount) != null ? _o : 0,
        currency: entityTotal == null ? void 0 : entityTotal.totalPrice.totalNet.currencyCode
      })]
    }, "subtotal-price"), (entityTotal == null ? void 0 : entityTotal.totalPrice.taxPortions) && entityTotal.totalPrice.taxPortions.map(taxPortion => {
      const taxRate = Math.round((taxPortion.rate + Number.EPSILON) * 1e3) / 10;
      return /* @__PURE__ */jsxs5("div", {
        className: "pd:flex pd:justify-between",
        children: [/* @__PURE__ */jsxs5("span", {
          children: [/* @__PURE__ */jsx8(FormattedMessage5, {
            id: "checkout.totalVat",
            defaultMessage: "VAT"
          }), " ", "(", /* @__PURE__ */jsx8(FormattedMessage5, {
            id: "checkout.taxRate",
            defaultMessage: "{taxRate}%",
            values: {
              taxRate
            }
          }), "):"]
        }), /* @__PURE__ */jsx8(Money_default, {
          value: taxPortion.amount.centAmount,
          currency: taxPortion.amount.currencyCode
        })]
      }, "tax-portion-".concat(taxRate));
    }), /* @__PURE__ */jsx8("hr", {}), /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:justify-between",
      children: [/* @__PURE__ */jsxs5(Heading3, {
        as: "span",
        variant: "display",
        size: "2",
        children: [/* @__PURE__ */jsx8(FormattedMessage5, {
          id: "checkout.lineItemTotalPrice",
          defaultMessage: "Total"
        }), ":"]
      }), /* @__PURE__ */jsx8(Heading3, {
        as: "span",
        variant: "display",
        size: "2",
        children: /* @__PURE__ */jsx8(Money_default, {
          value: (_p = entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.centAmount) != null ? _p : 0,
          currency: entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.currencyCode
        })
      })]
    }, "total-final-price"), /* @__PURE__ */jsxs5("div", {
      className: "pd:flex pd:flex-col pd:gap-4",
      children: [nextStepButton, isKiyohEnabled && Boolean(reviewUrl) && Boolean(last12MonthAverageRating) && Boolean(last12MonthNumberReviews) && /* @__PURE__ */jsx8(StoreToggle, {
        id: "drukwerkdeal-nl_printdeal-be",
        children: /* @__PURE__ */jsx8(StoreToggle.Enabled, {
          children: /* @__PURE__ */jsxs5(Link, {
            href: reviewUrl,
            target: "_blank",
            className: "pd:flex pd:justify-center",
            variant: "secondary",
            children: [/* @__PURE__ */jsx8(Brand, {
              brand: "kiyoh",
              className: "pd:inline-block pd:h-5"
            }), /* @__PURE__ */jsxs5("span", {
              className: "pd:inline-block",
              children: [last12MonthAverageRating, " ", "Kiyoh\xA0", /* @__PURE__ */jsx8(FormattedMessage5, {
                id: "checkout.numberOfKiyohReviewsSmall",
                defaultMessage: "{number} reviews",
                values: {
                  number: last12MonthNumberReviews
                }
              })]
            })]
          })
        })
      })]
    })]
  });
};
var CheckoutSummary_default = CheckoutSummary;

// src/library/components/cart/DeleteCartButton.tsx
import { LinkAsButton as LinkAsButton2 } from "@printdeal/ui-library";
import { useMemo } from "react";
import { FormattedMessage as FormattedMessage6 } from "react-intl";

// src/library/queries/cart/useDeleteCartMutation.ts
import { useMutation as useMutation4 } from "@tanstack/react-query";
function useDeleteCartMutation(_ref35) {
  let {
    onError,
    onSuccess
  } = _ref35;
  const {
    locallyRemoveCart
  } = useCart();
  return useMutation4({
    mutationKey: ["deleteCart" /* deleteCart */],
    mutationFn: cartId => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot delete a cart without cartId");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.deleteCart(cartId);
      return data;
    }),
    onError: error => {
      if (typeof onError === "function") {
        onError(error);
      }
    },
    onSuccess: () => {
      locallyRemoveCart();
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    },
    retry: false
  });
}

// src/library/components/cart/DeleteCartButton.tsx
import { jsx as jsx9 } from "react/jsx-runtime";
var DeleteCartButton = _ref36 => {
  let {
    onSuccess,
    onError
  } = _ref36;
  const deleteCartMutation = useDeleteCartMutation({
    onSuccess,
    onError
  });
  const {
    cart,
    cartId
  } = useCart();
  const {
    isCartMutationPending: isCartMutationPending2
  } = useCartVersionMismatchPrevention();
  const shouldDisableMutation = useMemo(() => !cart || !cartId || isCartMutationPending2 || deleteCartMutation.isPending, [cart, cartId, isCartMutationPending2, deleteCartMutation.isPending]);
  const handleOnClick = event => {
    event.preventDefault();
    if (shouldDisableMutation) {
      return;
    }
    deleteCartMutation.mutate(cartId);
  };
  return /* @__PURE__ */jsx9(LinkAsButton2, {
    iconBefore: deleteCartMutation.isPending ? void 0 : "trashcan",
    onClick: handleOnClick,
    variant: "secondary",
    disabled: shouldDisableMutation,
    className: "pd:text-xs",
    isLoading: deleteCartMutation.isPending,
    children: /* @__PURE__ */jsx9(FormattedMessage6, {
      id: "checkout.emptyCart.button",
      defaultMessage: "Empty cart"
    })
  });
};
var DeleteCartButton_default = DeleteCartButton;

// src/library/components/design-system/checkout/CheckoutDevOnly.tsx
import { Panel as Panel3 } from "@printdeal/ui-library";
import cx from "clsx";

// src/library/components/design-system/checkout/CheckoutJSONViewer.tsx
import { LinkAsButton as LinkAsButton3, useCopyToClipboard as useCopyToClipboard2 } from "@printdeal/ui-library";
import { jsx as jsx10, jsxs as jsxs6 } from "react/jsx-runtime";
var CheckoutJSONViewer = _ref37 => {
  let {
    jsonObject
  } = _ref37;
  const [, copyToClipboard] = useCopyToClipboard2();
  return /* @__PURE__ */jsx10("div", {
    className: "pd:flex pd:flex-col",
    children: Object.keys(jsonObject).map(key => /* @__PURE__ */jsxs6(LinkAsButton3, {
      onClick: () => __async(void 0, null, function* () {
        const value = jsonObject[key];
        if (value) {
          yield copyToClipboard(value.toString());
        }
      }),
      iconAfter: "copy",
      variant: "secondary",
      children: [key, ":", jsonObject[key]]
    }, key))
  });
};
var CheckoutJSONViewer_default = CheckoutJSONViewer;

// src/library/components/design-system/checkout/CheckoutDevOnly.tsx
import { jsx as jsx11, jsxs as jsxs7 } from "react/jsx-runtime";
var CheckoutDevOnly = _ref38 => {
  let {
    className,
    jsonObject,
    children
  } = _ref38;
  return window.localStorage.getItem("checkout_info") === "true" &&
  // Implement helper function from UI library
  /* @__PURE__ */
  jsxs7(Panel3, {
    className: cx("pd:p-4 pd:bg-error-100", className),
    children: [/* @__PURE__ */jsx11("p", {
      className: "pd:mb-2 pd:text-xs",
      children: "This panel is only visible for developers."
    }), /* @__PURE__ */jsx11("div", {
      className: "pd:flex",
      children: /* @__PURE__ */jsxs7("div", {
        className: "pd:w-full pd:rounded-md pd:border pd:border-dim-200 pd:bg-white pd:p-2 pd:text-sm",
        children: [jsonObject && /* @__PURE__ */jsx11(CheckoutJSONViewer_default, {
          jsonObject
        }), children]
      })
    })]
  });
};
var CheckoutDevOnly_default = CheckoutDevOnly;

// src/library/components/design-system/line-item/LineItemPanel.tsx
import { Panel as Panel6 } from "@printdeal/ui-library";

// src/library/components/design-system/line-item/LineItemActions.tsx
import { useState as useState7 } from "react";
import { hasLinkedServices, isQuoteLineItem, hasOrchestration } from "@printdeal/business-logic";
import { LineItemHelper as LineItemHelper2 } from "@printdeal/ecommerce-helpers";

// src/library/components/line-item/DuplicateLineItemButton.tsx
import { useMemo as useMemo2 } from "react";
import { FormattedMessage as FormattedMessage7 } from "react-intl";
import { Button as Button2 } from "@printdeal/ui-library";

// src/library/queries/line-item/useDuplicateLineItemMutation.ts
import { useMutation as useMutation6 } from "@tanstack/react-query";
import { AddLineItemHelper } from "@printdeal/ecommerce-helpers";
import { isGroupLineItem, getAssociatedGroupedLineItems } from "@printdeal/business-logic";
import { nanoid } from "nanoid";

// src/library/queries/quote/useAddQuoteToCartMutation.ts
import { useMutation as useMutation5 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication2 } from "@printdeal/authentication";
import { ErrorManagement as ErrorManagement3 } from "@printdeal/error-management/react";
function useAddQuoteToCartMutation() {
  const {
    isUserLoggedIn
  } = useAuthentication2();
  const {
    setCartData,
    cartId,
    addError,
    removeError
  } = useCart();
  const createCartMutation = useCreateCartMutation();
  const mutationKey = "addQuoteToCart" /* addQuoteToCart */;
  return useMutation5({
    mutationKey: [mutationKey],
    mutationFn: payload => __async(this, null, function* () {
      if (!isUserLoggedIn) {
        throw new Error("Cannot add a quote to the cart when not logged in");
      }
      if (payload.length === 0) {
        throw new Error("Payload for add quote line item is invalid: ".concat(JSON.stringify(payload)));
      }
      let newCartId = cartId;
      if (!newCartId) {
        ({
          id: newCartId
        } = yield createCartMutation.mutateAsync());
      }
      removeError(mutationKey);
      return ShoppingCartHttpClient_default.addQuoteLineItem(newCartId, payload);
    }),
    onSuccess: responseData => {
      setCartData(responseData.data);
    },
    onError: error => {
      addError(mutationKey, error);
      ErrorManagement3.exception({
        exception: error,
        tags: {
          fileLocation: "useAddQuoteToCartMutation",
          featureFunction: "add quote line item to cart"
        },
        fingerprint: ["checkout", "useAddQuoteToCartMutation"]
      });
    }
  });
}

// src/library/queries/line-item/useDuplicateLineItemMutation.ts
function useDuplicateLineItemMutation(_ref39) {
  let {
    onSuccess,
    onError
  } = _ref39;
  const {
    cartId,
    cart,
    setCartData
  } = useCart();
  const mutationKey = "duplicateLineItem" /* duplicateLineItem */;
  const addQuoteToCartMutation = useAddQuoteToCartMutation();
  const reAssignGroupIds = lineItems => {
    const groupIds = [];
    lineItems.forEach(lineItem => {
      var _a, _b;
      if ((_a = lineItem.custom) == null ? void 0 : _a.fields.serviceGroup) {
        groupIds.push({
          oldGroupId: lineItem.custom.fields.serviceGroup,
          newGroupId: nanoid()
        });
      }
      if ((_b = lineItem.custom) == null ? void 0 : _b.fields.isReviewGroupLead) {
        groupIds.push({
          oldGroupId: lineItem.custom.fields.reviewGroup,
          newGroupId: nanoid()
        });
      }
    });
    groupIds.forEach(_ref40 => {
      let {
        oldGroupId,
        newGroupId
      } = _ref40;
      lineItems.forEach(lineItem => {
        var _a, _b;
        if (((_a = lineItem.custom) == null ? void 0 : _a.fields.serviceGroup) && lineItem.custom.fields.serviceGroup === oldGroupId) {
          lineItem.custom.fields.serviceGroup = newGroupId;
        }
        if (((_b = lineItem.custom) == null ? void 0 : _b.fields.reviewGroup) && lineItem.custom.fields.reviewGroup === oldGroupId) {
          lineItem.custom.fields.reviewGroup = newGroupId;
          lineItem.custom.fields.fulfillmentGroup = newGroupId;
        }
      });
    });
    return lineItems;
  };
  return useMutation6({
    mutationKey: [mutationKey],
    mutationFn: _0 => __async(this, [_0], function (_ref41) {
      let {
        lineItem
      } = _ref41;
      return function* () {
        var _a;
        if (!cartId || !cart) {
          throw new Error("Cannot duplicate line item without a cart");
        }
        if ((_a = lineItem.custom) == null ? void 0 : _a.fields.quoteId) {
          const {
            data: data2
          } = yield addQuoteToCartMutation.mutateAsync([{
            quoteId: lineItem.custom.fields.quoteId,
            quoteLineItemId: lineItem.custom.fields.quoteLineItemId
          }]);
          return data2;
        }
        const lineItems = [lineItem];
        if (isGroupLineItem(lineItem)) {
          lineItems.push(...getAssociatedGroupedLineItems(cart, lineItem, {
            reviewGroup: true,
            fulfillmentGroup: true,
            multipleDesignsGroup: true
          }));
        }
        const newLineItem = AddLineItemHelper.buildLineItemShapeFromLineItems({
          lineItems: reAssignGroupIds(lineItems),
          orderOrCart: cart
        });
        const {
          data
        } = yield ShoppingCartHttpClient_default.addLineItem(cartId, newLineItem);
        return data;
      }();
    }),
    retry: false,
    onSuccess: data => {
      setCartData(data);
      if (typeof onSuccess === "function") {
        onSuccess(data, mutationKey);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error, mutationKey);
      }
    }
  });
}

// src/library/components/line-item/DuplicateLineItemButton.tsx
import { jsx as jsx12 } from "react/jsx-runtime";
var DuplicateLineItemButton = _ref42 => {
  let {
    lineItem,
    open = false,
    onSuccess,
    onError,
    onMouseEnter,
    onMouseLeave
  } = _ref42;
  const duplicateLineItemMutation = useDuplicateLineItemMutation({
    onSuccess,
    onError
  });
  const {
    isCartMutationPending: isCartMutationPending2
  } = useCartVersionMismatchPrevention();
  const {
    queries: {
      cartQuery
    }
  } = useCart();
  const shouldDisableMutation = useMemo2(() => {
    if (cartQuery.isLoading || isCartMutationPending2 || duplicateLineItemMutation.status === "pending") {
      return true;
    }
    return false;
  }, [cartQuery.isLoading, isCartMutationPending2, duplicateLineItemMutation.status]);
  const handleOnClick = event => {
    event.preventDefault();
    if (shouldDisableMutation) {
      return;
    }
    duplicateLineItemMutation.mutate({
      lineItem
    });
  };
  const showSpinner = duplicateLineItemMutation.status === "pending" && duplicateLineItemMutation.variables.lineItem.id === lineItem.id;
  return /* @__PURE__ */jsx12(Button2, {
    variant: "tertiary",
    iconBefore: "copy",
    className: "pd:gap-0",
    isLoading: showSpinner,
    disabled: shouldDisableMutation,
    onClick: handleOnClick,
    onMouseEnter,
    onMouseLeave,
    children: /* @__PURE__ */jsx12("div", {
      className: "pd:overflow-hidden pd:transition-[max-width] pd:duration-[1000ms] ".concat(open ? "pd:max-w-[200px]" : "pd:max-w-0"),
      children: /* @__PURE__ */jsx12("span", {
        className: "pd:ml-2 pd:whitespace-nowrap",
        children: /* @__PURE__ */jsx12(FormattedMessage7, {
          id: "checkout.lineItem.copy",
          defaultMessage: "Copy"
        })
      })
    })
  });
};
var DuplicateLineItemButton_default = DuplicateLineItemButton;

// src/library/components/line-item/RemoveLineItemButton.tsx
import { useEffect as useEffect6, useMemo as useMemo3 } from "react";
import { FormattedMessage as FormattedMessage8 } from "react-intl";
import { useQueryClient } from "@tanstack/react-query";
import { addDataLayerEntry as addDataLayerEntry2 } from "@printdeal/data-layer-manager";
import { Button as Button3 } from "@printdeal/ui-library";

// src/library/helpers/EcommerceObjectHelper.ts
import { CustomLineItemHelper } from "@printdeal/ecommerce-helpers";
var EcommerceObjectHelper = class {
  static convertCentAmountToAmountWithCents(_ref43) {
    let {
      centAmount,
      fractionDigits
    } = _ref43;
    var _a;
    const digits = fractionDigits;
    const fractionDivision = {
      2: 100
    };
    return Number((centAmount / ((_a = fractionDivision[digits]) != null ? _a : 100)).toFixed(digits));
  }
  static getCouponCodes(cart) {
    return cart.discountCodes.length > 0 ? cart.discountCodes.map(_ref44 => {
      let {
        discountCode
      } = _ref44;
      var _a;
      return (_a = discountCode.obj) == null ? void 0 : _a.code;
    }).join(", ") : void 0;
  }
  static getPropertyValueFromVariableAttributesByKey(lineItem, propertyKey) {
    var _a;
    const variableAttributes = (_a = lineItem.custom) == null ? void 0 : _a.fields.variableAttributes;
    if (!variableAttributes || variableAttributes.length === 0) {
      return void 0;
    }
    const keyToLower = propertyKey.toLowerCase();
    const quantity = variableAttributes.map(attribute => {
      const [key, value] = attribute.split(":");
      return {
        key,
        value: value ? parseInt(value, 10) : void 0
      };
    }).find(attribute => {
      var _a2;
      return ((_a2 = attribute.key) == null ? void 0 : _a2.toLowerCase()) === keyToLower;
    });
    return quantity ? quantity.value : void 0;
  }
  static getProductVariant(lineItem) {
    var _a;
    const userSelection = (_a = lineItem.custom) == null ? void 0 : _a.fields.userSelection;
    if (!userSelection || userSelection.length === 0) {
      return "Unknown, userSelection field missing or empty";
    }
    const productVariant = {};
    userSelection.forEach(selection => {
      const [key, value] = selection.split(":");
      if (key && value) {
        productVariant[key] = value;
      }
    });
    const quantity = this.getPropertyValueFromVariableAttributesByKey(lineItem, "Quantity");
    if (quantity) {
      productVariant.Quantity = quantity;
    }
    return JSON.stringify(productVariant);
  }
  static clearEcommerceObject() {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      ecommerce: null
    });
  }
  /**
   * Intended for most events that don't need anything else besides basic cart data.
   * See other functions below for events that need their own separate implementation.
   */
  static createEcommerceObject(cart) {
    return {
      currency: "EUR",
      value: cart && cart.taxedPrice ? this.convertCentAmountToAmountWithCents(cart.taxedPrice.totalGross) : void 0,
      coupon: cart ? this.getCouponCodes(cart) : void 0,
      items: cart && cart.lineItems.length > 0 ? cart.lineItems.map(lineItem => {
        var _a;
        return {
          item_name: lineItem.name.en,
          item_id: (_a = lineItem.custom) == null ? void 0 : _a.fields.productKey,
          price: this.convertCentAmountToAmountWithCents(lineItem.totalPrice),
          item_variant: this.getProductVariant(lineItem),
          quantity: 1,
          sku_quantity: lineItem.quantity
        };
      }) : void 0
    };
  }
  /**
   * Intended for 'add_payment_info' events.
   * @see https://sites.google.com/artefact.com/drukwerkdeal-ga4-solutiondesig/tracking-overview/add_payment_info?authuser=0
   */
  static createEcommercePaymentInfoObject(cart, paymentMethodId) {
    return __spreadProps(__spreadValues({}, this.createEcommerceObject(cart)), {
      payment_type: paymentMethodId
    });
  }
  /**
   * Intended for 'remove_from_cart' events.
   * @see https://sites.google.com/artefact.com/drukwerkdeal-ga4-solutiondesig/tracking-overview/remove_from_cart?authuser=0
   */
  static createEcommerceRemoveObject(cart, removedLineItems) {
    return {
      currency: "EUR",
      coupon: cart ? this.getCouponCodes(cart) : void 0,
      items: removedLineItems.map(lineItem => {
        var _a;
        return {
          item_name: lineItem.name.en,
          item_id: (_a = lineItem.custom) == null ? void 0 : _a.fields.productKey,
          price: this.convertCentAmountToAmountWithCents(lineItem.totalPrice),
          item_variant: this.getProductVariant(lineItem),
          quantity: 1,
          sku_quantity: lineItem.quantity,
          index: cart ? cart.lineItems.indexOf(lineItem) + 1 : void 0
        };
      })
    };
  }
  static createEcommercePurchaseObject(cart, order) {
    var _a, _b, _c;
    const shippingCostsCustomLineItems = CustomLineItemHelper.getCustomLineItemsOfType(order.customLineItems, "shipping");
    const shippingCosts = shippingCostsCustomLineItems.length > 0 ? (_b = (_a = shippingCostsCustomLineItems[0]) == null ? void 0 : _a.taxedPrice) == null ? void 0 : _b.totalNet : void 0;
    return __spreadProps(__spreadValues({}, this.createEcommerceObject(cart)), {
      transaction_id: order.orderNumber,
      tax: ((_c = order.taxedPrice) == null ? void 0 : _c.totalTax) ? this.convertCentAmountToAmountWithCents(order.taxedPrice.totalTax) : void 0,
      shipping: shippingCosts ? this.convertCentAmountToAmountWithCents(shippingCosts) : void 0
    });
  }
};

// src/library/components/line-item/RemoveLineItemButton.tsx
import { jsx as jsx13 } from "react/jsx-runtime";
var RemoveLineItemButton = _ref45 => {
  let {
    lineItem,
    open = false,
    onSuccess,
    onError,
    onMouseEnter,
    onMouseLeave
  } = _ref45;
  var _a;
  const removeLineItemMutation = useRemoveLineItemMutation({
    onSuccess,
    onError
  });
  const {
    isCartMutationPending: isCartMutationPending2
  } = useCartVersionMismatchPrevention();
  const queryClient = useQueryClient();
  const {
    queries: {
      cartQuery
    },
    expiredQuotesError,
    cart,
    cartId
  } = useCart();
  const shouldDisableRemoveLineItem = useMemo3(() => {
    if (cartQuery.isLoading || isCartMutationPending2 || removeLineItemMutation.status === "pending") {
      return true;
    }
    return false;
  }, [cartQuery.isLoading, isCartMutationPending2, removeLineItemMutation.status]);
  useEffect6(() => {
    var _a2;
    if (removeLineItemMutation.isSuccess && ((_a2 = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a2.length) && cart && cart.lineItems.map(_ref46 => {
      let {
        id
      } = _ref46;
      return id;
    }).includes(lineItem.id)) {
      const invalidateQuery = () => __async(void 0, null, function* () {
        yield queryClient.invalidateQueries({
          queryKey: ["getExpiredQuotes", cartId]
        });
      });
      invalidateQuery().catch(() => {});
    }
  }, [cart, cartId, (_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.length, lineItem.id, queryClient, removeLineItemMutation.isSuccess]);
  const showSpinner = removeLineItemMutation.status === "pending" && removeLineItemMutation.variables.lineItemId === lineItem.id;
  return /* @__PURE__ */jsx13(Button3, {
    variant: "tertiary",
    iconBefore: "trashcan",
    className: "pd:gap-0",
    isLoading: showSpinner,
    disabled: shouldDisableRemoveLineItem,
    onClick: () => {
      if (shouldDisableRemoveLineItem) {
        return;
      }
      removeLineItemMutation.mutate({
        lineItemId: lineItem.id
      });
      EcommerceObjectHelper.clearEcommerceObject();
      addDataLayerEntry2("remove_from_cart", EcommerceObjectHelper.createEcommerceRemoveObject(cart, [lineItem]));
    },
    onMouseEnter,
    onMouseLeave,
    children: /* @__PURE__ */jsx13("div", {
      className: "pd:overflow-hidden pd:transition-[max-width] pd:duration-[1000ms] ".concat(open ? "pd:max-w-[200px]" : "pd:max-w-0"),
      children: /* @__PURE__ */jsx13("span", {
        className: "pd:ml-2 pd:whitespace-nowrap",
        children: /* @__PURE__ */jsx13(FormattedMessage8, {
          id: "checkout.lineItem.remove",
          defaultMessage: "Remove"
        })
      })
    })
  });
};
var RemoveLineItemButton_default = RemoveLineItemButton;

// src/library/components/line-item/EditLineItemButton.tsx
import { useState as useState6 } from "react";
import { FormattedMessage as FormattedMessage13 } from "react-intl";
import { Button as Button5 } from "@printdeal/ui-library";

// src/library/components/line-item/edit-line-item/EditLineItemModal.tsx
import { Modal, Spinner as Spinner2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage12, useIntl as useIntl5 } from "react-intl";
import { SelectorContextProvider, PricesContextProvider, VatModeProvider, useSelectorContentByPageId } from "@printdeal/product-selector";

// src/library/components/line-item/edit-line-item/EditLineItemContent.tsx
import { useSelectorMachineSend } from "@printdeal/product-selector";
import { LinkAsButton as LinkAsButton4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage11 } from "react-intl";
import { CustomLineItemHelper as CustomLineItemHelper2 } from "@printdeal/ecommerce-helpers";

// src/library/components/line-item/edit-line-item/EditLineItemSummary.tsx
import { useContext as useContext4, useEffect as useEffect7, useState as useState3 } from "react";
import { VatModeContext, useSelectorMachineContext, getProductAttribute, useSelectorState } from "@printdeal/product-selector";
import { Alert as Alert2, Button as Button4, Heading as Heading4, Panel as Panel4, Tooltip } from "@printdeal/ui-library";
import { defineMessages as defineMessages2, FormattedMessage as FormattedMessage9, useIntl as useIntl4 } from "react-intl";
import { arrayOfStringArraysToArrayOfObjects, keyValueObjectToStringArray } from "@printdeal/transformers";
import { getProductVariantVersion, isArtworkDelivered } from "@printdeal/business-logic";
import { SurfaceHelper } from "@printdeal/ecommerce-helpers";

// src/library/queries/surface-helper/useGetSurfaceDependenciesQuery.ts
import { useQuery as useQuery2 } from "@tanstack/react-query";

// src/library/http-clients/SurfaceHelperServiceHttpClient.ts
import axios2 from "axios";
import { configurationProvider as configurationProvider2 } from "@printdeal/configuration";
import { jwtDecode } from "jwt-decode";
import { authenticationHttpClient } from "@printdeal/authentication";
var anonymousCoamIdentity;
var isDecodedTokenExpired = decodedToken => {
  if (!decodedToken.exp) {
    return true;
  }
  return Boolean(decodedToken.exp <= Math.floor(( /* @__PURE__ */new Date()).getTime() / 1e3));
};
var createAnonymousCOAMIdentity = identity => __async(void 0, null, function* () {
  const {
    data: {
      token: printdealAuthToken
    }
  } = yield authenticationHttpClient.createToken();
  const {
    data
  } = yield axios2.post("".concat(configurationProvider2.getValue("AUTH_LAYER_API_BASE_URL"), "/anon-coam-identity"), identity, {
    headers: {
      Authorization: printdealAuthToken
    }
  });
  return data;
});
var getAnonymousCOAMIdentity = () => __async(void 0, null, function* () {
  const identityFromStorage = typeof window !== "undefined" ? window.localStorage.getItem("anonCoamIdentity") : void 0;
  if (!identityFromStorage) {
    const newIdentity = yield createAnonymousCOAMIdentity();
    if (typeof window !== "undefined") {
      window.localStorage.setItem("anonCoamIdentity", JSON.stringify(newIdentity));
    }
    return newIdentity;
  }
  const parsedIdentityFromStorage = JSON.parse(identityFromStorage);
  const decodedToken = jwtDecode(parsedIdentityFromStorage.anonymousToken);
  if (isDecodedTokenExpired(decodedToken)) {
    const newIdentity = yield createAnonymousCOAMIdentity(parsedIdentityFromStorage);
    if (typeof window !== "undefined") {
      window.localStorage.setItem("anonCoamIdentity", JSON.stringify(newIdentity));
    }
    return newIdentity;
  }
  return parsedIdentityFromStorage;
});
function authenticateHttpRequestInterceptor2(config) {
  return __async(this, null, function* () {
    if (!anonymousCoamIdentity) {
      anonymousCoamIdentity = yield getAnonymousCOAMIdentity();
    }
    if (!(anonymousCoamIdentity == null ? void 0 : anonymousCoamIdentity.anonymousToken)) {
      throw new Error("Could not retrieve an anonymous COAM Identity to authenticate the HTTP request.");
    }
    const updatedConfig = config;
    updatedConfig.headers.Authorization = "Bearer ".concat(anonymousCoamIdentity.anonymousToken);
    return updatedConfig;
  });
}
var SurfaceHelperServiceHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = "https://surface-helper.products.cimpress.io";
      this.httpClient = axios2.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor2);
    }
    return this.httpClient;
  }
  getDependencies(productId, version) {
    return __async(this, null, function* () {
      return this.client.post("/v1/dependencies:calculated", {
        productId,
        version
      });
    });
  }
};
var surfaceHelperServiceHttpClient = new SurfaceHelperServiceHttpClient();
var SurfaceHelperServiceHttpClient_default = surfaceHelperServiceHttpClient;

// src/library/queries/surface-helper/useGetSurfaceDependenciesQuery.ts
function useGetSurfaceDependenciesQuery(_ref47) {
  let {
    productId,
    version,
    enabled
  } = _ref47;
  return useQuery2({
    queryKey: ["get-surface-dependencies", productId, version],
    queryFn: () => __async(this, null, function* () {
      if (!productId || !version) {
        throw new Error("productId and or version are required");
      }
      const {
        data
      } = yield SurfaceHelperServiceHttpClient_default.getDependencies(productId, version);
      return data;
    }),
    retry: false,
    enabled
  });
}

// src/library/components/line-item/edit-line-item/EditLineItemSummary.tsx
import { jsx as jsx14, jsxs as jsxs8 } from "react/jsx-runtime";
var translations = defineMessages2({
  "Normal": {
    id: "checkout.editLineItem.deliveryMethod.normal",
    defaultMessage: "Normal"
  },
  "Next Day": {
    id: "checkout.editLineItem.deliveryMethod.nextDay",
    defaultMessage: "Next Day"
  },
  "Express": {
    id: "checkout.editLineItem.deliveryMethod.express",
    defaultMessage: "Express"
  },
  "Quantity": {
    id: "checkout.editLineItem.quantity",
    defaultMessage: "Quantity"
  },
  "Delivery Type": {
    id: "checkout.editLineItem.deliveryType",
    defaultMessage: "Delivery Type"
  }
});
var EditLineItemSummary = _ref48 => {
  let {
    lineItem,
    onSubmitChanges,
    error,
    product,
    deliveryOptionId
  } = _ref48;
  var _a, _b, _c, _d, _e, _f, _g, _h, _i;
  const intl = useIntl4();
  const vatContext = useContext4(VatModeContext);
  const selectedPrice = useSelectorMachineContext(state => state.context.totalPrice);
  const selectorState = useSelectorState();
  const selection = useSelectorMachineContext(state => state.context.selection);
  const quantity = useSelectorMachineContext(state => state.context.totalQuantity);
  const deliveryOption = useSelectorMachineContext(state => state.context.selectedDeliveryOption);
  const deliveryOptions = useSelectorMachineContext(state => state.context.deliveryDates);
  const getSurfaceDependenciesQuery = useGetSurfaceDependenciesQuery({
    productId: (_a = lineItem.custom) == null ? void 0 : _a.fields.mcpSku,
    version: getProductVariantVersion({
      attributes: (_b = lineItem.variant.attributes) != null ? _b : []
    }).toString(),
    enabled: isArtworkDelivered(lineItem)
  });
  const hasNewQuantity = lineItem.quantity !== quantity;
  const [isPending, setIsPending] = useState3(false);
  const [changedAttributes, setChangedAttributes] = useState3([]);
  const [willRemoveArtwork, setWillRemoveArtwork] = useState3(false);
  const [willRemoveSplitShipment, setWillRemoveSplitShipment] = useState3(false);
  const [newUserSelection, setNewUserSelection] = useState3({});
  useEffect7(() => {
    var _a2;
    if (getSurfaceDependenciesQuery.data) {
      const {
        remainingOptions
      } = getSurfaceDependenciesQuery.data;
      if (isArtworkDelivered(lineItem) && remainingOptions.length > 0 && Object.keys(selection).length > 0) {
        const removeArtwork = SurfaceHelper.shouldRemoveArtwork(remainingOptions, keyValueObjectToStringArray((_a2 = lineItem.custom) == null ? void 0 : _a2.fields.userSelection), selection);
        setWillRemoveArtwork(removeArtwork);
      }
    }
  }, [getSurfaceDependenciesQuery.data, lineItem, selection]);
  useEffect7(() => {
    var _a2, _b2;
    const currentSelection = keyValueObjectToStringArray((_a2 = lineItem.custom) == null ? void 0 : _a2.fields.userSelection);
    const userSelection = {};
    const changedAttributesArray = [];
    Object.keys(selection).forEach(key => {
      const isQuantity = key === "Quantity";
      const previousValue = currentSelection[key];
      const newValue = selection[key];
      if (newValue && newValue !== previousValue && !isQuantity && previousValue) {
        changedAttributesArray.push({
          attributeName: key,
          previousValue,
          newValue
        });
      }
      if (!isQuantity && newValue) {
        userSelection[key] = newValue;
      }
    });
    if (deliveryOption.id && deliveryOption.id !== deliveryOptionId) {
      const previousDeliveryOption = deliveryOptions.find(_ref49 => {
        let {
          id
        } = _ref49;
        return id === deliveryOptionId;
      });
      if (previousDeliveryOption) {
        changedAttributesArray.push({
          attributeName: "Delivery Type",
          previousValue: previousDeliveryOption.name,
          newValue: deliveryOption.name
        });
      }
    }
    if (hasNewQuantity) {
      changedAttributesArray.push({
        attributeName: "Quantity",
        previousValue: String(lineItem.quantity),
        newValue: String(quantity)
      });
      const shippingAddresses = arrayOfStringArraysToArrayOfObjects((_b2 = lineItem.custom) == null ? void 0 : _b2.fields.shippingAddressPerLineItem);
      if (shippingAddresses.length > 1) {
        setWillRemoveSplitShipment(true);
      } else {
        setWillRemoveSplitShipment(false);
      }
    } else {
      setWillRemoveSplitShipment(false);
    }
    setNewUserSelection(userSelection);
    setChangedAttributes(changedAttributesArray);
  }, [(_c = lineItem.custom) == null ? void 0 : _c.fields.shippingAddressPerLineItem, (_d = lineItem.custom) == null ? void 0 : _d.fields.userSelection, lineItem.quantity, selection, quantity, deliveryOption.id]);
  return /* @__PURE__ */jsxs8(Panel4, {
    className: "pd:flex pd:flex-col pd:gap-3",
    children: [/* @__PURE__ */jsx14(Heading4, {
      as: "h3",
      children: /* @__PURE__ */jsx14(FormattedMessage9, {
        id: "checkout.editLineItem.yourChanges",
        defaultMessage: "Your changes"
      })
    }), error && /* @__PURE__ */jsx14(ErrorAlert_default, {
      exception: {
        exception: error,
        tags: {
          fileLocation: "EditLineItemSummary.tsx",
          featureFunction: "editLineItemMutation"
        },
        fingerprint: ["edit-line-item-summary", "edit-line-item-mutation"]
      },
      children: /* @__PURE__ */jsx14(FormattedMessage9, {
        id: "checkout.editLineItem.error",
        defaultMessage: "Something went wrong while updating"
      })
    }), willRemoveArtwork && /* @__PURE__ */jsx14(Alert2, {
      variant: "warning",
      children: /* @__PURE__ */jsx14(FormattedMessage9, {
        id: "checkout.editLineItem.willRemoveArtwork",
        defaultMessage: "Do you confirm these changes? Then we remove the design. This no longer meets the graphic requirements of the new product composition."
      })
    }), willRemoveSplitShipment && /* @__PURE__ */jsx14(Alert2, {
      variant: "warning",
      children: /* @__PURE__ */jsx14(FormattedMessage9, {
        id: "checkout.editLineItem.willRemoveSplitShipment",
        defaultMessage: "Do you confirm to change the quantity? Then we remove the split shipment. This is no longer possible with the new quantity."
      })
    }), changedAttributes.length ? /* @__PURE__ */jsxs8("div", {
      className: "pd:flex pd:flex-col pd:rounded-md pd:border",
      children: [/* @__PURE__ */jsxs8("div", {
        className: "pd:grid pd:grid-cols-3 pd:bg-dim-100 pd:px-4 pd:py-2",
        children: [/* @__PURE__ */jsx14(Heading4, {
          as: "h4",
          className: "pd:col-start-2",
          children: /* @__PURE__ */jsx14(FormattedMessage9, {
            id: "checkout.editLineItem.oldValue",
            defaultMessage: "Old value"
          })
        }), /* @__PURE__ */jsx14(Heading4, {
          as: "h4",
          children: /* @__PURE__ */jsx14(FormattedMessage9, {
            id: "checkout.editLineItem.newValue",
            defaultMessage: "New value"
          })
        })]
      }), changedAttributes.map(_ref50 => {
        let {
          attributeName,
          previousValue,
          newValue
        } = _ref50;
        var _a2, _b2, _c2, _d2;
        const productAttribute = getProductAttribute(product.attributes, attributeName);
        const translatedAttributeName = attributeName === "Quantity" ? intl.formatMessage(translations.Quantity) : (productAttribute == null ? void 0 : productAttribute.attributeAlias) || attributeName;
        const translatedPreviousValue = ((_b2 = (_a2 = productAttribute == null ? void 0 : productAttribute.values) == null ? void 0 : _a2.find(value => value.pimAttributeValue === previousValue)) == null ? void 0 : _b2.attributeValueAlias) || previousValue;
        const translatedNewValue = ((_d2 = (_c2 = productAttribute == null ? void 0 : productAttribute.values) == null ? void 0 : _c2.find(value => value.pimAttributeValue === newValue)) == null ? void 0 : _d2.attributeValueAlias) || newValue;
        if (attributeName === "Delivery Type") {
          return /* @__PURE__ */jsxs8("div", {
            className: "pd:grid pd:grid-cols-3 pd:p-2",
            children: [/* @__PURE__ */jsx14("p", {
              children: intl.formatMessage(translations[attributeName])
            }), /* @__PURE__ */jsx14("p", {
              className: "pd:line-through",
              children: intl.formatMessage(translations[previousValue])
            }), /* @__PURE__ */jsx14("p", {
              children: intl.formatMessage(translations[newValue])
            })]
          }, attributeName);
        }
        return /* @__PURE__ */jsxs8("div", {
          className: "pd:grid pd:grid-cols-3 pd:p-2",
          children: [/* @__PURE__ */jsx14("p", {
            children: translatedAttributeName
          }), /* @__PURE__ */jsx14("p", {
            className: "pd:line-through",
            children: translatedPreviousValue
          }), /* @__PURE__ */jsx14("p", {
            children: translatedNewValue
          })]
        }, attributeName);
      }), selectedPrice && selectedPrice.totalNet.centAmount !== ((_e = lineItem.taxedPrice) == null ? void 0 : _e.totalNet.centAmount) && /* @__PURE__ */jsxs8("div", {
        className: "pd:grid pd:grid-cols-3 pd:bg-dim-100 pd:p-2 pd:font-bold",
        children: [vatContext.vatMode === "totalNet" ? /* @__PURE__ */jsx14(FormattedMessage9, {
          id: "checkout.editLineItem.priceExclusiveVAT",
          defaultMessage: "Price (excl. VAT)"
        }) : /* @__PURE__ */jsx14(FormattedMessage9, {
          id: "checkout.editLineItem.priceInclusiveVAT",
          defaultMessage: "Price (incl. VAT)"
        }), /* @__PURE__ */jsx14("p", {
          className: "pd:line-through",
          children: vatContext.vatMode === "totalNet" ? /* @__PURE__ */jsx14(Money_default, {
            value: (_f = lineItem.taxedPrice) == null ? void 0 : _f.totalNet.centAmount,
            currency: (_g = lineItem.taxedPrice) == null ? void 0 : _g.totalNet.currencyCode
          }) : /* @__PURE__ */jsx14(Money_default, {
            value: (_h = lineItem.taxedPrice) == null ? void 0 : _h.totalGross.centAmount,
            currency: (_i = lineItem.taxedPrice) == null ? void 0 : _i.totalGross.currencyCode
          })
        }), vatContext.vatMode === "totalNet" ? /* @__PURE__ */jsx14(Money_default, {
          value: selectedPrice.totalNet.centAmount,
          currency: selectedPrice.totalNet.currencyCode
        }) : /* @__PURE__ */jsx14(Money_default, {
          value: selectedPrice.totalGross.centAmount,
          currency: selectedPrice.totalGross.currencyCode
        })]
      })]
    }) : /* @__PURE__ */jsx14(Alert2, {
      variant: "dim",
      children: /* @__PURE__ */jsx14(FormattedMessage9, {
        id: "checkout.editLineItem.noChanges",
        defaultMessage: "You have not yet made any product changes"
      })
    }), /* @__PURE__ */jsx14(Tooltip, {
      placement: "top",
      trigger: /* @__PURE__ */jsx14(Button4, {
        as: changedAttributes.length === 0 ? Tooltip.Trigger : "button",
        isLoading: isPending,
        disabled: !selectedPrice || isPending || selectorState !== "idle" || changedAttributes.length === 0,
        onClick: () => __async(void 0, null, function* () {
          setIsPending(true);
          yield onSubmitChanges({
            changedAttributes,
            willRemoveArtwork,
            willRemoveSplitShipment,
            newUserSelection,
            quantity,
            deliveryOptionId: deliveryOption.id
          }, () => {
            setIsPending(false);
          });
        }),
        className: "pd:mt-2 pd:w-full",
        children: /* @__PURE__ */jsx14(FormattedMessage9, {
          id: "checkout.editLineItem.submit",
          defaultMessage: "Confirm changes"
        })
      }),
      children: /* @__PURE__ */jsx14(FormattedMessage9, {
        id: "checkout.editLineItem.noChangedAttributes",
        defaultMessage: "You have not changed any product attributes yet"
      })
    })]
  });
};
var EditLineItemSummary_default = EditLineItemSummary;

// src/library/components/line-item/edit-line-item/EditLineItemSelector.tsx
import { Panel as Panel5 } from "@printdeal/ui-library";
import { PricesComponent, Selector, getPricePivot, useSelectorMachineContext as useSelectorMachineContext2, SelectVatMode, getAttributes, pricePivotAttributes, getPriceGroups, Pricing, DeliveryOptions } from "@printdeal/product-selector";
import { keyValueObjectToStringArray as keyValueObjectToStringArray2 } from "@printdeal/transformers";
import { useContext as useContext5, useEffect as useEffect8, useState as useState4 } from "react";
import { configurationProvider as configurationProvider3 } from "@printdeal/configuration";
import { LineItemHelper } from "@printdeal/ecommerce-helpers";

// src/library/queries/line-item/pickup-point/useGetPickupPointQuery.ts
import { useQuery as useQuery3 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication3 } from "@printdeal/authentication";
import axios3 from "axios";
function useGetPickupPointQuery(_ref51) {
  let {
    pickupPointId
  } = _ref51;
  const {
    isUserLoggedIn
  } = useAuthentication3();
  return useQuery3({
    queryKey: ["get-pickup-point", pickupPointId],
    queryFn: () => __async(this, null, function* () {
      if (!pickupPointId) {
        throw new Error("No pickup point id provided");
      }
      const response = yield axios3.get("https://proxy.pup.cimpress.io/v1/pickupPoints/".concat(pickupPointId));
      return response.data;
    }),
    enabled: isUserLoggedIn && Boolean(pickupPointId)
  });
}

// src/library/components/line-item/edit-line-item/EditLineItemSelector.tsx
import { Fragment as Fragment2, jsx as jsx15, jsxs as jsxs9 } from "react/jsx-runtime";
var EditLineItemSelector = _ref52 => {
  let {
    lineItem,
    selector,
    deliveryOptionId
  } = _ref52;
  var _a, _b, _c, _d;
  const {
    customer
  } = useContext5(CheckoutViewContext_default);
  const isSelectionComplete = useSelectorMachineContext2(state => state.matches({
    STARTED: "SELECTION COMPLETE"
  }));
  const selectionMode = useSelectorMachineContext2(state => state.context.selectionMode);
  const price = useSelectorMachineContext2(state => state.context.price);
  const productAttributes = useSelectorMachineContext2(state => state.context.productAttributes);
  const selection = useSelectorMachineContext2(state => state.context.selection);
  const configurationAttributes = useSelectorMachineContext2(state => state.context.attributes);
  const groupSelection = useSelectorMachineContext2(state => state.context.group);
  const shippingAddresses = (_a = lineItem.custom) == null ? void 0 : _a.fields.shippingAddressPerLineItem;
  const pickupPointId = LineItemHelper.getLineItemPickupPointId(lineItem);
  const pickupPointQuery = useGetPickupPointQuery({
    pickupPointId
  });
  const isStepByStepSelector = selectionMode === "step-by-step";
  const {
    isPimProduct
  } = selector.product;
  const [shippingAddress, setShippingAddress] = useState4({
    CountryCode: configurationProvider3.getValue("OFFICE_ADDRESS_COUNTRY"),
    PostalCode: configurationProvider3.getValue("OFFICE_ADDRESS_POSTAL_CODE")
  });
  useEffect8(() => {
    let firstShippingAddress;
    if (shippingAddresses) {
      [firstShippingAddress] = shippingAddresses;
    }
    if (firstShippingAddress) {
      const {
        country,
        postalCode
      } = keyValueObjectToStringArray2(firstShippingAddress);
      if (country && postalCode) {
        setShippingAddress({
          CountryCode: country,
          PostalCode: postalCode
        });
      }
    }
  }, [shippingAddresses]);
  useEffect8(() => {
    if (pickupPointQuery.data) {
      const {
        countryCode,
        postalCode
      } = pickupPointQuery.data.address;
      if (countryCode && postalCode) {
        setShippingAddress({
          CountryCode: countryCode,
          PostalCode: postalCode
        });
      }
    }
  }, [pickupPointQuery.data]);
  return /* @__PURE__ */jsxs9(Panel5, {
    children: [/* @__PURE__ */jsx15(Selector, {
      productPageId: (_b = lineItem.custom) == null ? void 0 : _b.fields.contentfulPageId,
      selector,
      prefilledSelection: keyValueObjectToStringArray2((_c = lineItem.custom) == null ? void 0 : _c.fields.userSelection),
      shippingAddress,
      customerGroupId: customer == null ? void 0 : customer.customerGroupId,
      deliveryOptionId,
      quantity: lineItem.quantity
    }), isPimProduct && isStepByStepSelector && /* @__PURE__ */jsxs9("div", {
      className: "pd:flex pd:flex-col pd:gap-4",
      children: [/* @__PURE__ */jsx15("div", {
        className: "pd:flex pd:justify-end",
        children: /* @__PURE__ */jsx15(SelectVatMode, {})
      }), /* @__PURE__ */jsx15(Pricing, {
        hasPrefilledSelection: true
      })]
    }), isPimProduct && !isStepByStepSelector && /* @__PURE__ */jsxs9(Fragment2, {
      children: [/* @__PURE__ */jsx15(Pricing, {
        hasPrefilledSelection: true
      }), /* @__PURE__ */jsx15(DeliveryOptions, {
        hasPrefilledSelection: true
      })]
    }), !isPimProduct && isStepByStepSelector && (isSelectionComplete || price) && selection["Printing Process"] && selection["Delivery Type"] && /* @__PURE__ */jsxs9("div", {
      className: "pd:flex pd:flex-col pd:gap-4",
      children: [/* @__PURE__ */jsx15("div", {
        className: "pd:flex pd:justify-end",
        children: /* @__PURE__ */jsx15(SelectVatMode, {})
      }), /* @__PURE__ */jsx15(PricesComponent, {
        shippingAddress,
        inventoryCheckEnabled: ((_d = productAttributes.find(_ref53 => {
          let {
            key
          } = _ref53;
          return key === "InventoryCheck";
        })) == null ? void 0 : _d.resolvedValue) === "Yes",
        product: selector.product,
        selectionAttributes: getAttributes(selection, [...pricePivotAttributes, "Quantity"]),
        sort: getPricePivot(configurationAttributes).sort,
        group: getPriceGroups(groupSelection),
        customerGroupId: customer == null ? void 0 : customer.customerGroupId,
        preselectedPriceAttributes: {
          "Printing Process": selection["Printing Process"],
          "Delivery Type": selection["Delivery Type"],
          "Quantity": lineItem.quantity
        }
      })]
    })]
  });
};
var EditLineItemSelector_default = EditLineItemSelector;

// src/library/components/line-item/edit-line-item/EditLineItemLockedAttributesAlert.tsx
import { Alert as Alert3, List } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage10 } from "react-intl";
import { getProductVariantVersion as getProductVariantVersion2, isArtworkDelivered as isArtworkDelivered2 } from "@printdeal/business-logic";
import { useEffect as useEffect9, useState as useState5 } from "react";
import { getProductAttribute as getProductAttribute2, useSelectorMachineContext as useSelectorMachineContext3 } from "@printdeal/product-selector";
import { SurfaceHelper as SurfaceHelper2 } from "@printdeal/ecommerce-helpers";
import { Fragment as Fragment3, jsx as jsx16, jsxs as jsxs10 } from "react/jsx-runtime";
var EditLineItemLockedAttributesAlert = _ref54 => {
  let {
    lineItem,
    product
  } = _ref54;
  var _a, _b;
  const getSurfaceDependenciesQuery = useGetSurfaceDependenciesQuery({
    productId: (_a = lineItem.custom) == null ? void 0 : _a.fields.mcpSku,
    version: getProductVariantVersion2({
      attributes: (_b = lineItem.variant.attributes) != null ? _b : []
    }).toString(),
    enabled: isArtworkDelivered2(lineItem)
  });
  const selection = useSelectorMachineContext3(state => state.context.selection);
  const [lockedAttributes, setLockedAttributes] = useState5([]);
  const [forceRemoveArtwork, setForceRemoveArtwork] = useState5(false);
  useEffect9(() => {
    if (getSurfaceDependenciesQuery.data) {
      const filteredLockedAttributes = SurfaceHelper2.filterRemainingOptions(getSurfaceDependenciesQuery.data.remainingOptions, selection);
      setLockedAttributes(filteredLockedAttributes);
    }
    if (getSurfaceDependenciesQuery.isError) {
      setLockedAttributes([]);
      setForceRemoveArtwork(true);
    }
  }, [getSurfaceDependenciesQuery, selection]);
  return /* @__PURE__ */jsxs10(Fragment3, {
    children: [forceRemoveArtwork && /* @__PURE__ */jsx16(Alert3, {
      variant: "warning",
      children: /* @__PURE__ */jsx16(FormattedMessage10, {
        id: "checkout.editLineItem.forcedArtworkRemoval",
        defaultMessage: "The artwork you have provided will be removed when you edit this product, to ensure this product will not be produced with invalid artwork."
      })
    }), isArtworkDelivered2(lineItem) && lockedAttributes.length > 0 && /* @__PURE__ */jsx16(Alert3, {
      variant: "info",
      children: /* @__PURE__ */jsxs10("div", {
        className: "pd:grid pd:gap-2",
        children: [/* @__PURE__ */jsx16(FormattedMessage10, {
          id: "checkout.editLineItem.lockedAttributes",
          defaultMessage: "Due to the design provided, the following options are locked. If you change these options, your design will be lost because the design no longer meets all graphic requirements."
        }), /* @__PURE__ */jsx16(List, {
          className: "pd:gap-0",
          children: lockedAttributes.map(attribute => {
            const productAttribute = getProductAttribute2(product.attributes, attribute);
            const attributeName = (productAttribute == null ? void 0 : productAttribute.attributeAlias) || attribute;
            return /* @__PURE__ */jsx16(List.Item, {
              children: attributeName
            }, attribute);
          })
        })]
      })
    })]
  });
};
var EditLineItemLockedAttributesAlert_default = EditLineItemLockedAttributesAlert;

// src/library/components/line-item/edit-line-item/EditLineItemContent.tsx
import { jsx as jsx17, jsxs as jsxs11 } from "react/jsx-runtime";
var EditLineItemContent = _ref55 => {
  let {
    lineItem,
    customLineItems,
    onSubmitChanges,
    selector,
    error
  } = _ref55;
  const selectorMachineSend = useSelectorMachineSend();
  const shippingCustomLineItems = CustomLineItemHelper2.getAssociatedCustomLineItems(customLineItems, lineItem.id, "shipping");
  const ecommerceDeliveryOptionId = shippingCustomLineItems.length && shippingCustomLineItems[0] ? CustomLineItemHelper2.getCustomLineItemEcommerceDeliveryOptionId(shippingCustomLineItems[0]) : void 0;
  return /* @__PURE__ */jsxs11("div", {
    className: "pd:flex pd:flex-col pd:gap-2",
    children: [/* @__PURE__ */jsx17(EditLineItemLockedAttributesAlert_default, {
      lineItem,
      product: selector.product
    }), /* @__PURE__ */jsx17("div", {
      className: "pd:flex pd:justify-end",
      children: /* @__PURE__ */jsx17(LinkAsButton4, {
        variant: "secondary",
        onClick: () => selectorMachineSend({
          type: "Reset machine"
        }),
        iconBefore: "refresh",
        className: "pd:text-sm",
        children: /* @__PURE__ */jsx17(FormattedMessage11, {
          id: "checkout.editLineItem.restoreAll",
          defaultMessage: "Restore all"
        })
      })
    }), /* @__PURE__ */jsx17(EditLineItemSelector_default, {
      lineItem,
      selector,
      deliveryOptionId: ecommerceDeliveryOptionId
    }), /* @__PURE__ */jsx17(EditLineItemSummary_default, {
      lineItem,
      onSubmitChanges,
      error,
      product: selector.product,
      deliveryOptionId: ecommerceDeliveryOptionId
    })]
  });
};
var EditLineItemContent_default = EditLineItemContent;

// src/library/components/line-item/edit-line-item/EditLineItemModal.tsx
import { jsx as jsx18, jsxs as jsxs12 } from "react/jsx-runtime";
var EditLineItemModal = _ref56 => {
  let {
    lineItem,
    customLineItems,
    isOpen,
    onClose,
    onSubmitChanges,
    error
  } = _ref56;
  var _a, _b, _c;
  const intl = useIntl5();
  const selector = useSelectorContentByPageId({
    productPageId: (_a = lineItem.custom) == null ? void 0 : _a.fields.contentfulPageId,
    locale: intl.locale
  });
  return /* @__PURE__ */jsx18(Modal, {
    size: "lg",
    isOpen,
    title: intl.formatMessage({
      id: "checkout.editLineItem",
      defaultMessage: "Edit line item"
    }),
    dismissLabel: intl.formatMessage({
      id: "checkout.editLineItem.closeModal",
      defaultMessage: "Close modal"
    }),
    onClose: () => onClose(),
    children: /* @__PURE__ */jsx18(Modal.Content, {
      className: "pd:h-[80vh] pd:bg-dim-100",
      children: /* @__PURE__ */jsx18(SelectorContextProvider, {
        isPimProduct: (_c = (_b = selector.data) == null ? void 0 : _b.product.isPimProduct) != null ? _c : false,
        children: /* @__PURE__ */jsx18(PricesContextProvider, {
          children: /* @__PURE__ */jsxs12(VatModeProvider, {
            children: [selector.isError && /* @__PURE__ */jsx18(ErrorAlert_default, {
              exception: {
                exception: "Error loading product selector for edit line item modal",
                tags: {
                  fileLocation: "EditLineItemModal.tsx",
                  featureFunction: "useSelectorContentByPageId"
                },
                fingerprint: ["edit-line-item-modal", "product-selector"]
              },
              children: /* @__PURE__ */jsx18(FormattedMessage12, {
                id: "checkout.editLineItem.errorLoadingSelector",
                defaultMessage: "Something went wrong while loading the product selector"
              })
            }), selector.data && selector.status === "success" && /* @__PURE__ */jsx18(EditLineItemContent_default, {
              customLineItems,
              lineItem,
              onSubmitChanges,
              selector: selector.data,
              error
            }), selector.isPending && /* @__PURE__ */jsx18("div", {
              className: "pd:flex pd:h-full pd:items-center pd:justify-center",
              children: /* @__PURE__ */jsx18(Spinner2, {
                size: "lg"
              })
            })]
          })
        })
      })
    })
  });
};
var EditLineItemModal_default = EditLineItemModal;

// src/library/queries/line-item/useUpdateLineItemMutation.ts
import { useMutation as useMutation7 } from "@tanstack/react-query";
function useUpdateLineItemMutation(_ref57) {
  let {
    context,
    onSuccess,
    onError
  } = _ref57;
  const {
    cartId,
    setCartData
  } = useCart();
  return useMutation7({
    mutationKey: ["updateLineItem" /* updateLineItem */, context],
    mutationFn: requestData => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot update a line item without a cart id");
      }
      if (!requestData.lineItemId) {
        throw new Error("Cannot update a line item without a line item id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.updateLineItem(cartId, requestData);
      return data;
    }),
    onSuccess: data => {
      setCartData(data);
      if (typeof onSuccess === "function") {
        onSuccess(data);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error);
      }
    }
  });
}

// src/library/components/line-item/EditLineItemButton.tsx
import { Fragment as Fragment4, jsx as jsx19, jsxs as jsxs13 } from "react/jsx-runtime";
var EditLineItemButton = _ref58 => {
  let {
    lineItem,
    open,
    onMouseEnter,
    onMouseLeave
  } = _ref58;
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "editLineItem" /* editLineItem */
  });
  const mismatchPrevention = useCartVersionMismatchPrevention();
  const {
    cart
  } = useCart();
  const [showModal, setShowModal] = useState6(false);
  return /* @__PURE__ */jsxs13(Fragment4, {
    children: [/* @__PURE__ */jsx19(Button5, {
      variant: "tertiary",
      iconBefore: "edit",
      className: "pd:gap-0",
      onClick: () => setShowModal(true),
      onMouseEnter,
      onMouseLeave,
      disabled: mismatchPrevention.isCartMutationPending,
      children: /* @__PURE__ */jsx19("div", {
        className: "pd:overflow-hidden pd:transition-[max-width] pd:duration-[1000ms] ".concat(open ? "pd:max-w-[200px]" : "pd:max-w-0"),
        children: /* @__PURE__ */jsx19("span", {
          className: "pd:ml-2 pd:whitespace-nowrap",
          children: /* @__PURE__ */jsx19(FormattedMessage13, {
            id: "checkout.lineItem.edit",
            defaultMessage: "Edit"
          })
        })
      })
    }), /* @__PURE__ */jsx19(EditLineItemModal_default, {
      lineItem,
      customLineItems: cart.customLineItems,
      isOpen: showModal,
      onClose: () => {
        setShowModal(false);
        updateLineItemMutation.reset();
      },
      onSubmitChanges: (_0, _1) => __async(void 0, [_0, _1], function (_ref59, callback) {
        let {
          changedAttributes,
          newUserSelection,
          quantity,
          deliveryOptionId
        } = _ref59;
        return function* () {
          const hasNewQuantity = changedAttributes.find(item => item.attributeName === "Quantity");
          yield updateLineItemMutation.mutateAsync({
            lineItemId: lineItem.id,
            payload: {
              editLineItem: [__spreadValues(__spreadValues(__spreadValues({
                lineItemId: lineItem.id
              }, Object.keys(newUserSelection).length && {
                userSelection: newUserSelection
              }), hasNewQuantity && {
                quantity
              }), deliveryOptionId && {
                shipping: {
                  deliveryOptionId
                }
              })]
            }
          }).then(() => setShowModal(false)).finally(callback);
        }();
      }),
      error: updateLineItemMutation.error
    })]
  });
};
var EditLineItemButton_default = EditLineItemButton;

// src/library/components/design-system/line-item/LineItemActions.tsx
import { Fragment as Fragment5, jsx as jsx20, jsxs as jsxs14 } from "react/jsx-runtime";
var LineItemActions = _ref60 => {
  let {
    lineItem
  } = _ref60;
  var _a, _b;
  const {
    cart,
    expiredQuotesError
  } = useCart();
  const {
    addError,
    removeError
  } = useError();
  const [currentButtonHovered, setCurrentButtonHovered] = useState7(void 0);
  const hasMultipleDesigns = LineItemHelper2.hasLineItemMultipleDesignsGroup(lineItem);
  const showEditLineItemButton = Boolean(cart && !isQuoteLineItem(lineItem) && !LineItemHelper2.isLineItemReviewGroupLead(lineItem) && !hasOrchestration(lineItem) && !hasLinkedServices(lineItem.id, cart) && !hasMultipleDesigns);
  const isQuoteLineItemExpired = (_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.some(detail => detail.lineItemId === lineItem.id);
  const showDuplicateItemButton = Boolean(!isQuoteLineItemExpired && !hasMultipleDesigns && !hasOrchestration(lineItem));
  return /* @__PURE__ */jsxs14("div", {
    className: "pd:absolute pd:-top-5 pd:right-4 pd:flex pd:gap-2",
    children: [cart && !((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsSiblings) && /* @__PURE__ */jsxs14(Fragment5, {
      children: [showEditLineItemButton && /* @__PURE__ */jsx20(EditLineItemButton_default, {
        lineItem,
        open: currentButtonHovered === "copy-edit" || !currentButtonHovered,
        onMouseEnter: () => setCurrentButtonHovered("copy-edit"),
        onMouseLeave: () => setCurrentButtonHovered(void 0)
      }), showDuplicateItemButton && /* @__PURE__ */jsx20(DuplicateLineItemButton_default, {
        lineItem,
        open: currentButtonHovered === "copy-edit" || !currentButtonHovered,
        onMouseEnter: () => setCurrentButtonHovered("copy-edit"),
        onMouseLeave: () => setCurrentButtonHovered(void 0),
        onSuccess: (_data, mutationKey) => removeError(mutationKey),
        onError: (error, mutationKey) => addError(mutationKey, error)
      })]
    }), /* @__PURE__ */jsx20(RemoveLineItemButton_default, {
      lineItem,
      open: currentButtonHovered === "remove",
      onMouseEnter: () => setCurrentButtonHovered("remove"),
      onMouseLeave: () => setCurrentButtonHovered(void 0),
      onSuccess: (_data, mutationKey) => removeError(mutationKey),
      onError: (error, mutationKey) => addError(mutationKey, error)
    })]
  });
};
var LineItemActions_default = LineItemActions;

// src/library/components/design-system/line-item/LineItemPanel.tsx
import { jsx as jsx21, jsxs as jsxs15 } from "react/jsx-runtime";
var LineItemPanel = _ref61 => {
  let {
    lineItem,
    showLineItemActions = true,
    children
  } = _ref61;
  return /* @__PURE__ */jsxs15(Panel6, {
    className: "pd:p-6 pd:pt-8",
    children: [showLineItemActions && /* @__PURE__ */jsx21(LineItemActions_default, {
      lineItem
    }), children]
  });
};
var LineItemPanel_default = LineItemPanel;

// src/library/components/design-system/line-item/LineItemTitle.tsx
import { LineItemHelper as LineItemHelper3 } from "@printdeal/ecommerce-helpers";
import { Heading as Heading5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage14, useIntl as useIntl6 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry3 } from "@printdeal/data-layer-manager";
import { Fragment as Fragment6, jsx as jsx22, jsxs as jsxs16 } from "react/jsx-runtime";
var LineItemTitle = _ref62 => {
  let {
    lineItem
  } = _ref62;
  var _a, _b, _c, _d;
  const intl = useIntl6();
  const {
    cart
  } = useCart();
  const localizedProductName = (_a = lineItem.custom) == null ? void 0 : _a.fields.localizedProductName;
  const merchandisingProductName = (_b = lineItem.custom) == null ? void 0 : _b.fields.merchandisingProductName;
  const merchProductURL = (_c = lineItem.custom) == null ? void 0 : _c.fields.merchProductURL;
  const lineItemQuantity = cart ? LineItemHelper3.getLineItemQuantity(cart, lineItem) : void 0;
  const quantity = lineItemQuantity && /* @__PURE__ */jsx22(FormattedMessage14, {
    id: "checkout.lineItem.quantityCount",
    defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
    values: {
      quantity: lineItemQuantity
    }
  });
  const lineItemTitle = /* @__PURE__ */jsxs16(Fragment6, {
    children: [(_d = localizedProductName == null ? void 0 : localizedProductName[intl.locale]) != null ? _d : merchandisingProductName, ",", " ", quantity]
  });
  const isUrlValid = url => {
    try {
      new URL(url);
      return true;
    } catch (error) {
      return false;
    }
  };
  if (merchProductURL && isUrlValid(merchProductURL)) {
    const parsedMerchProductURL = new URL(merchProductURL);
    return /* @__PURE__ */jsx22(Heading5, {
      as: "h3",
      children: /* @__PURE__ */jsx22("a", {
        href: parsedMerchProductURL.href,
        onClick: () => {
          addDataLayerEntry3("click_product");
        },
        children: lineItemTitle
      })
    });
  }
  return /* @__PURE__ */jsx22(Heading5, {
    as: "h3",
    children: lineItemTitle
  });
};
var LineItemTitle_default = LineItemTitle;

// src/library/components/line-item/quote/ExpiredQuoteBadge.tsx
import { Badge, Root } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage15 } from "react-intl";
import { jsx as jsx23 } from "react/jsx-runtime";
var ExpiredQuoteBadge = _ref63 => {
  let {
    lineItemId
  } = _ref63;
  var _a;
  const {
    expiredQuotesError
  } = useCart();
  const isQuoteLineItemExpired = (_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.some(detail => detail.lineItemId === lineItemId);
  return isQuoteLineItemExpired && /* @__PURE__ */jsx23(Root, {
    children: /* @__PURE__ */jsx23(Badge, {
      variant: "error",
      children: /* @__PURE__ */jsx23(FormattedMessage15, {
        id: "cart.messages.expiredQuoteLineItemBadge",
        defaultMessage: "Quote expired"
      })
    })
  });
};
var ExpiredQuoteBadge_default = ExpiredQuoteBadge;

// src/library/components/design-system/line-item/LineItemPrice.tsx
import { Heading as Heading6 } from "@printdeal/ui-library";
import { jsx as jsx24 } from "react/jsx-runtime";
var LineItemPrice = _ref64 => {
  let {
    lineItem
  } = _ref64;
  var _a, _b, _c;
  const {
    cart
  } = useCart();
  const {
    lineItemsTotal
  } = useEntityTotals({
    entity: cart
  });
  const lineItemPrice = lineItemsTotal == null ? void 0 : lineItemsTotal.get(lineItem.id);
  return /* @__PURE__ */jsx24(Heading6, {
    as: "h3",
    children: /* @__PURE__ */jsx24("div", {
      className: "pd:flex",
      children: /* @__PURE__ */jsx24("div", {
        className: "pd:flex pd:items-center pd:gap-2",
        children: /* @__PURE__ */jsx24(Money_default, {
          value: (_b = (_a = lineItemPrice == null ? void 0 : lineItemPrice.product) == null ? void 0 : _a.price.totalGross.centAmount) != null ? _b : 0,
          currency: (_c = lineItemPrice == null ? void 0 : lineItemPrice.product) == null ? void 0 : _c.price.totalGross.currencyCode
        })
      })
    })
  });
};
var LineItemPrice_default = LineItemPrice;

// src/library/components/design-system/line-item/LineItemDescription.tsx
import { getLinkedServices, getAttributeDescription } from "@printdeal/business-logic";
import { FormattedMessage as FormattedMessage16, useIntl as useIntl7 } from "react-intl";
import { EntityHelper as EntityHelper4, LineItemHelper as LineItemHelper5 } from "@printdeal/ecommerce-helpers";
import { Fragment as Fragment7 } from "react";
import { DescriptionList } from "@printdeal/ui-library";
import { Money as Money2 } from "@printdeal/product-selector";

// src/library/helpers/LineItemHelpers.ts
import { EntityHelper as EntityHelper3, LineItemHelper as LineItemHelper4 } from "@printdeal/ecommerce-helpers";
import splitOnFirst from "split-on-first";
function getMCPDocumentReference(lineItem) {
  var _a;
  const mcpDocumentsSource = (_a = lineItem.custom) == null ? void 0 : _a.fields.mcpDocumentsSource;
  const documentReference = mcpDocumentsSource && mcpDocumentsSource[0] && splitOnFirst(mcpDocumentsSource[0], ":")[1];
  return documentReference;
}
function getMCPDocumentReferences(lineItem, entity) {
  var _a, _b, _c;
  if (LineItemHelper4.getLineItemGroupType(lineItem) === "textile") {
    return [{
      documentReference: getMCPDocumentReference(lineItem),
      lineItemNumber: (_a = lineItem.custom) == null ? void 0 : _a.fields.lineItemNumber,
      quantity: lineItem.quantity
    }].filter(reference => reference.documentReference !== void 0);
  }
  if (LineItemHelper4.getLineItemGroupType(lineItem) === "multipleDesigns") {
    const multipleDesignsGroupLineItems = EntityHelper3.getMultipleDesignsGroup(entity, (_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup);
    return multipleDesignsGroupLineItems.map(multipleDesignsGroupLineItem => ({
      documentReference: getMCPDocumentReference(multipleDesignsGroupLineItem),
      lineItemNumber: multipleDesignsGroupLineItem.custom.fields.lineItemNumber,
      quantity: multipleDesignsGroupLineItem.quantity
    })).filter(reference => reference.documentReference !== void 0);
  }
  const documentReference = getMCPDocumentReference(lineItem);
  return documentReference ? [{
    documentReference,
    lineItemNumber: (_c = lineItem.custom) == null ? void 0 : _c.fields.lineItemNumber,
    quantity: lineItem.quantity
  }] : [];
}

// src/library/components/design-system/line-item/LineItemDescription.tsx
import { Fragment as Fragment8, jsx as jsx25, jsxs as jsxs17 } from "react/jsx-runtime";
var LineItemDescription = _ref65 => {
  let {
    lineItem,
    entity
  } = _ref65;
  var _a;
  const {
    locale
  } = useIntl7();
  const localeAbbreviation = new Intl.Locale(locale).language;
  const productDescription = getAttributeDescription(lineItem, localeAbbreviation);
  const descriptionItems = productDescription && productDescription.split(", ").map(attribute => {
    const [attributeName, attributeValue] = attribute.split(": ");
    return {
      attributeName,
      attributeValue
    };
  });
  const mcpDocumentReferences = getMCPDocumentReferences(lineItem, entity);
  const reviewGroupSiblings = (_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroupSiblings;
  return descriptionItems ? /* @__PURE__ */jsxs17(DescriptionList, {
    children: [EntityHelper4.isOrder(entity) && getLinkedServices(lineItem.id, entity).map(service => {
      var _a2;
      return /* @__PURE__ */jsxs17(Fragment7, {
        children: [/* @__PURE__ */jsxs17(DescriptionList.Title, {
          children: [/* @__PURE__ */jsx25(FormattedMessage16, {
            id: "account.order.productDescription.service",
            defaultMessage: "Service"
          }), ":"]
        }), /* @__PURE__ */jsxs17(DescriptionList.Content, {
          children: [(_a2 = service.name[localeAbbreviation]) != null ? _a2 : service.custom.fields.serviceName, " (", /* @__PURE__ */jsx25(Money2, {
            value: service.totalPrice.centAmount,
            currency: service.totalPrice.currencyCode
          }), ")"]
        })]
      }, service.id);
    }), descriptionItems.map(descriptionItem => {
      var _a2, _b;
      return /* @__PURE__ */jsxs17(Fragment7, {
        children: [/* @__PURE__ */jsxs17(DescriptionList.Title, {
          children: [(_b = descriptionItem.attributeName) == null ? void 0 : _b.trim(), ":"]
        }), /* @__PURE__ */jsx25(DescriptionList.Content, {
          children: descriptionItem.attributeValue
        })]
      }, (_a2 = descriptionItem.attributeName) == null ? void 0 : _a2.trim());
    }), LineItemHelper5.isLineItemReviewGroupLead(lineItem) && reviewGroupSiblings && reviewGroupSiblings.length > 0 && /* @__PURE__ */jsxs17(Fragment7, {
      children: [/* @__PURE__ */jsxs17(DescriptionList.Title, {
        children: [/* @__PURE__ */jsx25(FormattedMessage16, {
          id: "checkout.lineItem.reviewGroup",
          defaultMessage: "Included items"
        }), ":"]
      }), /* @__PURE__ */jsx25(DescriptionList.Content, {
        children: reviewGroupSiblings.map(reviewGroupSibling => {
          var _a2;
          const localizedDescription = (_a2 = reviewGroupSibling.custom) == null ? void 0 : _a2.fields.childProductDescription[locale];
          const quantity = reviewGroupSibling.quantity && /* @__PURE__ */jsx25("span", {
            children: /* @__PURE__ */jsx25(FormattedMessage16, {
              id: "checkout.lineItem.quantityCount",
              defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
              values: {
                quantity: reviewGroupSibling.quantity
              }
            })
          });
          return /* @__PURE__ */jsxs17("div", {
            children: [localizedDescription, ",\xA0", quantity]
          }, localizedDescription);
        })
      })]
    }, "review-group-siblings"), LineItemHelper5.getLineItemGroupType(lineItem) === "multipleDesigns" && mcpDocumentReferences.length > 0 && /* @__PURE__ */jsxs17(Fragment8, {
      children: [/* @__PURE__ */jsxs17(DescriptionList.Title, {
        children: [/* @__PURE__ */jsx25(FormattedMessage16, {
          id: "checkout.lineItem.designs",
          defaultMessage: "Designs"
        }), ":"]
      }), /* @__PURE__ */jsx25(DescriptionList.Content, {
        children: mcpDocumentReferences.map((_ref66, index) => {
          let {
            documentReference,
            lineItemNumber,
            quantity
          } = _ref66;
          return /* @__PURE__ */jsxs17("div", {
            children: [EntityHelper4.isOrder(entity) && /* @__PURE__ */jsxs17(Fragment8, {
              children: [/* @__PURE__ */jsx25(FormattedMessage16, {
                id: "checkout.lineItem.design.lineItemNumber",
                defaultMessage: "{lineItemNumber}:",
                values: {
                  lineItemNumber
                }
              }), "\xA0"]
            }), /* @__PURE__ */jsx25(FormattedMessage16, {
              id: "checkout.lineItem.design.quantity",
              defaultMessage: "Design {designNumber}, {quantity} {quantity, plural, one {piece} other {pieces}}",
              values: {
                quantity,
                designNumber: index + 1
              }
            })]
          }, documentReference);
        })
      })]
    })]
  }) : /* @__PURE__ */jsx25("div", {
    className: "pd:text-sm",
    children: productDescription
  });
};
var LineItemDescription_default = LineItemDescription;

// src/library/components/design-system/line-item/LineItemArtwork.tsx
import { useContext as useContext6, useEffect as useEffect10, useState as useState8 } from "react";
import { Button as Button6, Gallery, LinkAsButton as LinkAsButton5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage17 } from "react-intl";
import { PreviewModal } from "@printdeal/previews";
import { mapAttributesToMcpAttributes } from "@printdeal/transformers";
import { hasAlternativelyUploaded, isAlternativeUploadsUrl } from "@printdeal/business-logic";
import { Fragment as Fragment9, jsx as jsx26, jsxs as jsxs18 } from "react/jsx-runtime";
var LineItemArtwork = _ref67 => {
  let {
    lineItem,
    entity
  } = _ref67;
  var _a, _b, _c;
  const {
    CheckoutFileDeliveryButton
  } = useContext6(CheckoutViewContext_default);
  const [isPreviewModalOpen, setIsPreviewModalOpen] = useState8(false);
  const [documentReferenceUrls, setDocumentReferenceUrls] = useState8([]);
  const productVersion = (_a = lineItem.custom) == null ? void 0 : _a.fields.MMProductVersion;
  const productKey = (_c = (_b = lineItem.custom) == null ? void 0 : _b.fields.productKey) != null ? _c : "";
  useEffect10(() => {
    if (hasAlternativelyUploaded(lineItem)) {
      const userUploadsUrl = isAlternativeUploadsUrl(lineItem);
      if (userUploadsUrl === null) {
        throw new Error("User uploads URL not found");
      }
      setDocumentReferenceUrls([userUploadsUrl]);
    } else {
      const artworkUrls = getMCPDocumentReferences(lineItem, entity);
      setDocumentReferenceUrls(artworkUrls.map(_ref68 => {
        let {
          documentReference
        } = _ref68;
        return documentReference;
      }));
    }
  }, [lineItem, entity]);
  if (documentReferenceUrls.length === 0) {
    return null;
  }
  return /* @__PURE__ */jsx26("div", {
    className: "pd:w-48",
    children: /* @__PURE__ */jsx26(Gallery, {
      id: "example",
      secondaryAction: !isAlternativeUploadsUrl(lineItem) && /* @__PURE__ */jsxs18("div", {
        className: "pd:flex pd:gap-2",
        children: [/* @__PURE__ */jsx26(Button6, {
          variant: "white-circle",
          iconBefore: "zoom-plus",
          onClick: () => setIsPreviewModalOpen(true),
          children: /* @__PURE__ */jsx26("span", {
            className: "pd:sr-only",
            children: "Zoom"
          })
        }), documentReferenceUrls.length === 1 && CheckoutFileDeliveryButton && /* @__PURE__ */jsx26(CheckoutFileDeliveryButton, {
          lineItem,
          children: /* @__PURE__ */jsx26(Button6, {
            variant: "white-circle",
            iconAfter: "edit",
            type: "submit"
          })
        })]
      }),
      children: _ref69 => {
        let {
          activeItem,
          totalItems
        } = _ref69;
        var _a2;
        const documentReferenceUrl = documentReferenceUrls[activeItem - 1];
        return /* @__PURE__ */jsxs18(Fragment9, {
          children: [/* @__PURE__ */jsx26(Gallery.Root, {
            children: documentReferenceUrls.map(src => /* @__PURE__ */jsx26(Gallery.Item, {
              children: /* @__PURE__ */jsx26("img", {
                src: isAlternativeUploadsUrl(lineItem) ? src : "https://previews.cimpress.io/v2/preview?documentReferenceUri=".concat(encodeURIComponent(src), "&width=400"),
                alt: "Gallery item",
                className: "pd:cover-parent",
                width: "400",
                height: "400"
              })
            }, src))
          }), documentReferenceUrls.length > 1 && /* @__PURE__ */jsxs18("nav", {
            className: "pd:mt-2 pd:flex pd:justify-between",
            children: [/* @__PURE__ */jsx26(Gallery.Button, {
              as: LinkAsButton5,
              variant: "prev",
              screenReaderLabel: "Previous",
              className: "pd:static pd:translate-y-0"
            }), /* @__PURE__ */jsx26("span", {
              children: /* @__PURE__ */jsx26(FormattedMessage17, {
                id: "checkout.lineItem.designGallery",
                defaultMessage: "<b>Design {activeItem}</b> of {totalItems}",
                values: {
                  // eslint-disable-next-line react/no-unstable-nested-components
                  b: chunks => /* @__PURE__ */jsx26("b", {
                    children: chunks
                  }),
                  activeItem,
                  totalItems
                }
              })
            }), /* @__PURE__ */jsx26(Gallery.Button, {
              as: LinkAsButton5,
              variant: "next",
              screenReaderLabel: "Next",
              className: "pd:static pd:translate-y-0"
            })]
          }), ((_a2 = lineItem.custom) == null ? void 0 : _a2.fields.userSelection) && lineItem.custom.fields.mcpSku && documentReferenceUrl && /* @__PURE__ */jsx26(PreviewModal, {
            isOpen: isPreviewModalOpen,
            setIsOpen: setIsPreviewModalOpen,
            documentReferenceUrl,
            mcpSku: productVersion && productKey ? productKey : lineItem.custom.fields.mcpSku,
            mcpAttributes: mapAttributesToMcpAttributes(lineItem.custom.fields.userSelection)
          })]
        });
      }
    })
  });
};
var LineItemArtwork_default = LineItemArtwork;

// src/library/components/design-system/line-item/LineItemServices.tsx
import { CheckboxGroup, LinkAsButton as LinkAsButton6 } from "@printdeal/ui-library";
import { Money as Money3, SupportArticleModal } from "@printdeal/product-selector";
import { useIntl as useIntl8 } from "react-intl";
import { useState as useState10, Fragment as Fragment10, useEffect as useEffect11, useMemo as useMemo4 } from "react";
import { addDataLayerEntry as addDataLayerEntry4 } from "@printdeal/data-layer-manager";
import { CustomLineItemHelper as CustomLineItemHelper3, EntityHelper as EntityHelper5, LineItemHelper as LineItemHelper6 } from "@printdeal/ecommerce-helpers";

// src/library/queries/line-item/useGetLineItemOptionsQuery.ts
import { useQuery as useQuery4 } from "@tanstack/react-query";
import { useState as useState9 } from "react";
function useGetLineItemOptionsQuery(_ref70) {
  let {
    lineItemId
  } = _ref70;
  const {
    cartId
  } = useCart();
  const [cutOffTime, setCutOffTime] = useState9(null);
  return useQuery4({
    queryKey: ["getShippingOptions" /* getShippingOptions */, lineItemId, cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId || !lineItemId) {
        throw new Error("Cannot get shipping options for a lineitem without a cart id and or line item id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.getLineItemOptions(cartId, lineItemId);
      if (data.cutOffTime) {
        const [hours, minutes, seconds] = data.cutOffTime.split(":").map(time => parseInt(time, 10));
        const cutOffDate = ( /* @__PURE__ */new Date()).setHours(Number(hours), Number(minutes), Number(seconds));
        setCutOffTime(cutOffDate);
      }
      return data;
    }),
    retry: false,
    enabled: Boolean(cartId) && Boolean(lineItemId),
    refetchInterval: cutOffTime ? Math.max(cutOffTime - ( /* @__PURE__ */new Date()).getTime() + 3e4, 0) : false
  });
}

// src/library/components/design-system/line-item/LineItemServices.tsx
import { jsx as jsx27, jsxs as jsxs19 } from "react/jsx-runtime";
var getLineItemId2 = lineItem => {
  var _a, _b;
  return (_b = (_a = lineItem.custom) == null ? void 0 : _a.fields.artworkItemId) != null ? _b : lineItem.id;
};
var LineItemServices = _ref71 => {
  let {
    lineItem
  } = _ref71;
  const intl = useIntl8();
  const {
    cart
  } = useCart();
  const {
    data
  } = useGetLineItemOptionsQuery({
    lineItemId: getLineItemId2(lineItem)
  });
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "editLineItem" /* editLineItem */
  });
  const [selectedServiceKey, setSelectedServiceKey] = useState10(void 0);
  const [supportModalServiceKey, setSupportModalServiceKey] = useState10(void 0);
  const fileServices = useMemo4(() => {
    if (!data) {
      return [];
    }
    return data.services.filter(service => {
      var _a;
      return (_a = service.name) == null ? void 0 : _a.toLowerCase().startsWith("file");
    });
  }, [data]);
  useEffect11(() => {
    var _a;
    if (!cart) {
      setSelectedServiceKey(void 0);
      return;
    }
    const servicesCustomLineItems = CustomLineItemHelper3.getAssociatedCustomLineItems(cart.customLineItems, getLineItemId2(lineItem), "service");
    const fileServiceFromLineItem = servicesCustomLineItems.find(service => {
      var _a2, _b;
      return (_b = (_a2 = service.custom) == null ? void 0 : _a2.fields.serviceName) == null ? void 0 : _b.toLowerCase().startsWith("file");
    });
    setSelectedServiceKey((_a = fileServiceFromLineItem == null ? void 0 : fileServiceFromLineItem.custom) == null ? void 0 : _a.fields.serviceKey);
  }, [cart, lineItem]);
  if (fileServices.length === 0) {
    return null;
  }
  return /* @__PURE__ */jsx27(CheckboxGroup, {
    id: "".concat(lineItem.id, "-services"),
    name: "".concat(lineItem.id, "-services"),
    label: intl.formatMessage({
      id: "services.title",
      defaultMessage: "Extra services"
    }),
    children: fileServices.map(service => /* @__PURE__ */jsxs19(Fragment10, {
      children: [/* @__PURE__ */jsx27(CheckboxGroup.Field, {
        disabled: updateLineItemMutation.isPending,
        checked: selectedServiceKey === service.serviceKey,
        onChange: _ref72 => {
          let {
            target: {
              checked
            }
          } = _ref72;
          const previousServiceKey = selectedServiceKey;
          addDataLayerEntry4("line_item_service_clicked", {
            previousValue: previousServiceKey || void 0,
            newValue: checked ? service.serviceKey : void 0
          });
          setSelectedServiceKey(checked ? service.serviceKey : void 0);
          if (!cart) {
            throw new Error("Attempting to update line item service without a cart");
          }
          let lineItems = [lineItem];
          if (LineItemHelper6.hasLineItemOrchestrationsGroup(lineItem)) {
            lineItems = EntityHelper5.getGroupedLineItems(cart, lineItem.id);
          }
          updateLineItemMutation.mutateAsync({
            lineItemId: getLineItemId2(lineItem),
            payload: {
              editLineItem: lineItems.map(item => ({
                lineItemId: getLineItemId2(item),
                services: checked ? [service.serviceKey] : []
              }))
            }
          }).catch(() => {
            setSelectedServiceKey(previousServiceKey);
          });
        },
        id: "".concat(lineItem.id, "-").concat(service.serviceKey),
        variant: "multiline",
        label: /* @__PURE__ */jsxs19("div", {
          className: "pd:flex pd:gap-2",
          children: [service.displayName[intl.locale], service.prices.totalGross.centAmount > 0 && /* @__PURE__ */jsxs19("span", {
            className: "pd:whitespace-nowrap",
            children: ["(", "+ ", /* @__PURE__ */jsx27(Money3, {
              value: service.prices.totalNet.centAmount,
              currency: service.prices.totalNet.currencyCode
            }), ")"]
          })]
        }),
        secondaryAction: service.supportArticleId && /* @__PURE__ */jsx27(LinkAsButton6, {
          variant: "secondary",
          iconBefore: "info",
          onClick: () => {
            addDataLayerEntry4("line_item_service_support_modal_opened");
            setSupportModalServiceKey(service.serviceKey);
          }
        })
      }), /* @__PURE__ */jsx27(SupportArticleModal, {
        show: supportModalServiceKey === service.serviceKey,
        onClose: () => {
          addDataLayerEntry4("line_item_service_support_modal_closed");
          setSupportModalServiceKey(void 0);
        },
        supportArticleId: service.supportArticleId
      })]
    }, "".concat(lineItem.id, "-").concat(service.serviceKey)))
  });
};
var LineItemServices_default = LineItemServices;

// src/library/components/design-system/checkout/cart-page/CartLineItems.tsx
import { jsx as jsx28, jsxs as jsxs20 } from "react/jsx-runtime";
var CartLineItems = _ref73 => {
  let {
    lineItem
  } = _ref73;
  const {
    cart
  } = useCart();
  if (!cart) {
    return null;
  }
  return /* @__PURE__ */jsx28(LineItemPanel_default, {
    lineItem,
    children: /* @__PURE__ */jsxs20("div", {
      className: "pd:grid pd:gap-3",
      children: [/* @__PURE__ */jsx28(CheckoutDevOnly_default, {
        className: "pd:my-2",
        jsonObject: {
          lineItemId: lineItem.id
        }
      }), /* @__PURE__ */jsxs20("div", {
        className: "pd:flex pd:justify-between pd:gap-4",
        children: [/* @__PURE__ */jsx28(LineItemTitle_default, {
          lineItem
        }), /* @__PURE__ */jsx28(LineItemPrice_default, {
          lineItem
        })]
      }), /* @__PURE__ */jsxs20("div", {
        className: "pd:flex pd:justify-between pd:gap-4",
        children: [/* @__PURE__ */jsxs20("div", {
          className: "pd:grow",
          children: [/* @__PURE__ */jsx28(ExpiredQuoteBadge_default, {
            lineItemId: lineItem.id
          }), /* @__PURE__ */jsx28(LineItemDescription_default, {
            lineItem,
            entity: cart
          })]
        }), /* @__PURE__ */jsx28(LineItemArtwork_default, {
          lineItem,
          entity: cart
        })]
      }), /* @__PURE__ */jsx28(LineItemServices_default, {
        lineItem
      }, lineItem.id)]
    })
  }, lineItem.id);
};
var CartLineItems_default = CartLineItems;

// src/library/components/cart/quote/ExpiredQuotesValidator.tsx
import { Root as Root2 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage18 } from "react-intl";
import { jsx as jsx29 } from "react/jsx-runtime";
var ExpiredQuotesValidator = () => {
  var _a;
  const {
    expiredQuotesError
  } = useCart();
  return ((_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.length) && /* @__PURE__ */jsx29(Root2, {
    children: /* @__PURE__ */jsx29(ErrorAlert_default, {
      exception: void 0,
      children: /* @__PURE__ */jsx29(FormattedMessage18, {
        id: "cart.messages.containsExpiredQuotes",
        defaultMessage: "Your cart contains expired quotes. Please review your cart and remove any expired quotes, before continuing with your order."
      })
    })
  });
};
var ExpiredQuotesValidator_default = ExpiredQuotesValidator;

// src/library/components/design-system/payment-methods/PaymentMethodIconGrid.tsx
import { Brand as Brand2 } from "@printdeal/ui-library";
import { configurationProvider as configurationProvider4 } from "@printdeal/configuration";
import { jsx as jsx30 } from "react/jsx-runtime";
var PaymentMethodIconGrid = () => {
  const defaultPaymentMethods = configurationProvider4.getValueAsArray("DEFAULT_PAYMENT_METHODS");
  if (!defaultPaymentMethods.length) {
    return void 0;
  }
  return /* @__PURE__ */jsx30("div", {
    className: "pd:flex pd:justify-center pd:gap-4",
    children: defaultPaymentMethods.map(paymentMethod => /* @__PURE__ */jsx30(Brand2, {
      brand: paymentMethod,
      className: "pd:h-7"
    }, paymentMethod))
  });
};
var PaymentMethodIconGrid_default = PaymentMethodIconGrid;

// src/library/components/cart/quote/CreateQuoteFromCartButton.tsx
import { useEffect as useEffect12, useMemo as useMemo5 } from "react";
import { LinkAsButton as LinkAsButton7 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage19 } from "react-intl";
import { useAuthentication as useAuthentication5 } from "@printdeal/authentication";
import { addDataLayerEntry as addDataLayerEntry5 } from "@printdeal/data-layer-manager";

// src/library/queries/quote/useCreateQuoteFromCartMutation.ts
import { useMutation as useMutation8 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication4 } from "@printdeal/authentication";

// src/library/http-clients/QuotesHttpClient.ts
import axios4 from "axios";
import { configurationProvider as configurationProvider5 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor3 } from "@printdeal/authentication";
var QuoteHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider5.getValue("QUOTES_API_BASE_URL");
      this.httpClient = axios4.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor3);
    }
    return this.httpClient;
  }
  createQuoteFromCart(payload) {
    return __async(this, null, function* () {
      return this.client.post("/quotes/cart-as-quote", payload);
    });
  }
  getExpiredQuotes(cartId) {
    return __async(this, null, function* () {
      return this.client.get("/quotes/validate-cart/".concat(cartId));
    });
  }
  getQuote(quoteId) {
    return __async(this, null, function* () {
      return this.client.get("quotes/".concat(quoteId));
    });
  }
};
var quoteHttpClient = new QuoteHttpClient();
var QuotesHttpClient_default = quoteHttpClient;

// src/library/queries/quote/useCreateQuoteFromCartMutation.ts
function useCreateQuoteFromCartMutation(_ref74) {
  let {
    onSuccess
  } = _ref74;
  const {
    isUserLoggedIn
  } = useAuthentication4();
  return useMutation8({
    mutationKey: ["create-quote-from-cart"],
    mutationFn: requestData => {
      if (!isUserLoggedIn) {
        throw new Error("Cannot create quote from cart when not logged in");
      }
      return QuotesHttpClient_default.createQuoteFromCart(requestData);
    },
    onSuccess: quoteResponse => {
      if (typeof onSuccess === "function") {
        onSuccess(quoteResponse.data);
      }
    }
  });
}

// src/library/components/cart/quote/CreateQuoteFromCartButton.tsx
import { jsx as jsx31, jsxs as jsxs21 } from "react/jsx-runtime";
var CreateQuoteFromCartButton = _ref75 => {
  let {
    onSuccess
  } = _ref75;
  const {
    cartId
  } = useCart();
  const {
    isCartMutationPending: isCartMutationPending2
  } = useCartVersionMismatchPrevention();
  const createQuoteFromCartMutation = useCreateQuoteFromCartMutation({
    onSuccess
  });
  const {
    decodedToken,
    isUserLoggedIn
  } = useAuthentication5();
  const shouldDisableMutation = useMemo5(() => !cartId || !isUserLoggedIn || isCartMutationPending2 || createQuoteFromCartMutation.isPending, [cartId, isCartMutationPending2, createQuoteFromCartMutation.isPending, isUserLoggedIn]);
  useEffect12(() => {
    if (createQuoteFromCartMutation.isSuccess) {
      addDataLayerEntry5("save_cart");
    }
  }, [createQuoteFromCartMutation.isSuccess]);
  const handleOnClick = event => {
    event.preventDefault();
    if (shouldDisableMutation) {
      return;
    }
    createQuoteFromCartMutation.mutate({
      cartId,
      quoteAcquisitionChannel: {
        source: "launchpad",
        referrer_url: window.location.href,
        // this is the user account id
        source_agent: decodedToken.account.id
      }
    });
  };
  return /* @__PURE__ */jsxs21("div", {
    className: "pd:flex pd:w-full pd:flex-col pd:gap-2",
    children: [createQuoteFromCartMutation.isError && /* @__PURE__ */jsx31(ErrorAlert_default, {
      exception: {
        exception: createQuoteFromCartMutation.error,
        tags: {
          fileLocation: "CreateQuoteFromCartButton",
          featureFunction: "CreateQuoteFromCartButton"
        },
        fingerprint: ["checkout", "create-quote-from-cart"]
      },
      children: /* @__PURE__ */jsx31(FormattedMessage19, {
        id: "cart.messages.createQuoteFailed",
        defaultMessage: "Failed to create quote"
      })
    }), /* @__PURE__ */jsx31(LinkAsButton7, {
      iconBefore: createQuoteFromCartMutation.isPending ? void 0 : "save",
      onClick: handleOnClick,
      variant: "secondary",
      disabled: shouldDisableMutation,
      className: "pd:text-sm",
      isLoading: createQuoteFromCartMutation.isPending,
      children: /* @__PURE__ */jsx31(FormattedMessage19, {
        id: "cart.saveShoppingCartAsQuotation",
        defaultMessage: "Save cart as quote"
      })
    })]
  });
};
var CreateQuoteFromCartButton_default = CreateQuoteFromCartButton;

// src/library/components/design-system/checkout/CheckoutHeading.tsx
import { EntityHelper as EntityHelper6 } from "@printdeal/ecommerce-helpers";
import { Heading as Heading7 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage20 } from "react-intl";
import { jsx as jsx32, jsxs as jsxs22 } from "react/jsx-runtime";
var CheckoutHeading = _ref76 => {
  let {
    pageTitle,
    showTotalProducts = false
  } = _ref76;
  var _a;
  const {
    cart
  } = useCart();
  const {
    entityTotal
  } = useEntityTotals({
    entity: cart
  });
  const cartQuery = useGetCartQuery();
  return /* @__PURE__ */jsxs22("div", {
    className: "pd:mb-5",
    children: [/* @__PURE__ */jsx32(Heading7, {
      as: "h1",
      className: "pd:inline-block",
      children: pageTitle
    }), showTotalProducts && cart && EntityHelper6.getMainLineItems(cart).length > 0 && !cartQuery.isError && /* @__PURE__ */jsxs22("div", {
      className: "pd:ml-4 pd:inline-block pd:text-xs",
      children: ["(", /* @__PURE__ */jsx32(FormattedMessage20, {
        id: "checkout.totalProducts",
        defaultMessage: "{count} {count, plural, one {product} other {products}}",
        values: {
          count: EntityHelper6.getMainLineItems(cart).length
        }
      }), "\xA0\u2014\xA0", /* @__PURE__ */jsx32(Money_default, {
        value: (_a = entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.centAmount) != null ? _a : 0,
        currency: entityTotal == null ? void 0 : entityTotal.totalPrice.totalGross.currencyCode
      }), ")"]
    })]
  });
};
var CheckoutHeading_default = CheckoutHeading;

// src/library/hooks/payment/usePrefetchedPaymentMethodsForCart.ts
import { useQueryClient as useQueryClient2 } from "@tanstack/react-query";
import { useEffect as useEffect13 } from "react";
import { useAuthentication as useAuthentication6 } from "@printdeal/authentication";

// src/library/http-clients/PaymentHttpClient.ts
import axios5 from "axios";
import { configurationProvider as configurationProvider6 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor4 } from "@printdeal/authentication";
var PaymentHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider6.getValue("PAYMENT_V2_API_BASE_URL");
      this.httpClient = axios5.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor4);
    }
    return this.httpClient;
  }
  getPaymentMethodsForCart(cartId) {
    let psp = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "buckaroo";
    return __async(this, null, function* () {
      return this.client.get("/api/payments/methods", {
        params: {
          cartId,
          psp
        },
        headers: {
          // Disable API gateway caching, caching will be done by react query
          "Cache-Control": "max-age=0"
        }
      });
    });
  }
};
var paymentHttpClient = new PaymentHttpClient();
var PaymentHttpClient_default = paymentHttpClient;

// src/library/hooks/payment/usePrefetchedPaymentMethodsForCart.ts
function usePrefetchedPaymentMethodsForCart() {
  const {
    isUserLoggedIn
  } = useAuthentication6();
  const {
    cartId,
    cart
  } = useCart();
  const queryClient = useQueryClient2();
  useEffect13(() => {
    const prefetch = () => __async(this, null, function* () {
      if (isUserLoggedIn && Boolean(cartId)) {
        yield queryClient.prefetchQuery({
          queryKey: ["paymentMethodsForCart", cartId],
          queryFn: () => __async(this, null, function* () {
            if (!cartId) {
              throw new Error("Cannot get payment methods without cartId");
            }
            const {
              data
            } = yield PaymentHttpClient_default.getPaymentMethodsForCart(cartId);
            return data;
          })
        });
      }
    });
    prefetch().catch(() => {});
  }, [isUserLoggedIn, cartId, queryClient, cart == null ? void 0 : cart.totalPrice.centAmount]);
}

// src/library/components/design-system/checkout/cart-page/CartNotifications.tsx
import { FormattedMessage as FormattedMessage21 } from "react-intl";
import { useEffect as useEffect14, useRef as useRef2 } from "react";
import { addDataLayerEntry as addDataLayerEntry6 } from "@printdeal/data-layer-manager";
import { Alert as Alert4 } from "@printdeal/ui-library";
import { Fragment as Fragment11, jsx as jsx33, jsxs as jsxs23 } from "react/jsx-runtime";
var CartNotifications = () => {
  const {
    notifications,
    resetNotifications
  } = useCart();
  const hasMountedLongEnoughToResetNotifications = useRef2(false);
  useEffect14(() => {
    if (notifications.has("retrievedCartDuringLogin" /* retrievedCartDuringLogin */)) {
      addDataLayerEntry6("retrieved_cart_alert");
    }
    if (notifications.has("mergedCartDuringLogin" /* mergedCartDuringLogin */)) {
      addDataLayerEntry6("merged_cart_alert_view");
    }
    const timeout = setTimeout(() => {
      hasMountedLongEnoughToResetNotifications.current = true;
    }, 1e3);
    return () => {
      if (hasMountedLongEnoughToResetNotifications.current) {
        resetNotifications();
      } else {
        clearTimeout(timeout);
      }
    };
  }, [notifications]);
  return /* @__PURE__ */jsxs23(Fragment11, {
    children: [notifications.has("retrievedCartDuringLogin" /* retrievedCartDuringLogin */) && /* @__PURE__ */jsx33(Alert4, {
      variant: "warning",
      isDismissible: true,
      children: /* @__PURE__ */jsx33(FormattedMessage21, {
        id: "cart.notification.retrievedCart",
        defaultMessage: "You still had some products in your cart from your last visit. For easy shopping, these products have been added again."
      })
    }), notifications.has("mergedCartDuringLogin" /* mergedCartDuringLogin */) && /* @__PURE__ */jsx33(Alert4, {
      variant: "warning",
      isDismissible: true,
      children: /* @__PURE__ */jsx33(FormattedMessage21, {
        id: "cart.notification.mergedCart",
        defaultMessage: "You still had some products in your cart from your last visit. We added these to the products currently in your cart."
      })
    })]
  });
};
var CartNotifications_default = CartNotifications;

// src/library/components/design-system/checkout/layout/CheckoutStepper.tsx
import { Stepper as Stepper2 } from "@printdeal/ui-library";
import { useAuthentication as useAuthentication7 } from "@printdeal/authentication";
import { useContext as useContext8 } from "react";
import { FormattedMessage as FormattedMessage22 } from "react-intl";

// src/library/components/design-system/checkout/layout/CheckoutStepperItem.tsx
import { useContext as useContext7 } from "react";
import { LinkAsButton as LinkAsButton8, Stepper } from "@printdeal/ui-library";
import { Fragment as Fragment12, jsx as jsx34, jsxs as jsxs24 } from "react/jsx-runtime";
var CheckoutStepperItem = _ref77 => {
  let {
    children,
    to,
    state,
    active = false,
    completed = false,
    firstItem = false
  } = _ref77;
  const {
    navigate
  } = useContext7(CheckoutViewContext_default);
  const handleClick = () => {
    if (to) {
      navigate(to, {
        state
      }).catch(() => {});
    }
  };
  const completedVariant = completed ? "success" : "default";
  return /* @__PURE__ */jsxs24(Fragment12, {
    children: [!firstItem && /* @__PURE__ */jsx34(Stepper.Edge, {
      variant: completed ? "success" : "default"
    }), /* @__PURE__ */jsx34(LinkAsButton8, {
      onClick: handleClick,
      className: "pd:cursor-pointer",
      children: /* @__PURE__ */jsx34(Stepper.Node, {
        variant: active ? "primary" : completedVariant,
        children: /* @__PURE__ */jsx34("span", {
          children
        })
      })
    })]
  });
};
var CheckoutStepperItem_default = CheckoutStepperItem;

// src/library/components/design-system/checkout/layout/CheckoutStepper.tsx
import { Fragment as Fragment13, jsx as jsx35, jsxs as jsxs25 } from "react/jsx-runtime";
var checkoutSteps = ["cart", "login", "delivery", "paymentMethod"];
var CheckoutStepper = () => {
  const {
    isUserLoggedIn
  } = useAuthentication7();
  const {
    paths,
    location
  } = useContext8(CheckoutViewContext_default);
  const getStepperItemProps = step => {
    const checkoutStepPathMap = {
      cart: "cartPage",
      login: "loginPage",
      delivery: "deliveryPage",
      paymentMethod: "paymentMethodPage"
    };
    const stepPath = paths[checkoutStepPathMap[step]].path;
    const active = location ? location.toLowerCase().includes(stepPath.toLowerCase()) : false;
    const activeStepIndex = checkoutSteps.findIndex(checkoutStep => {
      const {
        path
      } = paths[checkoutStepPathMap[checkoutStep]];
      return location == null ? void 0 : location.toLowerCase().includes(path.toLowerCase());
    });
    const completed = checkoutSteps.indexOf(step) < activeStepIndex || active && step !== "cart";
    if (checkoutSteps.indexOf(step) >= checkoutSteps.indexOf("login") && !isUserLoggedIn) {
      return {
        step,
        active,
        completed,
        to: paths.loginPage.path,
        state: {
          redirectUrl: step === "login" ? paths.cartPage.path : stepPath
        }
      };
    }
    return {
      step,
      active,
      completed,
      to: stepPath
    };
  };
  return /* @__PURE__ */jsx35("div", {
    className: "pd:py-6 pd:max-sm:px-3 pd:sm:grid pd:sm:grid-cols-6",
    children: /* @__PURE__ */jsx35(Stepper2, {
      className: "pd:sm:col-span-4 pd:sm:col-start-2",
      children: /* @__PURE__ */jsxs25(Fragment13, {
        children: [/* @__PURE__ */jsx35(CheckoutStepperItem_default, __spreadProps(__spreadValues({}, getStepperItemProps("cart")), {
          firstItem: true,
          children: /* @__PURE__ */jsx35(FormattedMessage22, {
            id: "checkout.navBar.cart",
            defaultMessage: "Cart"
          })
        })), !isUserLoggedIn && /* @__PURE__ */jsx35(CheckoutStepperItem_default, __spreadProps(__spreadValues({}, getStepperItemProps("login")), {
          children: /* @__PURE__ */jsx35(FormattedMessage22, {
            id: "checkout.navBar.login.personalDetails",
            defaultMessage: "Personal details"
          })
        })), /* @__PURE__ */jsx35(CheckoutStepperItem_default, __spreadProps(__spreadValues({}, getStepperItemProps("delivery")), {
          children: /* @__PURE__ */jsx35(FormattedMessage22, {
            id: "checkout.navBar.delivery",
            defaultMessage: "Delivery"
          })
        })), /* @__PURE__ */jsx35(CheckoutStepperItem_default, __spreadProps(__spreadValues({}, getStepperItemProps("paymentMethod")), {
          children: /* @__PURE__ */jsx35(FormattedMessage22, {
            id: "checkout.navBar.paymentMethod",
            defaultMessage: "Payment method"
          })
        }))]
      })
    })
  });
};
var CheckoutStepper_default = CheckoutStepper;

// src/library/views/CartView.tsx
import { jsx as jsx36, jsxs as jsxs26 } from "react/jsx-runtime";
var CartView = () => {
  const intl = useIntl9();
  const {
    isUserLoggedIn
  } = useAuthentication8();
  const {
    cart: cartObject
  } = useCart();
  const {
    navigate,
    paths
  } = useContext9(CheckoutViewContext_default);
  usePrefetchedPaymentMethodsForCart();
  usePrefetchAddresses();
  useEffect15(() => {
    EcommerceObjectHelper.clearEcommerceObject();
    addDataLayerEntry7("view_cart", EcommerceObjectHelper.createEcommerceObject(cartObject));
  }, [cartObject]);
  return /* @__PURE__ */jsxs26(Container, {
    className: "pd:py-6",
    children: [/* @__PURE__ */jsx36(CheckoutStepper_default, {}), /* @__PURE__ */jsx36(CheckoutHeading_default, {
      pageTitle: intl.formatMessage({
        id: "checkout.cartView.title",
        defaultMessage: "Cart"
      }),
      showTotalProducts: true
    }), /* @__PURE__ */jsx36(CartQuery_default, {
      children: cart => {
        const lineItems = EntityHelper7.getMainGroupedLineItems(cart);
        return /* @__PURE__ */jsxs26("div", {
          className: "pd:grid pd:grid-cols-3 pd:items-start pd:gap-4",
          children: [/* @__PURE__ */jsx36("div", {
            className: "pd:col-span-3 pd:md:col-span-2",
            children: /* @__PURE__ */jsxs26("div", {
              className: "pd:grid pd:gap-4",
              children: [/* @__PURE__ */jsx36(CheckoutDevOnly_default, {
                jsonObject: {
                  cartId: cart.id,
                  cartVersion: cart.version
                }
              }), /* @__PURE__ */jsx36(CartErrorNotifications_default, {
                fileLocation: "CartView.tsx"
              }), /* @__PURE__ */jsx36(CartNotifications_default, {}), /* @__PURE__ */jsx36(ExpiredQuotesValidator_default, {}), /* @__PURE__ */jsx36(Alert5, {
                className: "pd:mb-5",
                children: /* @__PURE__ */jsx36(FormattedMessage23, {
                  id: "checkout.uploadYourFilesAfterPlacingOrder",
                  defaultMessage: "You can upload your missing files after you placed your order."
                })
              }), /* @__PURE__ */jsx36("div", {
                className: "pd:grid pd:gap-10",
                children: lineItems.map(lineItem => /* @__PURE__ */jsx36(CartLineItems_default, {
                  lineItem
                }, lineItem.id))
              })]
            })
          }), /* @__PURE__ */jsxs26("div", {
            className: "pd:sticky pd:top-3 pd:col-span-3 pd:flex pd:flex-col pd:gap-4 pd:md:col-span-1",
            children: [/* @__PURE__ */jsx36("div", {
              className: "pd:order-1 pd:md:order-none",
              children: /* @__PURE__ */jsx36(CheckoutSummary_default, {
                isKiyohEnabled: true,
                nextStepButton: /* @__PURE__ */jsx36(Button7, {
                  className: "pd:w-full",
                  iconAfter: "chevron-right",
                  "data-cy": "nextStepButton",
                  onClick: () => {
                    navigate(paths.deliveryPage.path).catch(() => {});
                    addDataLayerEntry7("cart_next");
                  },
                  children: isUserLoggedIn ? /* @__PURE__ */jsx36(FormattedMessage23, {
                    id: "checkout.nextStepToDelivery",
                    defaultMessage: "To delivery"
                  }) : /* @__PURE__ */jsx36(FormattedMessage23, {
                    id: "checkout.nextStepToLogin",
                    defaultMessage: "To login"
                  })
                })
              })
            }), /* @__PURE__ */jsx36(CheckoutDevOnly_default, {
              className: "pd:order-none pd:md:order-1",
              children: /* @__PURE__ */jsx36(DeleteCartButton_default, {})
            }), isUserLoggedIn && /* @__PURE__ */jsx36(StoreToggle2, {
              id: "drukwerkdeal-nl_printdeal-be",
              children: /* @__PURE__ */jsx36(StoreToggle2.Enabled, {
                children: /* @__PURE__ */jsx36(Panel7, {
                  className: "pd:order-none pd:flex pd:p-4 pd:md:order-1",
                  children: /* @__PURE__ */jsx36(CreateQuoteFromCartButton_default, {
                    onSuccess: _ref78 => {
                      let {
                        quoteId,
                        success
                      } = _ref78;
                      navigate("".concat(paths.accountDashboardPage.path, "/quoting/").concat(quoteId, "?quoteCreated=").concat(success)).catch(() => {});
                    }
                  })
                })
              })
            }), /* @__PURE__ */jsx36("div", {
              className: "pd:order-1",
              children: /* @__PURE__ */jsx36(PaymentMethodIconGrid_default, {})
            })]
          })]
        });
      }
    })]
  });
};
var CartView_default = CartView;

// src/library/components/context-providers/cart/CartProvider.tsx
import { useCallback, useEffect as useEffect16, useMemo as useMemo6, useState as useState11 } from "react";
import { useMutation as useMutation9, useQuery as useQuery6, useQueryClient as useQueryClient3 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication9 } from "@printdeal/authentication";
import { EntityHelper as EntityHelper8 } from "@printdeal/ecommerce-helpers";
import { ErrorManagement as ErrorManagement4 } from "@printdeal/error-management/react";

// src/library/queries/quote/useGetExpiredQuotesQuery.ts
import { useQuery as useQuery5 } from "@tanstack/react-query";
function useGetExpiredQuotesQuery(condition, cartId) {
  return useQuery5({
    queryKey: ["getExpiredQuotes", cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get expired quotes when there is no cart id");
      }
      const {
        data
      } = yield QuotesHttpClient_default.getExpiredQuotes(cartId);
      return data;
    }),
    retry: false,
    enabled: Boolean(cartId) && condition
  });
}

// src/library/components/context-providers/cart/CartProvider.tsx
import { jsx as jsx37 } from "react/jsx-runtime";
var localStorageKey = "cartId";
function getCartIdFromLocalStorage() {
  if (typeof window !== "undefined") {
    return window.localStorage.getItem(localStorageKey) || void 0;
  }
  return void 0;
}
function setCartIdInLocalStorage(cartId) {
  if (typeof window !== "undefined") {
    if (cartId) {
      window.localStorage.setItem(localStorageKey, cartId);
    } else {
      window.localStorage.removeItem(localStorageKey);
    }
  }
}
var CartProvider = _ref79 => {
  let {
    children,
    cartId: cartIdProp
  } = _ref79;
  var _a, _b, _c;
  const authenticationService = useAuthentication9();
  const [errors, setErrors] = useState11( /* @__PURE__ */new Map());
  const [notifications, setNotifications] = useState11( /* @__PURE__ */new Map());
  const [hasQuotes, setHasQuotes] = useState11(false);
  const [lastValidatedCartVersion, setLastValidatedCartVersion] = useState11(void 0);
  const [expiredQuotesError, setExpiredQuotesError] = useState11(void 0);
  const [cartId, setCartIdInState] = useState11(cartIdProp || getCartIdFromLocalStorage());
  const [cartAfterLogin, setCartAfterLogin] = useState11(void 0);
  const queryKey = "getCart" /* getCart */;
  function setCartIdInStateAndLocalStorage(newCartId) {
    setCartIdInState(newCartId);
    setCartIdInLocalStorage(newCartId);
  }
  const addError = (key, error) => {
    setErrors(previousErrors => new Map(previousErrors).set(key, {
      error
    }));
  };
  const removeError = key => {
    setErrors(previousErrors => {
      const newErrors = new Map(previousErrors);
      newErrors.delete(key);
      return newErrors;
    });
  };
  const removeAllErrors = () => {
    setErrors( /* @__PURE__ */new Map());
  };
  const addNotification = key => {
    setNotifications(previousNotifications => new Map(previousNotifications).set(key, true));
  };
  const removeNotification = key => {
    setNotifications(previousNotifications => {
      const newNotifications = new Map(previousNotifications);
      newNotifications.delete(key);
      return newNotifications;
    });
  };
  const resetNotifications = () => {
    setNotifications( /* @__PURE__ */new Map());
  };
  const queryClient = useQueryClient3();
  const cartQuery = useQuery6({
    queryKey: [queryKey, cartId],
    queryFn: () => __async(void 0, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get cart without a cart id");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.getCart(cartId);
      return data;
    }),
    enabled: Boolean(cartId)
  });
  const cartVersion = cartId ? (_a = cartQuery.data) == null ? void 0 : _a.version : void 0;
  const cart = cartId ? cartQuery.data : void 0;
  const invalidateCart = useCallback(() => {
    const execute = () => __async(void 0, null, function* () {
      yield queryClient.invalidateQueries({
        queryKey: [queryKey, cartId]
      });
    });
    execute().catch(() => {});
  }, [queryClient, queryKey, cartId]);
  const setCartData = useCallback(data => {
    queryClient.setQueryData([queryKey, data.id], data);
    setCartIdInStateAndLocalStorage(data.id);
  }, [queryClient, queryKey]);
  const locallyRemoveCart = useCallback(() => {
    setCartIdInStateAndLocalStorage(void 0);
    resetNotifications();
  }, []);
  const recalculateCartMutation = useMutation9({
    mutationKey: ["recalculateCart" /* recalculateCart */],
    mutationFn: id => __async(void 0, null, function* () {
      if (!id) {
        throw new Error("Cart cannot be recalculated without a cartId");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.patchCart(id, {
        action: {
          name: "recalculateCart"
        }
      });
      return data;
    }),
    onMutate: () => {
      removeError("recalculateCart" /* recalculateCart */);
    },
    onSuccess: data => {
      setCartData(data);
    },
    onError: error => {
      addError("recalculateCart" /* recalculateCart */, error);
      ErrorManagement4.exception({
        exception: error,
        tags: {
          fileLocation: "CartProvider",
          featureFunction: "patch-cart-mutation-error"
        },
        fingerprint: ["checkout", "recalculate-cart-mutation-error"]
      });
    }
  });
  const getExpiredQuotes = useGetExpiredQuotesQuery(hasQuotes, cartId);
  useEffect16(() => {
    if (cart) {
      if (EntityHelper8.hasQuoteLineItems(cart) && cartVersion !== lastValidatedCartVersion) {
        setHasQuotes(true);
        setLastValidatedCartVersion(cartVersion);
      } else {
        setHasQuotes(false);
      }
    }
  }, [cart, cartVersion, lastValidatedCartVersion]);
  useEffect16(() => {
    var _a2;
    if (getExpiredQuotes.status === "pending" || getExpiredQuotes.status === "success") {
      setExpiredQuotesError(void 0);
    }
    if (getExpiredQuotes.status === "error") {
      setExpiredQuotesError((_a2 = getExpiredQuotes.error.response) == null ? void 0 : _a2.data);
    }
  }, [(_c = (_b = getExpiredQuotes.error) == null ? void 0 : _b.response) == null ? void 0 : _c.data, getExpiredQuotes.status]);
  useEffect16(() => {
    const unsubscribeFromLogin = authenticationService.onLogin(loginResponseData => {
      if ("cart" in loginResponseData && loginResponseData.cart) {
        setCartAfterLogin(loginResponseData.cart);
      }
    });
    const unsubscribeFromLogout = authenticationService.onLogout(locallyRemoveCart);
    return () => {
      unsubscribeFromLogin();
      unsubscribeFromLogout();
    };
  }, [authenticationService, locallyRemoveCart]);
  useEffect16(() => {
    if (cartAfterLogin) {
      const visibleCartChangeAfterLogin = EntityHelper8.getVisibleCartChangeAfterLogin(cart, cartAfterLogin);
      if (visibleCartChangeAfterLogin === "mergedCart") {
        addNotification("mergedCartDuringLogin" /* mergedCartDuringLogin */);
      } else if (visibleCartChangeAfterLogin === "retrievedCart") {
        addNotification("retrievedCartDuringLogin" /* retrievedCartDuringLogin */);
      }
      setCartData(cartAfterLogin);
      setCartAfterLogin(void 0);
      recalculateCartMutation.mutate(cartAfterLogin.id);
    }
  }, [cart, cartAfterLogin, recalculateCartMutation, setCartData]);
  useEffect16(() => {
    if (typeof window !== "undefined") {
      const handleStorageChange = event => {
        if (event.key === localStorageKey) {
          const newCartId = event.newValue || void 0;
          if (newCartId !== cartId) {
            setCartIdInState(newCartId);
          }
        }
      };
      window.addEventListener("storage", handleStorageChange);
      return () => {
        window.removeEventListener("storage", handleStorageChange);
      };
    }
    return void 0;
  }, [cartId]);
  useEffect16(() => {
    if (authenticationService.isTokenExpired) {
      locallyRemoveCart();
    }
  }, [authenticationService.isTokenExpired, locallyRemoveCart]);
  useEffect16(() => {
    if (cartQuery.error && cartQuery.error.response && cartQuery.error.response.status >= 400 && cartQuery.error.response.status < 500) {
      locallyRemoveCart();
    }
  }, [cartQuery.error, locallyRemoveCart]);
  const contextValue = useMemo6(() => ({
    cartId,
    setCartId: setCartIdInStateAndLocalStorage,
    cart,
    invalidateCart,
    setCartData,
    locallyRemoveCart,
    queries: {
      cartQuery
    },
    errors,
    notifications,
    addError,
    removeError,
    removeAllErrors,
    addNotification,
    removeNotification,
    resetNotifications,
    expiredQuotesError
  }), [cartId, cart, invalidateCart, setCartData, locallyRemoveCart, cartQuery, errors, notifications, expiredQuotesError]);
  return /* @__PURE__ */jsx37(CartContext_default.Provider, {
    value: contextValue,
    children
  });
};
var CartProvider_default = CartProvider;

// src/library/queries/line-item/useReOrderLineItemsMutation.ts
import { useMutation as useMutation10 } from "@tanstack/react-query";
import { AddLineItemHelper as AddLineItemHelper2 } from "@printdeal/ecommerce-helpers";
import { isQuoteLineItem as isQuoteLineItem2 } from "@printdeal/business-logic";
import { nanoid as nanoid2 } from "nanoid";
function useReOrderLineItemsMutation() {
  const mutationKey = "reOrderLineItems" /* reOrderLineItems */;
  const addQuoteToCartMutation = useAddQuoteToCartMutation();
  const addLineItemMutation = useAddLineItemMutation();
  const reAssignGroupIds = lineItems => {
    const groupIds = [];
    const multipleDesignsGroup = /* @__PURE__ */new Set();
    lineItems.forEach(lineItem => {
      var _a, _b;
      if (((_a = lineItem.custom) == null ? void 0 : _a.fields.isReviewGroupLead) === true) {
        groupIds.push({
          oldGroupId: lineItem.custom.fields.reviewGroup,
          newGroupId: nanoid2()
        });
      }
      if (((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup) && !multipleDesignsGroup.has(lineItem.custom.fields.multipleDesignsGroup)) {
        multipleDesignsGroup.add(lineItem.custom.fields.multipleDesignsGroup);
        groupIds.push({
          oldGroupId: lineItem.custom.fields.multipleDesignsGroup,
          newGroupId: nanoid2()
        });
      }
    });
    groupIds.forEach(_ref80 => {
      let {
        oldGroupId,
        newGroupId
      } = _ref80;
      lineItems.forEach(lineItem => {
        var _a, _b;
        if (((_a = lineItem.custom) == null ? void 0 : _a.fields.reviewGroup) && lineItem.custom.fields.reviewGroup === oldGroupId) {
          lineItem.custom.fields.reviewGroup = newGroupId;
          lineItem.custom.fields.fulfillmentGroup = newGroupId;
        }
        if (((_b = lineItem.custom) == null ? void 0 : _b.fields.multipleDesignsGroup) && lineItem.custom.fields.multipleDesignsGroup === oldGroupId) {
          lineItem.custom.fields.fulfillmentGroup = newGroupId;
          lineItem.custom.fields.multipleDesignsGroup = newGroupId;
        }
      });
    });
    return lineItems;
  };
  const splitLineItems = (order, lineItemIds) => {
    const addQuoteLineItemRequestData = [];
    const regularLineItems = [];
    order.lineItems.filter(lineItem => lineItemIds.includes(lineItem.id)).forEach(lineItem => {
      if (isQuoteLineItem2(lineItem)) {
        addQuoteLineItemRequestData.push({
          quoteId: lineItem.custom.fields.quoteId,
          quoteLineItemId: lineItem.custom.fields.quoteLineItemId
        });
      } else {
        regularLineItems.push(lineItem);
      }
    });
    return {
      addQuoteLineItemRequestData,
      regularLineItems
    };
  };
  return useMutation10({
    mutationKey: [mutationKey],
    mutationFn: _0 => __async(this, [_0], function (_ref81) {
      let {
        order,
        lineItemIds,
        withFile,
        artworks
      } = _ref81;
      return function* () {
        if (!lineItemIds.length) {
          throw new Error("At least one line item id should be passed to call this mutation");
        }
        const {
          addQuoteLineItemRequestData,
          regularLineItems
        } = splitLineItems(order, lineItemIds);
        if (regularLineItems.length > 0) {
          const addLineItemPayload = AddLineItemHelper2.buildLineItemShapeFromLineItems({
            orderOrCart: order,
            lineItems: reAssignGroupIds(regularLineItems),
            isReorder: true,
            isWithFile: withFile != null ? withFile : false,
            artworks
          });
          yield addLineItemMutation.mutateAsync(addLineItemPayload);
        }
        if (addQuoteLineItemRequestData.length > 0) {
          yield addQuoteToCartMutation.mutateAsync(addQuoteLineItemRequestData);
        }
      }();
    })
  });
}

// src/library/views/PaymentMethodView.tsx
import { addDataLayerEntry as addDataLayerEntry12 } from "@printdeal/data-layer-manager";
import { useContext as useContext13, useEffect as useEffect23 } from "react";
import { FormattedMessage as FormattedMessage31 } from "react-intl";
import { Container as Container2, Heading as Heading8, Panel as Panel9 } from "@printdeal/ui-library";

// src/library/components/cart/payment-method/PaymentMethodSelector.tsx
import { Alert as Alert6, Badge as Badge2, LoadingModal, Panel as Panel8, RadioGroup, SelectField, Spinner as Spinner4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage24, defineMessages as defineMessages3, useIntl as useIntl10 } from "react-intl";
import { useState as useState12 } from "react";
import { addDataLayerEntry as addDataLayerEntry8 } from "@printdeal/data-layer-manager";
import { EntityHelper as EntityHelper9 } from "@printdeal/ecommerce-helpers";

// src/library/queries/payment-method/useGetPaymentMethodsQuery.ts
import { useQuery as useQuery7 } from "@tanstack/react-query";
function useGetPaymentMethodsQuery() {
  const {
    cartId
  } = useCart();
  return useQuery7({
    queryKey: ["paymentMethodsForCart", cartId],
    queryFn: () => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cannot get payment methods without cartId");
      }
      const {
        data
      } = yield PaymentHttpClient_default.getPaymentMethodsForCart(cartId);
      return data;
    }),
    staleTime: Math.round(15 * 60 * 1e3)
    // 15 minutes
  });
}

// src/library/components/cart/payment-method/PaymentMethodIcon.tsx
import { Brand as Brand3 } from "@printdeal/ui-library";
import { jsx as jsx38 } from "react/jsx-runtime";
var PaymentMethodIcon = _ref82 => {
  let {
    paymentMethodId
  } = _ref82;
  switch (paymentMethodId) {
    case "ideal":
      return /* @__PURE__ */jsx38(Brand3, {
        brand: "ideal",
        className: "pd:h-7"
      });
    case "bcmc":
    case "bcmc_mobile":
      return /* @__PURE__ */jsx38(Brand3, {
        brand: "bancontactmrcash",
        className: "pd:h-7"
      });
    case "creditCard":
      return /* @__PURE__ */jsx38(Brand3, {
        brand: "creditcards",
        className: "pd:h-7"
      });
    case "paypal":
      return /* @__PURE__ */jsx38(Brand3, {
        brand: "paypal",
        className: "pd:h-7"
      });
    case "cartebancaire":
      return /* @__PURE__ */jsx38(Brand3, {
        brand: "cartebancaire",
        className: "pd:h-7"
      });
    default:
      return null;
  }
};
var PaymentMethodIcon_default = PaymentMethodIcon;

// src/library/queries/cart/usePatchCartMutation.ts
import { useMutation as useMutation11 } from "@tanstack/react-query";
import { ErrorManagement as ErrorManagement5 } from "@printdeal/error-management/react";
function usePatchCartMutation(_ref83) {
  let {
    context: {
      mutationKey
    }
  } = _ref83;
  const {
    cartId,
    setCartData
  } = useCart();
  return useMutation11({
    mutationKey: [mutationKey],
    mutationFn: payload => __async(this, null, function* () {
      if (!cartId) {
        throw new Error("Cart cannot be patched without a cartId");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.patchCart(cartId, payload);
      return data;
    }),
    onSuccess: data => {
      setCartData(data);
    },
    onError: error => {
      ErrorManagement5.exception({
        exception: error,
        tags: {
          fileLocation: "usePatchCartMutation",
          featureFunction: "patch-cart-mutation-error"
        },
        fingerprint: ["checkout", "usePatchCartMutation"]
      });
    }
  });
}

// src/library/components/design-system/loading-indicators/ProgressSteps.tsx
import { Icon, Spinner as Spinner3 } from "@printdeal/ui-library";
import { jsx as jsx39, jsxs as jsxs27 } from "react/jsx-runtime";
var ProgressSteps = _ref84 => {
  let {
    steps
  } = _ref84;
  return /* @__PURE__ */jsx39("div", {
    className: "pd:flex pd:flex-col",
    children: steps.map(step => /* @__PURE__ */jsxs27("div", {
      className: "pd:flex pd:items-center pd:gap-2",
      children: [steps.length > 1 && /* @__PURE__ */jsx39("span", {
        children: step.isCompleted ? /* @__PURE__ */jsx39(Icon, {
          size: "sm",
          icon: "check"
        }) : /* @__PURE__ */jsx39(Spinner3, {
          size: "sm"
        })
      }), step.text]
    }))
  });
};
var ProgressSteps_default = ProgressSteps;

// src/library/components/cart/payment-method/PaymentMethodSelector.tsx
import { jsx as jsx40, jsxs as jsxs28 } from "react/jsx-runtime";
var mandateStatusLabels = defineMessages3({
  1: {
    id: "checkout.mandateStatusLabel.1",
    defaultMessage: "Not registered by bank"
  },
  2: {
    id: "checkout.mandateStatusLabel.2",
    defaultMessage: "Incasso failed multiple times"
  },
  3: {
    id: "checkout.mandateStatusLabel.3",
    defaultMessage: "Account is private"
  },
  4: {
    id: "checkout.mandateStatusLabel.4",
    defaultMessage: "Account is blocked"
  },
  5: {
    id: "checkout.mandateStatusLabel.5",
    defaultMessage: "Form was invalid"
  },
  6: {
    id: "checkout.mandateStatusLabel.6",
    defaultMessage: "Revoked by customer"
  },
  7: {
    id: "checkout.mandateStatusLabel.7",
    defaultMessage: "Created"
  },
  8: {
    id: "checkout.mandateStatusLabel.8",
    defaultMessage: "Pending"
  },
  9: {
    id: "checkout.mandateStatusLabel.9",
    defaultMessage: "Approved"
  },
  99: {
    id: "checkout.mandateStatusLabel.99",
    defaultMessage: "Mandate max amount less than order amount."
  }
});
var paymentMethodLabels = defineMessages3({
  mandate: {
    id: "checkout.paymentMethodLabel.mandate",
    defaultMessage: "Mandate"
  },
  creditcard: {
    id: "checkout.paymentMethodLabel.creditcard",
    defaultMessage: "Creditcard"
  },
  onaccount: {
    id: "checkout.paymentMethodLabel.onaccount",
    defaultMessage: "Pay afterwards on account"
  },
  ideal: {
    id: "checkout.paymentMethodLabel.ideal",
    defaultMessage: "iDEAL"
  },
  paypal: {
    id: "checkout.paymentMethodLabel.paypal",
    defaultMessage: "PayPal"
  },
  bcmc: {
    id: "checkout.paymentMethodLabel.bcmc",
    defaultMessage: "Ban Contact Mister Cash"
  },
  bcmc_mobile: {
    id: "checkout.paymentMethodLabel.bcmc_mobile",
    defaultMessage: "Ban Contact Mister Cash mobile"
  }
});
var PaymentMethodSelector = () => {
  var _a, _b, _c, _d, _e, _f, _g;
  const intl = useIntl10();
  const getPaymentMethodsQuery = useGetPaymentMethodsQuery();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setPaymentMethod" /* setPaymentMethod */
    }
  });
  const {
    cart
  } = useCart();
  const paymentOnCart = cart && EntityHelper9.getLastUpdatedPayment(cart);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState12(paymentOnCart == null ? void 0 : paymentOnCart.paymentMethodInfo.method);
  const mandateOnCart = cart && (paymentOnCart == null ? void 0 : paymentOnCart.paymentMethodInfo.method) === "mandate" ? (_a = paymentOnCart.custom) == null ? void 0 : _a.fields.mandateId : void 0;
  const [selectedMandate, setSelectedMandate] = useState12(mandateOnCart);
  const mandatePaymentMethod = (_b = getPaymentMethodsQuery.data) == null ? void 0 : _b.methods.find(paymentMethod => paymentMethod.id === "mandate");
  const handlePaymentMethodChange = (paymentMethodId, mandateId) => {
    if (paymentMethodId === "mandate" && !mandateId) {
      return;
    }
    patchCartMutation.mutate({
      action: {
        name: "setPaymentMethod",
        value: __spreadValues({
          paymentMethodId
        }, mandateId ? {
          mandateId
        } : {})
      }
    });
  };
  return /* @__PURE__ */jsxs28("div", {
    className: "pd:grid pd:gap-4",
    children: [/* @__PURE__ */jsx40(Alert6, {
      variant: "info",
      children: /* @__PURE__ */jsx40(FormattedMessage24, {
        id: "checkout.paymentSectionInfoAlert",
        defaultMessage: "Choose a payment method here. And pay after you have placed your order."
      })
    }), getPaymentMethodsQuery.isLoading && /* @__PURE__ */jsx40("div", {
      className: "pd:flex pd:justify-center",
      children: /* @__PURE__ */jsx40(Spinner4, {
        size: "lg"
      })
    }), (getPaymentMethodsQuery.isError || ((_c = getPaymentMethodsQuery.data) == null ? void 0 : _c.methods.length) === 0) && /* @__PURE__ */jsx40(ErrorAlert_default, {
      exception: {
        exception: getPaymentMethodsQuery.error,
        tags: {
          fileLocation: "PaymentMethodSelector.tsx",
          featureFunction: "getPaymentMethodsQuery"
        },
        extra: {
          defaultMethodId: (_d = getPaymentMethodsQuery.data) == null ? void 0 : _d.default,
          methods: JSON.stringify((_e = getPaymentMethodsQuery.data) == null ? void 0 : _e.methods.map(method => ({
            id: method.id,
            name: method.name
          })))
        },
        fingerprint: ["checkout-frontend", "payment-method-selector", "get-payment-methods-query"]
      },
      children: /* @__PURE__ */jsx40(FormattedMessage24, {
        id: "checkout.errorMessage.errorWhileLoadingPaymentMethods",
        defaultMessage: "An error occurred while loading the payment methods."
      })
    }), patchCartMutation.isError && /* @__PURE__ */jsx40(ErrorAlert_default, {
      exception: {
        exception: patchCartMutation.error,
        tags: {
          fileLocation: "PaymentMethodSelector.tsx",
          featureFunction: "patchCartMutation"
        },
        fingerprint: ["checkout-frontend", "payment-method-selector", "patch-cart-mutation"]
      },
      children: /* @__PURE__ */jsx40(FormattedMessage24, {
        id: "checkout.errorMessage.errorWhileUpdatingPaymentMethod",
        defaultMessage: "An error occurred while updating your payment method."
      })
    }), ((_f = getPaymentMethodsQuery.data) == null ? void 0 : _f.methods.length) && /* @__PURE__ */jsxs28(Panel8, {
      children: [/* @__PURE__ */jsx40(RadioGroup, {
        id: "paymentMethodSelector",
        name: "paymentMethodSelector",
        label: intl.formatMessage({
          id: "checkout.paymentMethodView.title",
          defaultMessage: "Payment method"
        }),
        children: getPaymentMethodsQuery.data.methods.filter(paymentMethod => {
          var _a2;
          return paymentMethod.id !== "mandate" || Boolean((_a2 = paymentMethod.mandates) == null ? void 0 : _a2.length);
        }).map(paymentMethod => {
          const paymentMethodIdLowerCase = paymentMethod.id.toLowerCase();
          return /* @__PURE__ */jsx40(RadioGroup.Field, {
            id: "paymentMethodSelector-".concat(paymentMethod.id),
            value: paymentMethod.id,
            checked: paymentMethod.id === selectedPaymentMethod,
            disabled: patchCartMutation.isPending,
            label: paymentMethodIdLowerCase in paymentMethodLabels ? /* @__PURE__ */jsx40(FormattedMessage24, {
              id: paymentMethodLabels[paymentMethodIdLowerCase].id,
              defaultMessage: paymentMethodLabels[paymentMethodIdLowerCase].defaultMessage
            }) : paymentMethod.name,
            description: /* @__PURE__ */jsx40(PaymentMethodIcon_default, {
              paymentMethodId: paymentMethod.id
            }),
            badge: /* @__PURE__ */jsx40(Badge2, {
              variant: "success-outline",
              children: Number(paymentMethod.costs.centAmount) === 0 ? /* @__PURE__ */jsx40(FormattedMessage24, {
                id: "checkout.priceLabel.free",
                defaultMessage: "Free"
              }) : /* @__PURE__ */jsx40(Money_default, {
                value: Number(paymentMethod.costs.centAmount),
                currency: paymentMethod.costs.currency
              })
            }),
            onChange: () => {
              handlePaymentMethodChange(paymentMethod.id);
              setSelectedPaymentMethod(paymentMethod.id);
              EcommerceObjectHelper.clearEcommerceObject();
              addDataLayerEntry8("add_payment_info", EcommerceObjectHelper.createEcommercePaymentInfoObject(cart, paymentMethod.id));
              addDataLayerEntry8("choose_payment_method", {
                payment_method: paymentMethod.id
              });
            }
          }, paymentMethod.id);
        })
      }), selectedPaymentMethod === "mandate" && /* @__PURE__ */jsx40("div", {
        className: "pd:mt-3",
        children: /* @__PURE__ */jsxs28(SelectField, {
          id: "paymentMethodSelector-mandate",
          name: "paymentMethodSelector_mandate",
          required: true,
          value: selectedMandate,
          onChange: event => {
            handlePaymentMethodChange("mandate", event.target.value || void 0);
            setSelectedMandate(event.target.value || void 0);
          },
          children: [/* @__PURE__ */jsx40(SelectField.Option, {
            value: "",
            children: intl.formatMessage({
              id: "checkout.formPlaceholder.mandate",
              defaultMessage: "Select a mandate"
            })
          }), (_g = mandatePaymentMethod == null ? void 0 : mandatePaymentMethod.mandates) == null ? void 0 : _g.map(mandate => {
            const unusableStatusLabel = !mandate.usable && mandate.statusId in mandateStatusLabels ? " (".concat(intl.formatMessage(mandateStatusLabels[mandate.statusId]), ")") : "";
            return /* @__PURE__ */jsx40(SelectField.Option, {
              value: mandate.id,
              disabled: !mandate.usable,
              children: "".concat(mandate.accountName, " - ").concat(mandate.ibanNumber, " - ").concat(intl.formatMessage({
                id: "checkout.mandate.maxAmountMessage",
                defaultMessage: "Mandate max amount"
              }), ": ").concat(intl.formatNumber(mandate.maxAmount, {
                style: "currency",
                currency: "EUR"
              })).concat(unusableStatusLabel)
            }, mandate.id);
          })]
        })
      })]
    }), /* @__PURE__ */jsx40(LoadingModal, {
      title: "",
      onClose: () => {},
      isOpen: patchCartMutation.isPending,
      children: /* @__PURE__ */jsx40(ProgressSteps_default, {
        steps: [{
          text: /* @__PURE__ */jsx40(FormattedMessage24, {
            id: "checkout.spinnerLabel.updatingPaymentMethod",
            defaultMessage: "Updating your payment method"
          }),
          isCompleted: false
        }]
      })
    })]
  });
};
var PaymentMethodSelector_default = PaymentMethodSelector;

// src/library/components/cart/place-order/PlaceOrderButton.tsx
import { Button as Button8, Link as Link2, LoadingModal as LoadingModal2, Tooltip as Tooltip2 } from "@printdeal/ui-library";
import { useContext as useContext10 } from "react";
import { FormattedMessage as FormattedMessage25, useIntl as useIntl11 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry9 } from "@printdeal/data-layer-manager";
import { ErrorManagement as ErrorManagement6 } from "@printdeal/error-management/react";
import { EntityHelper as EntityHelper10 } from "@printdeal/ecommerce-helpers";

// src/library/queries/cart/usePlaceOrderMutation.ts
import { useMutation as useMutation12 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication10 } from "@printdeal/authentication";
function usePlaceOrderMutation() {
  const {
    isUserLoggedIn
  } = useAuthentication10();
  const {
    cartId
  } = useCart();
  return useMutation12({
    mutationKey: ["placeOrder" /* placeOrder */],
    mutationFn: () => __async(this, null, function* () {
      if (!isUserLoggedIn) {
        throw new Error("Cannot place an order when not logged in");
      }
      if (!cartId) {
        throw new Error("Cannot place an order without cartId");
      }
      const {
        data: order
      } = yield ShoppingCartHttpClient_default.placeOrder(cartId);
      return order;
    }),
    retry: false
  });
}

// src/library/components/cart/place-order/PlaceOrderButton.tsx
import { Fragment as Fragment14, jsx as jsx41, jsxs as jsxs29 } from "react/jsx-runtime";
var PlaceOrderButton = () => {
  const intl = useIntl11();
  const placeOrderMutation = usePlaceOrderMutation();
  const {
    navigate,
    paths
  } = useContext10(CheckoutViewContext_default);
  const {
    cart
  } = useCart();
  const {
    isCartMutationPending: isCartMutationPending2
  } = useCartVersionMismatchPrevention();
  const paymentMethodOnCart = Boolean(cart && EntityHelper10.hasPaymentInfo(cart));
  return /* @__PURE__ */jsxs29(Fragment14, {
    children: [/* @__PURE__ */jsx41(Tooltip2, {
      placement: "top",
      className: "pd:w-full",
      trigger: /* @__PURE__ */jsx41(Button8, {
        as: !paymentMethodOnCart ? Tooltip2.Trigger : "button",
        iconAfter: "chevron-right",
        disabled: !paymentMethodOnCart || isCartMutationPending2,
        className: "pd:w-full",
        onClick: () => {
          placeOrderMutation.mutateAsync().then(data => {
            const order = data;
            EcommerceObjectHelper.clearEcommerceObject();
            addDataLayerEntry9("purchase", EcommerceObjectHelper.createEcommercePurchaseObject(cart, order));
            navigate("".concat(paths.thanksForOrderPage.path, "?itemId=").concat(order.id), {
              state: {
                order
              }
            }).catch(() => {});
          }).catch(() => {
            ErrorManagement6.exception({
              exception: placeOrderMutation.error,
              tags: {
                fileLocation: "PlaceOrderFunctions",
                featureFunction: "placeOrderError"
              },
              fingerprint: ["checkout-place-order-error"]
            });
          });
        },
        "data-cy": "placeOrderButton",
        children: /* @__PURE__ */jsx41(FormattedMessage25, {
          id: "checkout.placeOrderButton",
          defaultMessage: "Place order"
        })
      }),
      children: /* @__PURE__ */jsx41(FormattedMessage25, {
        id: "checkout.selectPaymentMethodBeforePlacingOrder",
        defaultMessage: "Please select a payment method before placing your order."
      })
    }), /* @__PURE__ */jsx41("p", {
      className: "pd:text-xs",
      children: /* @__PURE__ */jsx41(FormattedMessage25, {
        id: "checkout.termsAndConditionsSentence",
        defaultMessage: "By confirming this order I declare that I\\'m authorized to place this order with payment obligation as a private person or representative of the company and I agree with the {termsAndConditionsLink} and upload specifications.",
        description: "Terms and condition sentence in the checkout",
        values: {
          termsAndConditionsLink: /* @__PURE__ */jsx41(Link2, {
            href: intl.formatMessage({
              id: "link.termsAndConditions.url",
              defaultMessage: "/nl/pages/voorwaarden"
            }),
            target: "_blank",
            rel: "noopener noreferrer",
            children: /* @__PURE__ */jsx41(FormattedMessage25, {
              id: "placeOrderMessages.termsAndConditions",
              defaultMessage: "terms and conditions"
            })
          })
        }
      })
    }), /* @__PURE__ */jsx41(LoadingModal2, {
      title: intl.formatMessage({
        id: "checkout.placeOrderProgressTitle",
        defaultMessage: "Thanks for your order!"
      }),
      isOpen: placeOrderMutation.status === "pending",
      onClose: () => {},
      children: /* @__PURE__ */jsx41(FormattedMessage25, {
        id: "checkout.placeOrderProgressSentence",
        defaultMessage: "Your order is now being placed, just wait a little longer..."
      })
    })]
  });
};
var PlaceOrderButton_default = PlaceOrderButton;

// src/library/components/cart/coupon-code/CouponForm.tsx
import { useMemo as useMemo7 } from "react";

// src/library/components/cart/coupon-code/RemoveCouponCodeButton.tsx
import { FormattedMessage as FormattedMessage26 } from "react-intl";
import { LinkAsButton as LinkAsButton9 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry10 } from "@printdeal/data-layer-manager";
import { useEffect as useEffect17 } from "react";
import { jsx as jsx42, jsxs as jsxs30 } from "react/jsx-runtime";
var RemoveCouponCodeButton = _ref85 => {
  let {
    coupons
  } = _ref85;
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "removeCoupon" /* removeCoupon */
    }
  });
  useEffect17(() => {
    if (patchCartMutation.status === "success") {
      addDataLayerEntry10("checkout_coupon_removed");
    }
  }, [patchCartMutation.status]);
  const handleOnClick = coupon => {
    var _a;
    if (!((_a = coupon.discountCode.obj) == null ? void 0 : _a.code)) return;
    patchCartMutation.mutate({
      action: {
        name: "removeCouponCode",
        value: coupon.discountCode.obj.code
      }
    });
  };
  return coupons.map(coupon => {
    var _a, _b;
    return /* @__PURE__ */jsxs30("div", {
      children: [/* @__PURE__ */jsxs30(LinkAsButton9, {
        iconBefore: patchCartMutation.isPending ? void 0 : "trashcan",
        variant: "secondary",
        className: "pd:text-xs",
        onClick: () => handleOnClick(coupon),
        isLoading: patchCartMutation.isPending,
        children: [/* @__PURE__ */jsx42(FormattedMessage26, {
          id: "checkout.removeCoupon.labelText",
          defaultMessage: "Remove coupon"
        }), " ", "(", (_b = coupon.discountCode.obj) == null ? void 0 : _b.code, ")"]
      }), patchCartMutation.isError && /* @__PURE__ */jsx42("div", {
        className: "pd:mt-1 pd:text-xs pd:text-error-500",
        children: /* @__PURE__ */jsx42(FormattedMessage26, {
          id: "checkout.coupon.errorWhileRemovingCoupon",
          defaultMessage: "An unknown error occurred while removing the coupon."
        })
      })]
    }, (_a = coupon.discountCode.obj) == null ? void 0 : _a.code);
  });
};
var RemoveCouponCodeButton_default = RemoveCouponCodeButton;

// src/library/components/cart/coupon-code/AddCouponCodeButton.tsx
import { Button as Button9, TextField } from "@printdeal/ui-library";
import { useEffect as useEffect18, useRef as useRef3 } from "react";
import { FormattedMessage as FormattedMessage27, useIntl as useIntl12 } from "react-intl";
import { useAuthentication as useAuthentication11 } from "@printdeal/authentication";
import { addDataLayerEntry as addDataLayerEntry11 } from "@printdeal/data-layer-manager";
import { Fragment as Fragment15, jsx as jsx43, jsxs as jsxs31 } from "react/jsx-runtime";
function getAddCouponErrorMessage(error, isUserLoggedIn) {
  var _a, _b;
  const errorCode = (_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.error;
  if (errorCode === "DiscountCodeNotEligible") {
    if (isUserLoggedIn) {
      return /* @__PURE__ */jsx43(FormattedMessage27, {
        id: "checkout.coupon.couponCodeNotEligible.loggedInUser",
        defaultMessage: "\n            The entered coupon code could not be applied because our system indicates that you\n            are not eligible for it. The reason for this could be that you have already used\n            the coupon code in the past, the coupon code has already expired, or the coupon code\n            is not available for the account with which you are logged in.\n          "
      });
    }
    return /* @__PURE__ */jsx43(FormattedMessage27, {
      id: "checkout.coupon.couponCodeNotEligible.anonymousUser",
      defaultMessage: "\n          The entered coupon code could not be applied because our system indicates that you\n          are not eligible for it. The reason for this could be that you are not logged in yet.\n          Please try logging in first and then applying your coupon.\n        "
    });
  }
  if (errorCode === "DiscountCodeInvalid") {
    return /* @__PURE__ */jsx43(FormattedMessage27, {
      id: "checkout.coupon.couponCodeInvalid",
      defaultMessage: "The entered coupon code is invalid."
    });
  }
  return /* @__PURE__ */jsx43(FormattedMessage27, {
    id: "checkout.coupon.errorWhileApplyingCoupon",
    defaultMessage: "Oops! We couldn't apply this discount code.{br}Please check if:{br}- the code is entered correctly{br}- the code is still valid{br}- the code hasn't been used before{br}- the code applies to this product or order",
    values: {
      br: /* @__PURE__ */jsx43("br", {})
    }
  });
}
var AddCouponCodeButton = () => {
  const intl = useIntl12();
  const couponRef = useRef3(null);
  const {
    isUserLoggedIn
  } = useAuthentication11();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "addCoupon" /* addCoupon */
    }
  });
  useEffect18(() => {
    if (patchCartMutation.status === "success") {
      addDataLayerEntry11("checkout_coupon_applied");
    }
    if (patchCartMutation.status === "error") {
      addDataLayerEntry11("checkout_error_coupon_field");
    }
  }, [patchCartMutation.status]);
  const handleOnClick = () => {
    var _a;
    const couponCode = (_a = couponRef.current) == null ? void 0 : _a.value.trim();
    if (!couponCode) return;
    patchCartMutation.mutateAsync({
      action: {
        name: "addCouponCode",
        value: couponCode
      }
    }).then(() => {
      addDataLayerEntry11("checkout_accept_coupon_field");
    });
  };
  return /* @__PURE__ */jsxs31(Fragment15, {
    children: [/* @__PURE__ */jsx43(TextField, {
      validation: patchCartMutation.isError ? "error" : void 0,
      validationMessage: patchCartMutation.isError ? getAddCouponErrorMessage(patchCartMutation.error, isUserLoggedIn) : void 0,
      ref: couponRef,
      name: "text-input",
      id: "text-input",
      placeholder: intl.formatMessage({
        id: "checkout.coupon.labelText",
        defaultMessage: "Coupon"
      })
    }), /* @__PURE__ */jsx43(Button9, {
      variant: "secondary",
      size: "md",
      onClick: handleOnClick,
      className: "pd:mt-2 pd:w-full",
      isLoading: patchCartMutation.isPending,
      children: /* @__PURE__ */jsx43(FormattedMessage27, {
        id: "checkout.addCoupon.buttonText",
        defaultMessage: "Apply coupon code"
      })
    })]
  });
};
var AddCouponCodeButton_default = AddCouponCodeButton;

// src/library/components/cart/coupon-code/CouponForm.tsx
import { jsx as jsx44 } from "react/jsx-runtime";
var CouponForm = () => {
  const {
    cart
  } = useCart();
  const coupons = useMemo7(() => cart == null ? void 0 : cart.discountCodes, [cart == null ? void 0 : cart.discountCodes]);
  if (coupons == null ? void 0 : coupons.length) {
    return /* @__PURE__ */jsx44(RemoveCouponCodeButton_default, {
      coupons
    });
  }
  return /* @__PURE__ */jsx44(AddCouponCodeButton_default, {});
};
var CouponForm_default = CouponForm;

// src/library/components/cart/CartReferenceField.tsx
import { useIntl as useIntl13 } from "react-intl";

// src/library/components/DebounceField.tsx
import { Spinner as Spinner5, TextField as TextField2, useDebounce } from "@printdeal/ui-library";
import { useEffect as useEffect19, useState as useState13 } from "react";
import { FormattedMessage as FormattedMessage28 } from "react-intl";
import { jsx as jsx45 } from "react/jsx-runtime";
var DebounceField = _ref86 => {
  let {
    initialValue,
    mutationStatus,
    onUpdate,
    name,
    id,
    label,
    disabled = false
  } = _ref86;
  const [labelData, setLabel] = useState13(initialValue);
  const [validationState, setValidationState] = useState13(void 0);
  const debouncedValue = useDebounce(labelData, 500);
  useEffect19(() => {
    if (debouncedValue !== initialValue) {
      onUpdate(debouncedValue || "");
    }
  }, [debouncedValue]);
  useEffect19(() => {
    if (mutationStatus === "success" || mutationStatus === "error") {
      setValidationState(mutationStatus);
    }
  }, [mutationStatus]);
  return /* @__PURE__ */jsx45(TextField2, {
    name,
    id,
    label,
    disabled,
    value: labelData,
    onChange: event => setLabel(event.target.value.trimStart().replace(/\s{2,}/g, " ")),
    onKeyDown: () => setValidationState(void 0),
    onClick: () => setValidationState(void 0),
    iconAfter: mutationStatus === "pending" ? /* @__PURE__ */jsx45(Spinner5, {
      size: "sm",
      variant: "dim",
      screenReaderLabel: "Saving field..."
    }) : void 0,
    validation: validationState,
    validationMessage: mutationStatus === "error" ? /* @__PURE__ */jsx45(FormattedMessage28, __spreadValues({}, errorMessages.setReferenceLabel)) : void 0
  });
};
var DebounceField_default = DebounceField;

// src/library/components/cart/CartReferenceField.tsx
import { jsx as jsx46 } from "react/jsx-runtime";
var CartReferenceField = _ref87 => {
  let {
    disabled = false
  } = _ref87;
  var _a;
  const intl = useIntl13();
  const {
    cart
  } = useCart();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setReferenceLabel" /* setReferenceLabel */
    }
  });
  const {
    mutate: patchCart
  } = patchCartMutation;
  return /* @__PURE__ */jsx46(DebounceField_default, {
    initialValue: ((_a = cart == null ? void 0 : cart.custom) == null ? void 0 : _a.fields.referenceLabel) || "",
    mutationStatus: patchCartMutation.status,
    onUpdate: value => patchCart({
      action: {
        name: "setReferenceLabel",
        value
      }
    }),
    name: "reference",
    id: "reference",
    label: intl.formatMessage({
      id: "checkout.label.reference",
      defaultMessage: "Reference/Description"
    }),
    disabled
  });
};
var CartReferenceField_default = CartReferenceField;

// src/library/components/cart/CartPoNumberField.tsx
import { useIntl as useIntl14 } from "react-intl";
import { jsx as jsx47 } from "react/jsx-runtime";
var CartPoNumberField = _ref88 => {
  let {
    disabled = false
  } = _ref88;
  var _a;
  const intl = useIntl14();
  const {
    cart
  } = useCart();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setPurchaseorderNumber" /* setPurchaseorderNumber */
    }
  });
  const {
    mutate: patchCart
  } = patchCartMutation;
  return /* @__PURE__ */jsx47(DebounceField_default, {
    initialValue: ((_a = cart == null ? void 0 : cart.custom) == null ? void 0 : _a.fields.PONumber) || "",
    mutationStatus: patchCartMutation.status,
    onUpdate: value => patchCart({
      action: {
        name: "setPurchaseOrderNumber",
        value
      }
    }),
    name: "poNumber",
    id: "poNumber",
    label: intl.formatMessage({
      id: "checkout.label.poNumber",
      defaultMessage: "PO number"
    }),
    disabled
  });
};
var CartPoNumberField_default = CartPoNumberField;

// src/library/components/design-system/checkout/CheckoutKiyohScore.tsx
import { useContext as useContext11 } from "react";
import { FormattedMessage as FormattedMessage29, useIntl as useIntl15 } from "react-intl";
import { Brand as Brand4 } from "@printdeal/ui-library";
import { StoreToggle as StoreToggle3 } from "@printdeal/feature-management/react";
import { jsx as jsx48, jsxs as jsxs32 } from "react/jsx-runtime";
var CheckoutKiyohScore = () => {
  var _a, _b;
  const {
    locale
  } = useIntl15();
  const {
    kiyohScore
  } = useContext11(CheckoutViewContext_default);
  const last12MonthAverageRating = kiyohScore == null ? void 0 : kiyohScore.last12MonthAverageRating;
  const last12MonthNumberReviews = kiyohScore == null ? void 0 : kiyohScore.last12MonthNumberReviews;
  const last12MonthRecommendation = kiyohScore == null ? void 0 : kiyohScore.last12MonthRecommendation;
  const reviewUrl = (_b = (_a = kiyohScore == null ? void 0 : kiyohScore.reviewURLs) == null ? void 0 : _a.find(element => element.locale === locale)) == null ? void 0 : _b.reviewUrl;
  return reviewUrl && last12MonthAverageRating && last12MonthNumberReviews && last12MonthRecommendation ? /* @__PURE__ */jsx48(StoreToggle3, {
    id: "drukwerkdeal-nl_printdeal-be",
    children: /* @__PURE__ */jsx48(StoreToggle3.Enabled, {
      children: /* @__PURE__ */jsxs32("a", {
        href: reviewUrl,
        target: "_blank",
        className: "pd:order-last pd:flex pd:flex-col pd:text-center pd:text-sm",
        rel: "noreferrer",
        children: [/* @__PURE__ */jsx48(Brand4, {
          brand: "kiyoh",
          className: "pd:mb-2 pd:h-16"
        }), /* @__PURE__ */jsxs32("div", {
          children: [/* @__PURE__ */jsx48(FormattedMessage29, {
            id: "checkout.averageKiyohRating",
            defaultMessage: "Average Kiyoh rating"
          }), ":", /* @__PURE__ */jsx48("strong", {
            children: last12MonthAverageRating
          })]
        }), /* @__PURE__ */jsx48("div", {
          children: /* @__PURE__ */jsx48(FormattedMessage29, {
            id: "checkout.numberOfKiyohReviews",
            defaultMessage: "{number} reviews last 12 months",
            values: {
              number: last12MonthNumberReviews
            }
          })
        }), /* @__PURE__ */jsx48("div", {
          children: /* @__PURE__ */jsx48(FormattedMessage29, {
            id: "checkout.kiyohRecommendation",
            defaultMessage: "{percentage}% recommends us",
            values: {
              percentage: last12MonthRecommendation
            }
          })
        })]
      })
    })
  }) : null;
};
var CheckoutKiyohScore_default = CheckoutKiyohScore;

// src/library/hooks/validators/useCartAddressesValidatorHook.ts
import { AddressHelper } from "@printdeal/ecommerce-helpers";
import { useEffect as useEffect20, useState as useState14 } from "react";
import { configurationProvider as configurationProvider7 } from "@printdeal/configuration";
import { defineMessages as defineMessages4, useIntl as useIntl16 } from "react-intl";
var errorMessages2 = defineMessages4({
  incompleteShippingAddress: {
    id: "checkout.incompleteShippingAddress",
    defaultMessage: "Your shipping address(es) are incomplete."
  },
  incompleteBillingAddress: {
    id: "checkout.incompleteBillingAddress",
    defaultMessage: "Your billing address is incomplete."
  },
  invalidShippingCountry: {
    id: "checkout.invalidShippingCountry",
    defaultMessage: "Unfortunately, the country for your shipping address is unavailable."
  },
  invalidBillingCountry: {
    id: "checkout.invalidBillingCountry",
    defaultMessage: "Unfortunately, the country for your billing address is unavailable."
  },
  emailMissingOnBillingAddress: {
    id: "checkout.emailMissingOnBillingAddress",
    defaultMessage: "Your billing address is missing an email address."
  }
});
function useCartAddressesValidatorHook() {
  const intl = useIntl16();
  const {
    cart
  } = useCart();
  const [addressValidation, setAddressValidation] = useState14({
    isBillingAddressValidOnCart: true,
    isShippingAddressValidOnCart: true,
    isBillingAddressCountryValidOnCart: true,
    isShippingAddressCountryValidOnCart: true,
    hasBillingAddressEmailAddress: true
  });
  const getErrors = () => {
    const errors = [];
    const {
      isBillingAddressValidOnCart,
      isShippingAddressValidOnCart,
      isBillingAddressCountryValidOnCart,
      isShippingAddressCountryValidOnCart,
      hasBillingAddressEmailAddress
    } = addressValidation;
    if (!isShippingAddressValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.incompleteShippingAddress));
    } else if (!isShippingAddressCountryValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.invalidShippingCountry));
    }
    if (!isBillingAddressValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.incompleteBillingAddress));
      if (!hasBillingAddressEmailAddress) {
        errors.push(intl.formatMessage(errorMessages2.emailMissingOnBillingAddress));
      }
    } else if (!isBillingAddressCountryValidOnCart) {
      errors.push(intl.formatMessage(errorMessages2.invalidBillingCountry));
    }
    return errors;
  };
  useEffect20(() => {
    var _a;
    if (!cart) return;
    setAddressValidation({
      isBillingAddressValidOnCart: AddressHelper.isBillingAddressValidOnEntity(cart),
      isShippingAddressValidOnCart: AddressHelper.isShippingAddressValidOnEntity(cart),
      isBillingAddressCountryValidOnCart: AddressHelper.isBillingAddressCountryValidOnEntity(cart, configurationProvider7.getValueAsArray("ADDRESS_COUNTRIES")),
      isShippingAddressCountryValidOnCart: AddressHelper.isShippingAddressCountryValidOnEntity(cart, configurationProvider7.getValueAsArray("ADDRESS_COUNTRIES")),
      hasBillingAddressEmailAddress: Boolean((_a = cart.billingAddress) == null ? void 0 : _a.email)
    });
  }, [cart]);
  return {
    areAllAddressesValidOnCart: Object.values(addressValidation).every(isValid => isValid),
    errors: getErrors()
  };
}

// src/library/hooks/validators/useValidateCartRedirectHook.ts
import { useContext as useContext12, useEffect as useEffect21 } from "react";
import { useIsMutating } from "@tanstack/react-query";
function useValidateCartRedirectHook() {
  const {
    cart,
    expiredQuotesError
  } = useCart();
  const {
    navigate,
    paths
  } = useContext12(CheckoutViewContext_default);
  const cartQuery = useGetCartQuery();
  const isPlaceOrderMutating = useIsMutating({
    mutationKey: ["patchCartMutation"],
    status: "pending"
  }) > 0;
  useEffect21(() => {
    var _a;
    if (cartQuery.isLoading || isPlaceOrderMutating) {
      return;
    }
    if (!(cart == null ? void 0 : cart.lineItems.length) || ((_a = expiredQuotesError == null ? void 0 : expiredQuotesError.details) == null ? void 0 : _a.length)) {
      navigate(paths.cartPage.path).catch(() => {});
    }
  }, [cart, expiredQuotesError, cartQuery.status, isPlaceOrderMutating, cartQuery.isLoading, navigate, paths.cartPage.path]);
}

// src/library/components/design-system/payment-methods/CartValidationAlert.tsx
import { Alert as Alert7 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage30 } from "react-intl";

// src/library/hooks/validators/useValidateCartHook.ts
import { useEffect as useEffect22, useState as useState15 } from "react";
import { ValidationHelper } from "@printdeal/ecommerce-helpers";
import { useIntl as useIntl17, defineMessages as defineMessages5 } from "react-intl";
var errorMessages3 = defineMessages5({
  incompleteBillingAddress: {
    id: "checkout.validation.billingAddressIncomplete",
    defaultMessage: "Billing address is incomplete"
  },
  invalidBillingAddressEmail: {
    id: "checkout.validation.billingAddressEmail",
    defaultMessage: "Billing address email is invalid"
  },
  invalidCart: {
    id: "checkout.validation.invalidCart",
    defaultMessage: "Invalid cart: {message}"
  },
  genericError: {
    id: "checkout.validation.genericError",
    defaultMessage: "Invalid Cart!!"
  }
});
function useValidateCartHook() {
  const {
    cart
  } = useCart();
  const [errors, setErrors] = useState15( /* @__PURE__ */new Set());
  const intl = useIntl17();
  useEffect22(() => {
    if (!cart) {
      return;
    }
    ValidationHelper.validateEntity(cart).then(() => {
      setErrors( /* @__PURE__ */new Set());
    }).catch(outcome => {
      if (!outcome.errorMessage) {
        errors.add(intl.formatMessage(errorMessages3.genericError));
      } else {
        outcome.errorMessage.errors.forEach(error => {
          if (error.path.startsWith("billingAddress")) {
            if (error.path.endsWith("email")) {
              errors.add(intl.formatMessage(errorMessages3.invalidBillingAddressEmail));
            } else {
              errors.add(intl.formatMessage(errorMessages3.incompleteBillingAddress));
            }
          } else {
            errors.add(intl.formatMessage(errorMessages3.genericError));
          }
        });
      }
      setErrors(errors);
    });
  }, [cart, errors, intl]);
  return {
    errors
  };
}

// src/library/components/design-system/payment-methods/CartValidationAlert.tsx
import { jsx as jsx49, jsxs as jsxs33 } from "react/jsx-runtime";
var CartValidationAlert = () => {
  const {
    errors
  } = useValidateCartHook();
  return errors.size > 0 && /* @__PURE__ */jsxs33(Alert7, {
    variant: "warning",
    children: [/* @__PURE__ */jsx49(FormattedMessage30, {
      id: "checkout.pleaseReviewValidationErrors",
      defaultMessage: "Please review the following validation errors:"
    }), /* @__PURE__ */jsx49("ul", {
      children: Array.from(errors).map(error => /* @__PURE__ */jsx49("li", {
        children: error
      }, error))
    })]
  });
};
var CartValidationAlert_default = CartValidationAlert;

// src/library/views/PaymentMethodView.tsx
import { jsx as jsx50, jsxs as jsxs34 } from "react/jsx-runtime";
var PaymentMethodView = () => {
  const {
    navigate,
    paths
  } = useContext13(CheckoutViewContext_default);
  const {
    areAllAddressesValidOnCart
  } = useCartAddressesValidatorHook();
  useValidateCartRedirectHook();
  useEffect23(() => {
    if (!areAllAddressesValidOnCart) {
      navigate(paths.deliveryPage.path, {
        state: {
          warningType: "error"
        }
      }).catch(() => {});
    }
  }, [areAllAddressesValidOnCart, navigate, paths.deliveryPage.path]);
  useEffect23(() => {
    addDataLayerEntry12("view_payment_info");
  }, []);
  return /* @__PURE__ */jsxs34(Container2, {
    className: "pd:py-6",
    children: [/* @__PURE__ */jsx50(CheckoutStepper_default, {}), /* @__PURE__ */jsx50(Heading8, {
      as: "h1",
      className: "pd:mb-5",
      children: /* @__PURE__ */jsx50(FormattedMessage31, {
        id: "checkout.paymentMethodView.title",
        defaultMessage: "Payment method"
      })
    }), /* @__PURE__ */jsx50(CartQuery_default, {
      children: cart => /* @__PURE__ */jsxs34("div", {
        className: "pd:grid pd:grid-cols-3 pd:items-start pd:gap-4",
        children: [/* @__PURE__ */jsx50("div", {
          className: "pd:col-span-3 pd:md:col-span-2",
          children: /* @__PURE__ */jsxs34("div", {
            className: "pd:grid pd:gap-4",
            children: [/* @__PURE__ */jsx50(CheckoutDevOnly_default, {
              jsonObject: {
                cartId: cart.id,
                cartVersion: cart.version
              }
            }), /* @__PURE__ */jsx50(CartValidationAlert_default, {}), /* @__PURE__ */jsx50(CartErrorNotifications_default, {
              fileLocation: "PaymentMethodView.tsx"
            }), /* @__PURE__ */jsx50(PaymentMethodSelector_default, {})]
          })
        }), /* @__PURE__ */jsxs34("div", {
          className: "pd:sticky pd:top-3 pd:col-span-3 pd:flex pd:flex-col pd:gap-4 pd:md:col-span-1",
          children: [/* @__PURE__ */jsx50("div", {
            className: "pd:order-1 pd:md:order-none",
            children: /* @__PURE__ */jsx50(CheckoutSummary_default, {
              nextStepButton: /* @__PURE__ */jsx50(PlaceOrderButton_default, {})
            })
          }), /* @__PURE__ */jsx50("div", {
            className: "pd:order-none pd:grid pd:gap-4 pd:md:order-1",
            children: /* @__PURE__ */jsx50(Panel9, {
              children: /* @__PURE__ */jsxs34("div", {
                className: "pd:grid pd:gap-3",
                children: [/* @__PURE__ */jsx50(CouponForm_default, {}), /* @__PURE__ */jsx50(CartReferenceField_default, {}), /* @__PURE__ */jsx50(CartPoNumberField_default, {})]
              })
            })
          }), /* @__PURE__ */jsx50("div", {
            className: "pd:order-last",
            children: /* @__PURE__ */jsx50(CheckoutKiyohScore_default, {})
          })]
        })]
      })
    })]
  });
};
var PaymentMethodView_default = PaymentMethodView;

// src/library/components/context-providers/checkout-view/CheckoutViewProvider.tsx
import { useCallback as useCallback2, useMemo as useMemo8 } from "react";
import { useLocation as useLocation2 } from "@gatsbyjs/reach-router";
import { ErrorManagement as ErrorManagement7 } from "@printdeal/error-management/react";
import { jsx as jsx51 } from "react/jsx-runtime";
var CheckoutViewProvider = _ref89 => {
  let {
    navigate,
    paths,
    location,
    kiyohScore,
    children,
    checkoutFileDeliveryButton,
    customer
  } = _ref89;
  const navigateTo = useCallback2((to, options) => __async(void 0, null, function* () {
    yield navigate(to, options).catch(error => {
      ErrorManagement7.exception({
        exception: error,
        tags: {
          fileLocation: "CheckoutViewProvider",
          featureFunction: "navigateTo"
        },
        fingerprint: ["checkout-view-provider-navigate-to"]
      });
    });
  }), [navigate]);
  const contextValue = useMemo8(() => ({
    navigate: navigateTo,
    useLocation: () => useLocation2(),
    paths,
    location,
    kiyohScore,
    customer,
    // Temporary components and variables from Launchpad
    CheckoutFileDeliveryButton: checkoutFileDeliveryButton
  }), [navigateTo, customer, paths, location, kiyohScore, checkoutFileDeliveryButton]);
  return /* @__PURE__ */jsx51(CheckoutViewContext_default.Provider, {
    value: contextValue,
    children
  });
};
var CheckoutViewProvider_default = CheckoutViewProvider;

// src/library/views/DeliveryView.tsx
import { FormattedMessage as FormattedMessage57 } from "react-intl";
import { Alert as Alert15, Button as Button19, Container as Container3, Heading as Heading15, Panel as Panel11 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry17 } from "@printdeal/data-layer-manager";
import { EntityHelper as EntityHelper12, AddressHelper as AddressHelper2 } from "@printdeal/ecommerce-helpers";
import { useContext as useContext15, useEffect as useEffect32 } from "react";
import { AddressContent as AddressContent3, usePrefetchAddresses as usePrefetchAddresses3 } from "@printdeal/address-frontend";

// src/library/components/design-system/checkout/delivery-page/DeliveryAlerts.tsx
import { Alert as Alert8 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage32 } from "react-intl";
import { useContext as useContext14 } from "react";
import { Fragment as Fragment16, jsx as jsx52, jsxs as jsxs35 } from "react/jsx-runtime";
var DeliveryAlerts = () => {
  var _a, _b, _c;
  const {
    areAllAddressesValidOnCart,
    errors
  } = useCartAddressesValidatorHook();
  const {
    useLocation: useLocation3
  } = useContext14(CheckoutViewContext_default);
  const location = useLocation3();
  return /* @__PURE__ */jsxs35(Fragment16, {
    children: [((_a = location.state) == null ? void 0 : _a.flash) && /* @__PURE__ */jsx52(Alert8, {
      variant: "success",
      isDismissible: true,
      autoDismiss: 5e3,
      children: /* @__PURE__ */jsx52(FormattedMessage32, {
        id: "checkout.registration.successMessage",
        defaultMessage: "Your account has been created!"
      })
    }), !areAllAddressesValidOnCart && /* @__PURE__ */jsxs35(Alert8, {
      variant: (_c = (_b = location.state) == null ? void 0 : _b.warningType) != null ? _c : "warning",
      children: [/* @__PURE__ */jsx52(FormattedMessage32, {
        id: "checkout.pleaseReviewValidationErrors",
        defaultMessage: "Please review the following validation errors:"
      }), /* @__PURE__ */jsx52("ul", {
        children: errors.map(error => /* @__PURE__ */jsx52("li", {
          children: /* @__PURE__ */jsx52("p", {
            children: error
          })
        }, error))
      })]
    })]
  });
};
var DeliveryAlerts_default = DeliveryAlerts;

// src/library/components/design-system/checkout/delivery-page/DeliveryLineItem.tsx
import { LinkAsButton as LinkAsButton15, Transition as Transition2 } from "@printdeal/ui-library";
import { useState as useState24 } from "react";
import { FormattedMessage as FormattedMessage53 } from "react-intl";
import { addDataLayerEntry as addDataLayerEntry16 } from "@printdeal/data-layer-manager";
import { useFeatureToggle } from "@printdeal/feature-management/react";
import { usePrefetchAddresses as usePrefetchAddresses2 } from "@printdeal/address-frontend";
import { configurationProvider as configurationProvider11 } from "@printdeal/configuration";
import { isSpecificOrchestration as isSpecificOrchestration2 } from "@printdeal/business-logic";

// src/library/components/line-item/pickup-point/PickupPointSelector.tsx
import { useEffect as useEffect26, useState as useState17 } from "react";
import { FormattedMessage as FormattedMessage36, useIntl as useIntl21 } from "react-intl";
import { Heading as Heading10, Tooltip as Tooltip3 } from "@printdeal/ui-library";
import { CustomLineItemHelper as CustomLineItemHelper4, LineItemHelper as LineItemHelper8 } from "@printdeal/ecommerce-helpers";

// src/library/components/line-item/pickup-point/PickupPointButton.tsx
import { LinkAsButton as LinkAsButton10 } from "@printdeal/ui-library";
import { hasPickupPoint as isLineItemWithPickupPoint } from "@printdeal/business-logic";
import { FormattedMessage as FormattedMessage33 } from "react-intl";
import { jsx as jsx53 } from "react/jsx-runtime";
var PickupPointButton = _ref90 => {
  let {
    lineItem,
    unavailableReason,
    className,
    onClick
  } = _ref90;
  var _a;
  const lineItemOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  return /* @__PURE__ */jsx53(LinkAsButton10, {
    iconBefore: "truck",
    variant: "secondary",
    className,
    onClick: () => {
      if (unavailableReason !== void 0 || lineItemOptionsQuery.isLoading) {
        return;
      }
      onClick();
    },
    "aria-disabled": Boolean(unavailableReason !== void 0 || lineItemOptionsQuery.isLoading),
    disabled: lineItemOptionsQuery.isLoading,
    isLoading: lineItemOptionsQuery.isLoading,
    children: Boolean(isLineItemWithPickupPoint(lineItem)) || Boolean((_a = lineItem.custom) == null ? void 0 : _a.fields.printdealPickupPoint) ? /* @__PURE__ */jsx53(FormattedMessage33, {
      id: "checkout.changePickupPoint",
      defaultMessage: "Change pickup point"
    }) : /* @__PURE__ */jsx53(FormattedMessage33, {
      id: "checkout.choosePickupPoint",
      defaultMessage: "Choose pickup point"
    })
  });
};
var PickupPointButton_default = PickupPointButton;

// src/library/components/line-item/pickup-point/PickupPointModal.tsx
import { useIntl as useIntl20 } from "react-intl";
import { Modal as Modal2 } from "@printdeal/ui-library";
import { addDataLayerEntry as addDataLayerEntry13 } from "@printdeal/data-layer-manager";
import { configurationProvider as configurationProvider9 } from "@printdeal/configuration";
import { useGetAddressesQuery } from "@printdeal/address-frontend";

// src/library/components/line-item/pickup-point/widget/PickupPointWidget.tsx
import { configurationProvider as configurationProvider8 } from "@printdeal/configuration";
import { APIProvider } from "@vis.gl/react-google-maps";

// src/library/components/line-item/pickup-point/widget/PickupPointWidgetInternal.tsx
import { useMapsLibrary } from "@vis.gl/react-google-maps";
import { useCallback as useCallback3, useEffect as useEffect25, useState as useState16 } from "react";
import { useDebounce as useDebounce2 } from "@printdeal/ui-library";
import { LineItemHelper as LineItemHelper7 } from "@printdeal/ecommerce-helpers";

// src/library/components/line-item/pickup-point/widget/PickupPointMaps.tsx
import { Map as Map2, Marker, useMap } from "@vis.gl/react-google-maps";
import { useEffect as useEffect24 } from "react";
import { useIsMutating as useIsMutating2 } from "@tanstack/react-query";

// src/library/components/line-item/pickup-point/widget/MapStyling.ts
var mapStyling = [{
  featureType: "administrative",
  stylers: [{
    visibility: "on"
  }]
}, {
  featureType: "poi",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.attraction",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.business",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.government",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.medical",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.medical",
  elementType: "geometry",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.park",
  elementType: "labels.text",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.place_of_worship",
  elementType: "geometry",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.school",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "poi.sports_complex",
  elementType: "labels.icon",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "transit",
  stylers: [{
    visibility: "off"
  }]
}, {
  featureType: "water",
  elementType: "labels.text",
  stylers: [{
    visibility: "off"
  }]
}];
var MapStyling_default = mapStyling;

// src/library/components/line-item/pickup-point/widget/PickupPointMaps.tsx
import { jsx as jsx54 } from "react/jsx-runtime";
var PickupPointMaps = _ref91 => {
  let {
    pickupPoints,
    focusedPickupPointId,
    onClickMarker
  } = _ref91;
  const map = useMap("pickup-points-map");
  const updateLineItemMutating = useIsMutating2({
    mutationKey: ["updateLineItem" /* updateLineItem */, "setPickupPoint" /* setPickupPoint */],
    exact: true,
    status: "pending"
  });
  useEffect24(() => {
    if (pickupPoints) {
      const bounds = new google.maps.LatLngBounds();
      pickupPoints.forEach(_ref92 => {
        let {
          pickupPoint
        } = _ref92;
        if (pickupPoint.pickupPointsProviderId === "pup:providers:keep-at-plant-nl") {
          return;
        }
        bounds.extend({
          lat: pickupPoint.geoCoordinates.latitude,
          lng: pickupPoint.geoCoordinates.longitude
        });
      });
      pickupPoints.filter(_ref93 => {
        let {
          pickupPoint
        } = _ref93;
        return pickupPoint.pickupPointsProviderId === "pup:providers:keep-at-plant-nl";
      }).forEach(_ref94 => {
        let {
          pickupPoint
        } = _ref94;
        if (bounds.contains({
          lat: pickupPoint.geoCoordinates.latitude,
          lng: pickupPoint.geoCoordinates.longitude
        })) {
          bounds.extend({
            lat: pickupPoint.geoCoordinates.latitude,
            lng: pickupPoint.geoCoordinates.longitude
          });
        }
      });
      if (map) {
        map.fitBounds(bounds);
      }
    }
  }, [pickupPoints, map]);
  return /* @__PURE__ */jsx54(Map2, {
    id: "pickup-points-map",
    gestureHandling: "greedy",
    disableDefaultUI: true,
    zoomControl: true,
    styles: MapStyling_default,
    children: pickupPoints && pickupPoints.map(_ref95 => {
      let {
        pickupPoint
      } = _ref95;
      return /* @__PURE__ */jsx54(Marker, {
        position: {
          lat: pickupPoint.geoCoordinates.latitude,
          lng: pickupPoint.geoCoordinates.longitude
        },
        icon: {
          path: "M0-48c-9.8 0-17.7 7.8-17.7 17.4 0 15.5 17.7 30.6 17.7 30.6s17.7-15.4 17.7-30.6c0-9.6-7.9-17.4-17.7-17.4z",
          fillColor: focusedPickupPointId === pickupPoint.id ? "#262626" : "#ff7600",
          fillOpacity: 1,
          strokeWeight: 0,
          scale: focusedPickupPointId === pickupPoint.id ? 0.65 : 0.5
        },
        zIndex: focusedPickupPointId === pickupPoint.id ? 1 : 0,
        onClick: () => {
          if (updateLineItemMutating === 0) {
            onClickMarker(pickupPoint.id);
          }
        }
      }, pickupPoint.id);
    })
  });
};
var PickupPointMaps_default = PickupPointMaps;

// src/library/components/line-item/pickup-point/widget/PickupPointList.tsx
import { Spinner as Spinner6, TextInput } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage35, useIntl as useIntl19 } from "react-intl";

// src/library/components/line-item/pickup-point/widget/PickupPointPanel.tsx
import { Brand as Brand5, Button as Button10, DescriptionList as DescriptionList2, Heading as Heading9, Icon as Icon2, Panel as Panel10 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage34, defineMessages as defineMessages6, useIntl as useIntl18 } from "react-intl";
import { Fragment as Fragment17 } from "react";
import { useIsMutating as useIsMutating3 } from "@tanstack/react-query";
import clsx from "clsx";
import { Fragment as Fragment18, jsx as jsx55, jsxs as jsxs36 } from "react/jsx-runtime";
var DaysOfTheWeek = /* @__PURE__ */(DaysOfTheWeek2 => {
  DaysOfTheWeek2["MONDAY"] = "monday";
  DaysOfTheWeek2["TUESDAY"] = "tuesday";
  DaysOfTheWeek2["WEDNESDAY"] = "wednesday";
  DaysOfTheWeek2["THURSDAY"] = "thursday";
  DaysOfTheWeek2["FRIDAY"] = "friday";
  DaysOfTheWeek2["SATURDAY"] = "saturday";
  DaysOfTheWeek2["SUNDAY"] = "sunday";
  return DaysOfTheWeek2;
})(DaysOfTheWeek || {});
var PickupPointPanel = _ref96 => {
  let {
    pickupPointResult,
    focusedPickupPointId,
    onClickPanel,
    onSubmit
  } = _ref96;
  const intl = useIntl18();
  const updateLineItemMutating = useIsMutating3({
    mutationKey: ["updateLineItem" /* updateLineItem */, "setPickupPoint" /* setPickupPoint */],
    exact: true,
    status: "pending"
  });
  const {
    pickupPoint,
    distance
  } = pickupPointResult;
  const translatedDaysOfTheWeek = defineMessages6({
    ["monday" /* MONDAY */]: {
      id: "checkout.pickupPoint.monday",
      defaultMessage: "Monday"
    },
    ["tuesday" /* TUESDAY */]: {
      id: "checkout.pickupPoint.tuesday",
      defaultMessage: "Tuesday"
    },
    ["wednesday" /* WEDNESDAY */]: {
      id: "checkout.pickupPoint.wednesday",
      defaultMessage: "Wednesday"
    },
    ["thursday" /* THURSDAY */]: {
      id: "checkout.pickupPoint.thursday",
      defaultMessage: "Thursday"
    },
    ["friday" /* FRIDAY */]: {
      id: "checkout.pickupPoint.friday",
      defaultMessage: "Friday"
    },
    ["saturday" /* SATURDAY */]: {
      id: "checkout.pickupPoint.saturday",
      defaultMessage: "Saturday"
    },
    ["sunday" /* SUNDAY */]: {
      id: "checkout.pickupPoint.sunday",
      defaultMessage: "Sunday"
    }
  });
  const getPickupPointProviderImage = () => {
    switch (pickupPointResult.pickupPoint.pickupPointsProviderId) {
      case "pup:providers:postnl":
        return /* @__PURE__ */jsx55(Brand5, {
          brand: "postnl",
          className: "pd:h-14"
        });
      case "pup:providers:dhl":
        return /* @__PURE__ */jsx55(Brand5, {
          brand: "dhl",
          className: "pd:h-14"
        });
      case "pup:providers:keep-at-plant-nl":
      case "pup:providers:printdeal-pickup-point":
        return /* @__PURE__ */jsx55(Brand5, {
          brand: "printdeal-logo-mark",
          className: "pd:h-14"
        });
      default:
        return /* @__PURE__ */jsx55(Icon2, {
          icon: "truck",
          size: "2xl"
        });
    }
  };
  const getOpeningHours = businessHours => {
    const opening = businessHours == null ? void 0 : businessHours.opening;
    const closing = businessHours == null ? void 0 : businessHours.closing;
    if (opening === "00:00" && (closing === "23:59" || closing === "00:00")) {
      return intl.formatMessage({
        id: "checkout.pickupPoint.open24Hours",
        defaultMessage: "Open 24 hours"
      });
    }
    if (opening && closing) {
      return "".concat(opening, " - ").concat(closing);
    }
    return intl.formatMessage({
      id: "checkout.pickupPoint.closed",
      defaultMessage: "Closed"
    });
  };
  return /* @__PURE__ */jsxs36(Panel10, {
    className: clsx("pd:w-full pd:p-4", {
      "pd:cursor-pointer": focusedPickupPointId !== pickupPoint.id
    }),
    onClick: () => {
      if (updateLineItemMutating === 0 && focusedPickupPointId !== pickupPoint.id) {
        onClickPanel(pickupPoint.id);
      }
    },
    children: [/* @__PURE__ */jsxs36("div", {
      className: clsx("pd:grid pd:grid-cols-4 pd:gap-2", {
        "pd:cursor-pointer": focusedPickupPointId === pickupPoint.id
      }),
      children: [/* @__PURE__ */jsx55("div", {
        className: "pd:flex pd:items-center pd:justify-center",
        children: getPickupPointProviderImage()
      }), /* @__PURE__ */jsxs36("div", {
        className: "pd:col-span-3 pd:flex pd:w-full pd:flex-col pd:justify-center pd:gap-1",
        children: [/* @__PURE__ */jsx55(Heading9, {
          variant: "display",
          size: "3",
          children: pickupPoint.name
        }), /* @__PURE__ */jsxs36("div", {
          className: "pd:flex pd:justify-between pd:pr-2",
          children: [/* @__PURE__ */jsx55("p", {
            className: "pd:text-xs",
            children: pickupPoint.address.addressLine1
          }), distance && /* @__PURE__ */jsx55("div", {
            className: "pd:whitespace-nowrap pd:text-xs pd:font-semibold pd:text-dim-600",
            children: distance < 1 ? "".concat(Math.round(distance * 1e3), " m") : "".concat(distance.toFixed(1), " km")
          })]
        })]
      })]
    }), focusedPickupPointId === pickupPoint.id && /* @__PURE__ */jsxs36(Fragment18, {
      children: [/* @__PURE__ */jsxs36("div", {
        className: "pd:mt-4 pd:px-4",
        children: [/* @__PURE__ */jsx55("span", {
          className: "pd:text-sm pd:font-semibold",
          children: /* @__PURE__ */jsx55(FormattedMessage34, {
            id: "checkout.pickupPoint.openingHours",
            defaultMessage: "Opening hours"
          })
        }), /* @__PURE__ */jsx55(DescriptionList2, {
          className: "pd:gap-1",
          children: Object.values(DaysOfTheWeek).map(dayOfTheWeek => {
            var _a;
            return /* @__PURE__ */jsxs36(Fragment17, {
              children: [/* @__PURE__ */jsx55(DescriptionList2.Title, {
                className: "pd:mr-3 pd:text-sm pd:font-normal pd:text-dim-800",
                children: /* @__PURE__ */jsx55(FormattedMessage34, __spreadValues({}, translatedDaysOfTheWeek[dayOfTheWeek]))
              }), /* @__PURE__ */jsx55(DescriptionList2.Content, {
                className: "pd:text-sm",
                children: getOpeningHours((_a = pickupPoint.businessHours) == null ? void 0 : _a[dayOfTheWeek])
              })]
            }, dayOfTheWeek);
          })
        })]
      }), /* @__PURE__ */jsx55("div", {
        className: "pd:p-2 pd:pt-4",
        children: /* @__PURE__ */jsx55(Button10, {
          className: "pd:w-full",
          onClick: event => {
            event.stopPropagation();
            onSubmit(pickupPointResult);
          },
          isLoading: updateLineItemMutating > 0,
          disabled: updateLineItemMutating > 0,
          children: /* @__PURE__ */jsx55(FormattedMessage34, {
            id: "checkout.pickupPoint.select",
            defaultMessage: "Select pickup point"
          })
        })
      })]
    })]
  });
};
var PickupPointPanel_default = PickupPointPanel;

// src/library/components/line-item/pickup-point/widget/PickupPointList.tsx
import { Fragment as Fragment19, jsx as jsx56, jsxs as jsxs37 } from "react/jsx-runtime";
var PickupPointList = _ref97 => {
  let {
    pickupPointsQuery,
    focusedPickupPointId,
    searchAddress,
    setSearchAddress,
    onClickPanel,
    onSubmit
  } = _ref97;
  var _a;
  const intl = useIntl19();
  return /* @__PURE__ */jsxs37(Fragment19, {
    children: [/* @__PURE__ */jsx56(TextInput, {
      iconAfter: "search",
      className: "pd:mb-2 pd:w-full",
      defaultValue: searchAddress,
      placeholder: intl.formatMessage({
        id: "checkout.searchPickupPoint",
        defaultMessage: "Search by address or city"
      }),
      onChange: event => {
        setSearchAddress(event.target.value);
      }
    }), /* @__PURE__ */jsxs37("div", {
      className: "pd:flex pd:h-[60vh] pd:flex-col pd:gap-2 pd:overflow-x-hidden pd:overflow-y-scroll",
      children: [pickupPointsQuery.isLoading && /* @__PURE__ */jsx56("div", {
        className: "pd:flex pd:h-full pd:items-center pd:justify-center",
        children: /* @__PURE__ */jsx56(Spinner6, {
          size: "lg"
        })
      }), pickupPointsQuery.isError && /* @__PURE__ */jsx56(ErrorAlert_default, {
        exception: {
          exception: pickupPointsQuery.error,
          tags: {
            fileLocation: "PickupPointList.tsx",
            featureFunction: "pickupPointsQuery"
          },
          fingerprint: ["checkout-frontend", "pickup-point-widget"]
        },
        children: /* @__PURE__ */jsx56(FormattedMessage35, {
          id: "checkout.pickupPoint.error",
          defaultMessage: "Something went wrong while loading the pickup points."
        })
      }), (_a = pickupPointsQuery.data) == null ? void 0 : _a.sort((a, b) => {
        if (a.distance && b.distance) {
          return a.distance - b.distance;
        }
        return 0;
      }).map(pickupPointResult => /* @__PURE__ */jsx56(ScrollIntoView_default, {
        scrollIntoView: focusedPickupPointId === pickupPointResult.pickupPoint.id,
        scrollIntoViewOptions: {
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        },
        children: /* @__PURE__ */jsx56(PickupPointPanel_default, {
          pickupPointResult,
          focusedPickupPointId,
          onClickPanel,
          onSubmit
        })
      }, pickupPointResult.pickupPoint.id))]
    })]
  });
};
var PickupPointList_default = PickupPointList;

// src/library/queries/line-item/useSearchPickupPointsQuery.ts
import { useQuery as useQuery8 } from "@tanstack/react-query";
import { useAuthentication as useAuthentication12 } from "@printdeal/authentication";
function useSearchPickupPointsQuery(_ref98) {
  let {
    lineItemId,
    latitude,
    longitude
  } = _ref98;
  const {
    isUserLoggedIn
  } = useAuthentication12();
  const {
    cartId
  } = useCart();
  return useQuery8({
    queryKey: ["search-pickup-points", cartId, lineItemId, latitude, longitude],
    queryFn: () => __async(this, null, function* () {
      if (!cartId || !lineItemId) {
        throw new Error("CartId or lineItemId is not defined");
      }
      if (!latitude || !longitude) {
        throw new Error("Latitude or longitude is not defined");
      }
      const {
        data
      } = yield ShoppingCartHttpClient_default.searchPickupPoints(cartId, lineItemId, {
        action: {
          name: "searchPickupPoints",
          value: {
            latitude,
            longitude
          }
        }
      });
      return data;
    }),
    retry: false,
    enabled: isUserLoggedIn && Boolean(cartId) && Boolean(lineItemId) && Boolean(latitude) && Boolean(longitude)
  });
}

// src/library/components/line-item/pickup-point/widget/PickupPointWidgetInternal.tsx
import { jsx as jsx57, jsxs as jsxs38 } from "react/jsx-runtime";
var PickupPointWidgetInternal = _ref99 => {
  let {
    lineItem,
    customerAddress,
    fallbackAddress,
    onPickupPointClick,
    onPickupPointSelection
  } = _ref99;
  const pickupPointId = LineItemHelper7.getLineItemPickupPointId(lineItem);
  const pickupPointQuery = useGetPickupPointQuery({
    pickupPointId
  });
  const [geocoordinates, setGeocoordinates] = useState16(null);
  const [focusedPickupPointId, setFocusedPickupPointId] = useState16(pickupPointId);
  const [searchAddress, setSearchAddress] = useState16();
  const debouncedSearchAddress = useDebounce2(searchAddress, 500);
  const geocodingLibrary = useMapsLibrary("geocoding");
  const pickupPointsQuery = useSearchPickupPointsQuery({
    lineItemId: lineItem.id,
    latitude: geocoordinates == null ? void 0 : geocoordinates.latitude,
    longitude: geocoordinates == null ? void 0 : geocoordinates.longitude
  });
  const geocodeAddress = useCallback3(address => __async(void 0, null, function* () {
    if (!geocodingLibrary) {
      throw new Error("Geocoding library not loaded");
    }
    const geoCoder = new geocodingLibrary.Geocoder();
    const geocode = function (addressLine) {
      let retry = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      return __async(void 0, null, function* () {
        yield geoCoder.geocode({
          address: addressLine
        }).then(_ref100 => {
          let {
            results
          } = _ref100;
          const result = results.length > 0 ? results.shift() : void 0;
          if (result) {
            const {
              geometry: {
                location
              },
              formatted_address: formattedAddress
            } = result;
            setGeocoordinates({
              latitude: location.lat(),
              longitude: location.lng()
            });
            if (!debouncedSearchAddress) {
              setSearchAddress(formattedAddress);
            }
          }
        }).catch(() => __async(void 0, null, function* () {
          if (retry) {
            yield geocode("".concat(fallbackAddress.postalCode, " ").concat(fallbackAddress.country), false);
          } else {
            throw new Error("Geocoding failed");
          }
        }));
      });
    };
    yield geocode(address);
  }), [geocodingLibrary, fallbackAddress, debouncedSearchAddress]);
  useEffect25(() => {
    const execute = () => __async(void 0, null, function* () {
      if (!geocodingLibrary) return;
      if (!pickupPointId) {
        const address = debouncedSearchAddress || "".concat(customerAddress.postalCode, " ").concat(customerAddress.country);
        yield geocodeAddress(address);
        return;
      }
      if (pickupPointQuery.data) {
        yield geocodeAddress("".concat(pickupPointQuery.data.address.postalCode, " ").concat(pickupPointQuery.data.address.countryCode));
      }
    });
    execute().catch(() => {});
  }, [geocodingLibrary, customerAddress, debouncedSearchAddress, pickupPointQuery.data, pickupPointId, geocodeAddress]);
  return /* @__PURE__ */jsxs38("div", {
    className: "pd:grid pd:grid-cols-5 pd:md:gap-4",
    children: [/* @__PURE__ */jsx57("div", {
      className: "pd:col-span-5 pd:md:col-span-2",
      children: /* @__PURE__ */jsx57(PickupPointList_default, {
        pickupPointsQuery,
        focusedPickupPointId,
        searchAddress: debouncedSearchAddress,
        setSearchAddress,
        onClickPanel: id => {
          setFocusedPickupPointId(id);
          onPickupPointClick();
        },
        onSubmit: selectedPickupPoint => onPickupPointSelection(selectedPickupPoint)
      })
    }), /* @__PURE__ */jsx57("div", {
      className: "pd:col-span-3 pd:overflow-hidden pd:rounded-md",
      children: /* @__PURE__ */jsx57(PickupPointMaps_default, {
        pickupPoints: pickupPointsQuery.data,
        focusedPickupPointId,
        onClickMarker: id => {
          setFocusedPickupPointId(id);
          onPickupPointClick();
        }
      })
    })]
  });
};
var PickupPointWidgetInternal_default = PickupPointWidgetInternal;

// src/library/components/line-item/pickup-point/widget/PickupPointWidget.tsx
import { jsx as jsx58 } from "react/jsx-runtime";
var PickupPointWidget = props => /* @__PURE__ */jsx58(APIProvider, {
  apiKey: configurationProvider8.getValue("GOOGLE_MAPS_API_KEY"),
  children: /* @__PURE__ */jsx58(PickupPointWidgetInternal_default, __spreadValues({}, props))
});
var PickupPointWidget_default = PickupPointWidget;

// src/library/components/line-item/pickup-point/PickupPointModal.tsx
import { jsx as jsx59, jsxs as jsxs39 } from "react/jsx-runtime";
var PickupPointModal = _ref101 => {
  let {
    lineItem,
    isOpen,
    onClose
  } = _ref101;
  var _a, _b;
  const intl = useIntl20();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "setPickupPoint" /* setPickupPoint */
  });
  const customerAddresses = useGetAddressesQuery();
  const customerDefaultShippingAddress = (_a = customerAddresses.data) == null ? void 0 : _a.addresses.find(address => address.isDefaultShippingAddress);
  const customerDefaultBillingAddress = (_b = customerAddresses.data) == null ? void 0 : _b.addresses.find(address => address.isDefaultBillingAddress);
  const pickupPointDataLayerEvent = action => {
    addDataLayerEntry13(action);
  };
  return /* @__PURE__ */jsx59(Modal2, {
    onClose: () => onClose(),
    isOpen,
    title: intl.formatMessage({
      id: "checkout.choosePickupPoint",
      defaultMessage: "Choose pick-up point"
    }),
    dismissLabel: "Close",
    size: "xl",
    children: /* @__PURE__ */jsxs39(Modal2.Content, {
      className: "pd:bg-dim-100",
      children: [updateLineItemMutation.status === "error" && /* @__PURE__ */jsx59("div", {
        className: "pd:mb-2",
        children: /* @__PURE__ */jsx59(ErrorAlert_default, {
          exception: {
            exception: updateLineItemMutation.error,
            tags: {
              fileLocation: "PickupPointModal.tsx",
              featureFunction: "updateLineItemMutation"
            },
            fingerprint: ["checkout-frontend", "pickup-point-selector"]
          }
        })
      }), /* @__PURE__ */jsx59(PickupPointWidget_default, {
        lineItem,
        customerAddress: {
          postalCode: customerDefaultShippingAddress == null ? void 0 : customerDefaultShippingAddress.address.postalCode,
          country: customerDefaultShippingAddress == null ? void 0 : customerDefaultShippingAddress.address.country
        },
        fallbackAddress: {
          postalCode: configurationProvider9.getValue("PUP_DEFAULT_POSTAL_CODE"),
          country: configurationProvider9.getValue("PUP_DEFAULT_COUNTRY")
        },
        onPickupPointClick: () => {
          pickupPointDataLayerEvent("pickup_point_click");
        },
        onPickupPointSelection: selectedPickupPoint => {
          var _a2, _b2;
          const pickupPointHref = (_b2 = (_a2 = selectedPickupPoint.pickupPoint._links) == null ? void 0 : _a2.self) == null ? void 0 : _b2.href;
          if (!pickupPointHref) {
            const [streetName, streetNumber] = selectedPickupPoint.pickupPoint.address.addressLine1.split(" ");
            if (!streetNumber || !streetName) {
              throw new Error("No street number or street name found in pickup point address");
            }
            updateLineItemMutation.mutateAsync({
              lineItemId: lineItem.id,
              payload: {
                shippingAddresses: [{
                  address: {
                    id: selectedPickupPoint.pickupPoint.id,
                    firstName: (customerDefaultBillingAddress == null ? void 0 : customerDefaultBillingAddress.address.firstName) || "",
                    lastName: (customerDefaultBillingAddress == null ? void 0 : customerDefaultBillingAddress.address.lastName) || "",
                    company: selectedPickupPoint.pickupPoint.name,
                    streetName,
                    streetNumber,
                    postalCode: selectedPickupPoint.pickupPoint.address.postalCode,
                    city: selectedPickupPoint.pickupPoint.address.city,
                    country: selectedPickupPoint.pickupPoint.address.countryCode
                  },
                  quantity: lineItem.quantity
                }],
                printdealPickupPointId: selectedPickupPoint.pickupPoint.id
              }
            }).then(() => onClose());
          } else {
            updateLineItemMutation.mutateAsync({
              lineItemId: lineItem.id,
              payload: {
                pickupPoints: [{
                  href: pickupPointHref
                }]
              }
            }).then(() => onClose());
          }
          pickupPointDataLayerEvent("pickup_point_selection");
        }
      })]
    })
  });
};
var PickupPointModal_default = PickupPointModal;

// src/library/components/line-item/pickup-point/PickupPointSelector.tsx
import { jsx as jsx60, jsxs as jsxs40 } from "react/jsx-runtime";
var PickupPointSelector = _ref102 => {
  let {
    lineItem
  } = _ref102;
  const intl = useIntl21();
  const getLineItemOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const {
    cart
  } = useCart();
  const [pickupPointsAvailable, setPickupPointsAvailable] = useState17(false);
  const [unavailableReason, setUnavailableReason] = useState17(void 0);
  const [isModalOpen, setIsModalOpen] = useState17(false);
  useEffect26(() => {
    if (!pickupPointsAvailable) {
      setUnavailableReason(0 /* NotPossibleForProduct */);
      return;
    }
    if (LineItemHelper8.hasLineItemSplitShipment(lineItem)) {
      setUnavailableReason(3 /* HasSplitShipmentOnLineItem */);
      return;
    }
    if (LineItemHelper8.hasLineItemTimedDelivery(lineItem)) {
      setUnavailableReason(2 /* HasTimedDeliveryOnLineItem */);
      return;
    }
    if ((cart == null ? void 0 : cart.customLineItems) && CustomLineItemHelper4.getAssociatedCustomLineItems(cart.customLineItems, lineItem.id, "courierService").length) {
      setUnavailableReason(4 /* HasCourierOnLineItem */);
      return;
    }
    setUnavailableReason(void 0);
  }, [lineItem, pickupPointsAvailable, cart == null ? void 0 : cart.customLineItems]);
  useEffect26(() => {
    if (getLineItemOptionsQuery.data) {
      const {
        pickupPointAllowed
      } = getLineItemOptionsQuery.data;
      if (pickupPointAllowed) {
        setPickupPointsAvailable(true);
      } else {
        setPickupPointsAvailable(false);
      }
    }
    if (getLineItemOptionsQuery.error) {
      setUnavailableReason(1 /* CouldNotFetchPickupPoints */);
    }
  }, [getLineItemOptionsQuery.data, getLineItemOptionsQuery.error]);
  const getTooltipText = reason => {
    switch (reason) {
      case 0 /* NotPossibleForProduct */:
        return intl.formatMessage({
          id: "pickupPoints.notPossibleWithProduct",
          defaultMessage: "Pickup points are currently not possible for this product."
        });
      case 2 /* HasTimedDeliveryOnLineItem */:
        return intl.formatMessage({
          id: "pickupPoints.cannotBeCombinedWithTimedDeliveries",
          defaultMessage: "Pickup points cannot be combined with timed deliveries."
        });
      case 3 /* HasSplitShipmentOnLineItem */:
        return intl.formatMessage({
          id: "pickupPoints.cannotBeCombinedWithSplitShipments",
          defaultMessage: "Pick up points cannot be combined with split shipments."
        });
      case 4 /* HasCourierOnLineItem */:
        return intl.formatMessage({
          id: "pickupPoints.cannotBeCombinedWithCourier",
          defaultMessage: "Pick up points cannot be combined with courier."
        });
      case 1 /* CouldNotFetchPickupPoints */:
      default:
        return intl.formatMessage({
          id: "pickupPoints.temporarilyUnavailable",
          defaultMessage: "This feature is temporarily unavailable."
        });
    }
  };
  return /* @__PURE__ */jsxs40("div", {
    className: "pd:flex pd:flex-col pd:gap-2",
    children: [/* @__PURE__ */jsx60(Heading10, {
      as: "h4",
      className: "pd:mb-2",
      children: /* @__PURE__ */jsx60(FormattedMessage36, {
        id: "pickupPoint.pickupPoint",
        defaultMessage: "Pick-up point"
      })
    }), unavailableReason ? /* @__PURE__ */jsx60(Tooltip3, {
      placement: "top",
      trigger: /* @__PURE__ */jsx60(Tooltip3.Trigger, {
        as: PickupPointButton_default,
        lineItem,
        unavailableReason,
        className: "pd:self-start pd:text-sm",
        onClick: () => setIsModalOpen(true)
      }),
      children: getTooltipText(unavailableReason)
    }) : /* @__PURE__ */jsx60(PickupPointButton_default, {
      lineItem,
      unavailableReason,
      className: "pd:self-start pd:text-sm",
      onClick: () => setIsModalOpen(true)
    }), /* @__PURE__ */jsx60(PickupPointModal_default, {
      lineItem,
      isOpen: isModalOpen,
      onClose: () => setIsModalOpen(false)
    })]
  });
};
var PickupPointSelector_default = PickupPointSelector;

// src/library/components/line-item/delivery-option/DeliveryOptionSelector.tsx
import { Heading as Heading11, Tooltip as Tooltip4 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage42, useIntl as useIntl24 } from "react-intl";
import { useEffect as useEffect28, useState as useState18 } from "react";
import { addDataLayerEntry as addDataLayerEntry15 } from "@printdeal/data-layer-manager";
import { hasPickupPoint, hasSplitShipment, isReviewGroupLead } from "@printdeal/business-logic";
import { CarrierOptionHelper as CarrierOptionHelper3, CustomLineItemHelper as CustomLineItemHelper5 } from "@printdeal/ecommerce-helpers";

// src/library/components/line-item/delivery-option/DeliveryOptionButton.tsx
import { LinkAsButton as LinkAsButton11 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage37 } from "react-intl";
import { CarrierOptionHelper } from "@printdeal/ecommerce-helpers";
import { jsx as jsx61 } from "react/jsx-runtime";
var DeliveryOptionButton = _ref103 => {
  let {
    lineItem,
    availableDeliveryOptions,
    unavailableReason,
    className,
    onClick
  } = _ref103;
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  return /* @__PURE__ */jsx61(LinkAsButton11, {
    iconBefore: "clock",
    variant: "secondary",
    className,
    onClick: () => {
      if (unavailableReason !== void 0 || shippingOptionsQuery.isLoading) {
        return;
      }
      onClick();
    },
    "aria-disabled": Boolean(unavailableReason !== void 0 || shippingOptionsQuery.isLoading),
    disabled: shippingOptionsQuery.isLoading,
    isLoading: shippingOptionsQuery.isLoading,
    children: CarrierOptionHelper.getNumberOfCarrierOptions(availableDeliveryOptions) <= 1 ? /* @__PURE__ */jsx61(FormattedMessage37, {
      id: "deliveryOption.changeDeliverySlot",
      defaultMessage: "Change delivery slot"
    }) : /* @__PURE__ */jsx61(FormattedMessage37, {
      id: "deliveryOption.changeDeliveryCarrierAndSlot",
      defaultMessage: "Change carrier and or delivery slot"
    })
  });
};
var DeliveryOptionButton_default = DeliveryOptionButton;

// src/library/components/line-item/delivery-option/DeliveryOptionModal.tsx
import { Button as Button11, Modal as Modal3, RadioGroup as RadioGroup2, TextField as TextField3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage40, useIntl as useIntl23 } from "react-intl";
import { useEffect as useEffect27 } from "react";
import { CarrierOptionHelper as CarrierOptionHelper2 } from "@printdeal/ecommerce-helpers";
import { Experiment } from "@printdeal/feature-management/react";
import { useForm } from "react-hook-form";
import { ParseError, parsePhoneNumberWithError } from "libphonenumber-js";
import { addDataLayerEntry as addDataLayerEntry14 } from "@printdeal/data-layer-manager";

// src/library/components/line-item/delivery-option/DeliveryOptionPriceBadge.tsx
import { Badge as Badge3 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage38, useIntl as useIntl22 } from "react-intl";
import { jsx as jsx62 } from "react/jsx-runtime";
var DeliveryOptionPriceBadge = _ref104 => {
  let {
    price
  } = _ref104;
  const intl = useIntl22();
  if ((price == null ? void 0 : price.centAmount) && price.centAmount > 0) {
    return /* @__PURE__ */jsx62(Badge3, {
      variant: "success-outline",
      children: intl.formatNumber(price.centAmount / 100, {
        style: "currency",
        currency: price.currencyCode
      })
    });
  }
  return /* @__PURE__ */jsx62(Badge3, {
    variant: "success-outline",
    children: /* @__PURE__ */jsx62(FormattedMessage38, {
      id: "carrierOption.freeDelivery",
      defaultMessage: "Free delivery"
    })
  });
};
var DeliveryOptionPriceBadge_default = DeliveryOptionPriceBadge;

// src/library/components/line-item/delivery-option/DeliveryOptionLabel.tsx
import { FormattedMessage as FormattedMessage39, defineMessages as defineMessages7 } from "react-intl";

// src/library/components/line-item/delivery-option/DeliveryOptionImage.tsx
import { Brand as Brand6 } from "@printdeal/ui-library";
import { jsx as jsx63 } from "react/jsx-runtime";
var DeliveryOptionImage = _ref105 => {
  let {
    deliveryOption
  } = _ref105;
  switch (deliveryOption.carrier) {
    case "postnl":
      return /* @__PURE__ */jsx63(Brand6, {
        brand: "postnl",
        className: "pd:h-6"
      });
    case "dhl":
      return /* @__PURE__ */jsx63(Brand6, {
        brand: "dhl",
        className: "pd:h-6"
      });
    default:
      return null;
  }
};
var DeliveryOptionImage_default = DeliveryOptionImage;

// src/library/components/line-item/delivery-option/DeliveryOptionLabel.tsx
import { jsx as jsx64, jsxs as jsxs41 } from "react/jsx-runtime";
var DeliveryOptionLabel = _ref106 => {
  let {
    deliveryOption
  } = _ref106;
  const translatedCarrierNames = defineMessages7({
    postnl: {
      id: "carrierOption.postnl",
      defaultMessage: "PostNL"
    },
    dhl: {
      id: "carrierOption.dhl",
      defaultMessage: "DHL"
    }
  });
  if (!deliveryOption.carrier) {
    if (deliveryOption.before) {
      return /* @__PURE__ */jsx64(FormattedMessage39, {
        id: "deliveryOption.before",
        defaultMessage: "Before {before}",
        values: {
          before: deliveryOption.before
        }
      });
    }
    return /* @__PURE__ */jsx64(FormattedMessage39, {
      id: "carrierOption.noPreference",
      defaultMessage: "No preference"
    });
  }
  return /* @__PURE__ */jsxs41("div", {
    className: "pd:flex pd:gap-2",
    children: [deliveryOption.carrier in translatedCarrierNames ? /* @__PURE__ */jsx64(FormattedMessage39, __spreadValues({}, translatedCarrierNames[deliveryOption.carrier])) : deliveryOption.carrier, /* @__PURE__ */jsx64("span", {
      className: "pd:text-dim-600",
      children: deliveryOption.before ? /* @__PURE__ */jsx64(FormattedMessage39, {
        id: "deliveryOption.before",
        defaultMessage: "Before {before}",
        values: {
          before: deliveryOption.before
        }
      }) : /* @__PURE__ */jsx64(FormattedMessage39, {
        id: "deliveryOption.defaultTimeSlot",
        defaultMessage: "Between 08:00 and 17:00"
      })
    }), /* @__PURE__ */jsx64(DeliveryOptionImage_default, {
      deliveryOption
    })]
  });
};
var DeliveryOptionLabel_default = DeliveryOptionLabel;

// src/library/components/line-item/delivery-option/DeliveryOptionModal.tsx
import { jsx as jsx65, jsxs as jsxs42 } from "react/jsx-runtime";
var DeliveryOptionModal = _ref107 => {
  let {
    lineItem,
    availableDeliveryOptions,
    availableCourierOption,
    deliveryOptionFromLineItem,
    courierOptionFromLineItem,
    isOpen,
    onClose
  } = _ref107;
  var _a;
  const intl = useIntl23();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "changeDeliveryOption" /* changeDeliveryOption */
  });
  const {
    register,
    handleSubmit,
    formState: {
      errors
    },
    setValue,
    watch
  } = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange"
  });
  const onSubmit = data => __async(void 0, null, function* () {
    yield updateLineItemMutation.mutateAsync({
      lineItemId: lineItem.id,
      payload: __spreadValues(__spreadValues({}, data.courierOptionChecked && data.courierName && data.courierPhone && {
        courierOption: {
          name: data.courierName,
          phoneNumber: data.courierPhone
        }
      }), data.deliveryOption && {
        deliveryOption: {
          recsKey: data.deliveryOption.recsKey,
          before: data.deliveryOption.before
        }
      })
    }).then(() => {
      var _a2, _b;
      if (data.deliveryOption) {
        addDataLayerEntry14("checkout_save_carrier_option", {
          carrierLabel: (_a2 = data.deliveryOption.carrier) != null ? _a2 : "default",
          carrierOption: (_b = data.deliveryOption.before) != null ? _b : ""
        });
      }
      if (data.courierOptionChecked && data.courierName && data.courierPhone) {
        addDataLayerEntry14("checkout_save_courier_option", {
          name: data.courierName,
          phoneNumber: data.courierPhone
        });
      }
      onClose();
    });
  });
  useEffect27(() => {
    if (courierOptionFromLineItem) {
      setValue("courierOptionChecked", true);
      setValue("courierName", courierOptionFromLineItem.name);
      setValue("courierPhone", courierOptionFromLineItem.phoneNumber);
    } else if (deliveryOptionFromLineItem) {
      setValue("deliveryOption", {
        recsKey: deliveryOptionFromLineItem.recsKey || ["all"],
        before: deliveryOptionFromLineItem.before || "all-day"
      });
    }
  }, [setValue, deliveryOptionFromLineItem, courierOptionFromLineItem]);
  return /* @__PURE__ */jsxs42(Modal3, {
    isOpen,
    title: CarrierOptionHelper2.getNumberOfCarrierOptions(availableDeliveryOptions) <= 1 ? /* @__PURE__ */jsx65(FormattedMessage40, {
      id: "deliveryOption.changeDeliverySlot",
      defaultMessage: "Change delivery slot"
    }) : /* @__PURE__ */jsx65(FormattedMessage40, {
      id: "deliveryOption.changeDeliveryCarrierAndSlot",
      defaultMessage: "Change carrier and or delivery slot"
    }),
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    onClose,
    children: [/* @__PURE__ */jsxs42(Modal3.Content, {
      children: [updateLineItemMutation.isError && /* @__PURE__ */jsx65("div", {
        className: "pd:mb-4",
        children: /* @__PURE__ */jsx65(ErrorAlert_default, {
          exception: {
            exception: updateLineItemMutation.error,
            tags: {
              fileLocation: "DeliveryOptionModal.tsx",
              featureFunction: "updateLineItemMutation"
            },
            fingerprint: ["checkout-frontend", "delivery-option-selector"]
          },
          children: /* @__PURE__ */jsx65(FormattedMessage40, {
            id: "deliveryOption.error",
            defaultMessage: "Something went wrong while setting or updating the delivery option. Please try again later."
          })
        })
      }), /* @__PURE__ */jsx65("form", {
        id: "delivery-option-form",
        method: "POST",
        onSubmit: handleSubmit(onSubmit),
        noValidate: true,
        children: /* @__PURE__ */jsxs42(RadioGroup2, __spreadProps(__spreadValues({
          id: "delivery-option"
        }, register("deliveryOption")), {
          label: intl.formatMessage({
            id: "deliveryOption.selectDeliveryOption",
            defaultMessage: "Select delivery option"
          }),
          children: [availableDeliveryOptions.map((deliveryOption, index) => {
            var _a2, _b, _c;
            const generatedId = JSON.stringify({
              recsKey: deliveryOption.recsKey || ["all"],
              before: deliveryOption.before || "all-day"
            });
            return /* @__PURE__ */jsx65(RadioGroup2.Field, {
              id: "delivery-option-".concat(index),
              label: /* @__PURE__ */jsx65(DeliveryOptionLabel_default, {
                deliveryOption
              }),
              badge: /* @__PURE__ */jsx65(DeliveryOptionPriceBadge_default, {
                price: {
                  centAmount: (_a2 = deliveryOption.price) == null ? void 0 : _a2.centAmount,
                  currencyCode: "EUR"
                }
              }),
              checked: generatedId === JSON.stringify({
                recsKey: ((_b = watch("deliveryOption")) == null ? void 0 : _b.recsKey) || ["all"],
                before: ((_c = watch("deliveryOption")) == null ? void 0 : _c.before) || "all-day"
              }) && !watch("courierOptionChecked"),
              onChange: () => {
                setValue("deliveryOption", {
                  recsKey: deliveryOption.recsKey,
                  before: deliveryOption.before
                });
                setValue("courierOptionChecked", false);
                setValue("courierName", void 0);
                setValue("courierPhone", void 0);
              }
            }, generatedId);
          }), availableCourierOption.enabled && /* @__PURE__ */jsx65(Experiment, {
            id: "servicesprouts_exp1953_courier_in_check-out",
            children: /* @__PURE__ */jsxs42(Experiment.Variant, {
              children: [/* @__PURE__ */jsx65(RadioGroup2.Field, {
                id: "manual-courier",
                label: /* @__PURE__ */jsx65(FormattedMessage40, {
                  id: "deliveryOption.manualCourier",
                  defaultMessage: "Guaranteed delivery"
                }),
                badge: /* @__PURE__ */jsx65(DeliveryOptionPriceBadge_default, {
                  price: (_a = availableCourierOption.discountedPrice) == null ? void 0 : _a.totalNet
                }),
                checked: watch("courierOptionChecked"),
                onChange: () => {
                  setValue("courierOptionChecked", true);
                  setValue("deliveryOption", void 0);
                }
              }, "manual-courier"), watch("courierOptionChecked") && /* @__PURE__ */jsxs42("div", {
                className: "pd:flex pd:flex-row pd:gap-4",
                children: [/* @__PURE__ */jsx65(TextField3, __spreadProps(__spreadValues({
                  id: "deliveryOption.courierName"
                }, register("courierName", {
                  required: intl.formatMessage({
                    id: "deliveryOption.courierName.requiredLabel",
                    defaultMessage: "Name is required"
                  })
                })), {
                  label: intl.formatMessage({
                    id: "deliveryOption.courierName.label",
                    defaultMessage: "Name recipient"
                  }),
                  required: true,
                  validation: errors.courierName ? "error" : void 0,
                  validationMessage: errors.courierName ? errors.courierName.message : void 0,
                  className: "pd:w-full"
                })), /* @__PURE__ */jsx65(TextField3, __spreadProps(__spreadValues({
                  id: "deliveryOption.courierPhone"
                }, register("courierPhone", {
                  required: intl.formatMessage({
                    id: "deliveryOption.courierPhone.requiredLabel",
                    defaultMessage: "Phone is required"
                  }),
                  validate: value => {
                    if (value) {
                      try {
                        parsePhoneNumberWithError(value);
                      } catch (error) {
                        if (error instanceof ParseError) {
                          switch (error.message) {
                            case "INVALID_COUNTRY":
                              return intl.formatMessage({
                                id: "deliveryOption.courierPhone.invalidCountryCodeLabel",
                                defaultMessage: "Please enter a valid phone number with the country code e.g. +31612345678"
                              });
                            case "TOO_SHORT":
                            case "TOO_LONG":
                              return intl.formatMessage({
                                id: "deliveryOption.courierPhone.invalidLengthLabel",
                                defaultMessage: "Please enter a valid phone number with the correct length"
                              });
                            case "NOT_A_NUMBER":
                            default:
                              return intl.formatMessage({
                                id: "deliveryOption.courierPhone.invalidLabel",
                                defaultMessage: "Please enter a valid phone number"
                              });
                          }
                        }
                        return intl.formatMessage({
                          id: "deliveryOption.courierPhone.invalidLabelError",
                          defaultMessage: "An error occurred while parsing the phone number"
                        });
                      }
                    }
                    return true;
                  }
                })), {
                  label: intl.formatMessage({
                    id: "deliveryOption.courierPhone.label",
                    defaultMessage: "Phone recipient"
                  }),
                  placeholder: intl.formatMessage({
                    id: "deliveryOption.courierPhone.placeholder",
                    defaultMessage: "+31612345678"
                  }),
                  required: true,
                  type: "tel",
                  validation: errors.courierPhone ? "error" : void 0,
                  validationMessage: errors.courierPhone ? errors.courierPhone.message : void 0,
                  className: "pd:w-full"
                }))]
              })]
            })
          })]
        }))
      })]
    }), /* @__PURE__ */jsx65(Modal3.Footer, {
      className: "pd:flex pd:justify-end",
      children: /* @__PURE__ */jsx65(Button11, {
        type: "submit",
        form: "delivery-option-form",
        isLoading: updateLineItemMutation.isPending,
        children: /* @__PURE__ */jsx65(FormattedMessage40, {
          id: "deliveryOption.confirmDeliveryOption",
          defaultMessage: "Confirm delivery option"
        })
      })
    })]
  });
};
var DeliveryOptionModal_default = DeliveryOptionModal;

// src/library/components/line-item/delivery-option/DeliveryOptionDescription.tsx
import { FormattedMessage as FormattedMessage41 } from "react-intl";
import { jsx as jsx66, jsxs as jsxs43 } from "react/jsx-runtime";
var DeliveryOptionDescription = _ref108 => {
  let {
    deliveryOption,
    courierOption
  } = _ref108;
  if (courierOption) {
    return /* @__PURE__ */jsx66("div", {
      className: "pd:flex pd:items-center",
      children: /* @__PURE__ */jsx66(FormattedMessage41, {
        id: "deliveryOption.courier",
        defaultMessage: "Courier: {name} {phoneNumber}",
        values: {
          name: courierOption.name,
          phoneNumber: courierOption.phoneNumber
        }
      })
    });
  }
  if (deliveryOption) {
    return /* @__PURE__ */jsxs43("div", {
      className: "pd:flex pd:items-center",
      children: [deliveryOption.before ? /* @__PURE__ */jsx66(FormattedMessage41, {
        id: "deliveryOption.before",
        defaultMessage: "Before {before}",
        values: {
          before: deliveryOption.before
        }
      }) : /* @__PURE__ */jsx66(FormattedMessage41, {
        id: "deliveryOption.defaultTimeSlot",
        defaultMessage: "Between 08:00 and 17:00"
      }), deliveryOption.recsKey && /* @__PURE__ */jsx66("div", {
        className: "pd:ml-2",
        children: /* @__PURE__ */jsx66(DeliveryOptionImage_default, {
          deliveryOption
        })
      })]
    });
  }
  return null;
};
var DeliveryOptionDescription_default = DeliveryOptionDescription;

// src/library/components/line-item/delivery-option/DeliveryOptionSelector.tsx
import { jsx as jsx67, jsxs as jsxs44 } from "react/jsx-runtime";
var DeliveryOptionSelector = _ref109 => {
  let {
    lineItem
  } = _ref109;
  const intl = useIntl24();
  const {
    cart
  } = useCart();
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const [isModalOpen, setIsModalOpen] = useState18(false);
  const [availableDeliveryOptions, setAvailableDeliveryOptions] = useState18([]);
  const [availableCourierOption, setAvailableCourierOption] = useState18({
    enabled: false
  });
  const [deliveryOptionFromLineItem, setDeliveryFromLineItem] = useState18(void 0);
  const [courierOptionFromLineItem, setCourierFromLineItem] = useState18(void 0);
  const [unavailableReason, setUnavailableReason] = useState18(void 0);
  useEffect28(() => {
    var _a, _b, _c, _d;
    if (shippingOptionsQuery.data) {
      if (shippingOptionsQuery.data.deliveryOptions.length) {
        const deliveryOptionOnLineItem = CarrierOptionHelper3.getCarrierOptionFromLineItem(lineItem, shippingOptionsQuery.data.deliveryOptions);
        setDeliveryFromLineItem(deliveryOptionOnLineItem);
        setAvailableDeliveryOptions(shippingOptionsQuery.data.deliveryOptions);
      } else {
        setAvailableDeliveryOptions([]);
        setDeliveryFromLineItem(void 0);
      }
      if ((_a = shippingOptionsQuery.data.courier) == null ? void 0 : _a.enabled) {
        const [customLineItemCourierService] = CustomLineItemHelper5.getAssociatedCustomLineItems((_b = cart == null ? void 0 : cart.customLineItems) != null ? _b : [], lineItem.id, "courierService");
        if (customLineItemCourierService) {
          setCourierFromLineItem({
            name: (_c = customLineItemCourierService.custom) == null ? void 0 : _c.fields.courierContactName,
            phoneNumber: (_d = customLineItemCourierService.custom) == null ? void 0 : _d.fields.courierContactPhoneNumber
          });
        } else {
          setCourierFromLineItem(void 0);
        }
        setAvailableCourierOption(shippingOptionsQuery.data.courier);
      } else {
        setAvailableCourierOption({
          enabled: false
        });
        setCourierFromLineItem(void 0);
      }
    }
    if (shippingOptionsQuery.isPending) {
      setDeliveryFromLineItem(void 0);
      setCourierFromLineItem(void 0);
    }
    if (shippingOptionsQuery.error) {
      setAvailableDeliveryOptions([]);
      setAvailableCourierOption({
        enabled: false
      });
    }
  }, [shippingOptionsQuery.data, shippingOptionsQuery.error, shippingOptionsQuery.isPending, lineItem, cart]);
  useEffect28(() => {
    if (isReviewGroupLead(lineItem)) {
      setUnavailableReason(0 /* NotPossibleForProduct */);
      return;
    }
    if (hasSplitShipment(lineItem)) {
      setUnavailableReason(2 /* HasSplitShipmentOnLineItem */);
      return;
    }
    if (hasPickupPoint(lineItem)) {
      setUnavailableReason(3 /* HasPickupPointOnLineItem */);
      return;
    }
    if (shippingOptionsQuery.isSuccess) {
      if (availableDeliveryOptions.length > 0 || availableCourierOption.enabled) {
        setUnavailableReason(void 0);
        return;
      }
      if (availableDeliveryOptions.length === 0) {
        setUnavailableReason(0 /* NotPossibleForProduct */);
        return;
      }
    }
    setUnavailableReason(1 /* CouldNotFetchDeliveryOptions */);
  }, [availableDeliveryOptions, availableCourierOption, lineItem, shippingOptionsQuery.isSuccess]);
  const getTooltipText = reason => {
    switch (reason) {
      case 0 /* NotPossibleForProduct */:
        return intl.formatMessage({
          id: "deliveryOptions.notPossibleWithProduct",
          defaultMessage: "Delivery options are currently not possible for this product"
        });
      case 2 /* HasSplitShipmentOnLineItem */:
        return intl.formatMessage({
          id: "deliveryOptions.cannotBeCombinedWithSplitShipments",
          defaultMessage: "Delivery options cannot be combined with split shipments"
        });
      case 3 /* HasPickupPointOnLineItem */:
        return intl.formatMessage({
          id: "deliveryOptions.cannotBeCombinedWithPickupPoint",
          defaultMessage: "Delivery options cannot be combined with a pickup point"
        });
      case 1 /* CouldNotFetchDeliveryOptions */:
      default:
        return intl.formatMessage({
          id: "deliveryOptions.couldNotFetchDeliveryOptions",
          defaultMessage: "Could not fetch delivery options"
        });
    }
  };
  return /* @__PURE__ */jsxs44("div", {
    className: "pd:flex pd:flex-col pd:gap-2",
    children: [/* @__PURE__ */jsx67(Heading11, {
      as: "h4",
      children: CarrierOptionHelper3.getNumberOfCarrierOptions(availableDeliveryOptions) + (availableCourierOption.enabled ? 1 : 0) <= 1 ? /* @__PURE__ */jsx67(FormattedMessage42, {
        id: "deliveryOption.deliverySlot",
        defaultMessage: "Delivery slot"
      }) : /* @__PURE__ */jsx67(FormattedMessage42, {
        id: "deliveryOption.deliveryCarrierAndSlot",
        defaultMessage: "Carrier and delivery slot"
      })
    }), /* @__PURE__ */jsx67(DeliveryOptionDescription_default, {
      deliveryOption: deliveryOptionFromLineItem,
      courierOption: courierOptionFromLineItem
    }), unavailableReason ? /* @__PURE__ */jsx67(Tooltip4, {
      placement: "top",
      trigger: /* @__PURE__ */jsx67(Tooltip4.Trigger, {
        as: DeliveryOptionButton_default,
        lineItem,
        availableDeliveryOptions,
        unavailableReason,
        className: "pd:self-start pd:text-sm",
        onClick: () => {
          setIsModalOpen(true);
          addDataLayerEntry15("click_carrier_option");
        }
      }),
      children: getTooltipText(unavailableReason)
    }) : /* @__PURE__ */jsx67(DeliveryOptionButton_default, {
      lineItem,
      availableDeliveryOptions,
      unavailableReason,
      className: "pd:self-start pd:text-sm",
      onClick: () => {
        setIsModalOpen(true);
        addDataLayerEntry15("click_carrier_option");
      }
    }), /* @__PURE__ */jsx67(DeliveryOptionModal_default, {
      lineItem,
      availableDeliveryOptions,
      deliveryOptionFromLineItem,
      availableCourierOption,
      courierOptionFromLineItem,
      isOpen: isModalOpen,
      onClose: () => setIsModalOpen(false)
    })]
  });
};
var DeliveryOptionSelector_default = DeliveryOptionSelector;

// src/library/components/design-system/line-item/LineItemShippingAddress.tsx
import { Alert as Alert10, Heading as Heading12 } from "@printdeal/ui-library";
import { useState as useState21 } from "react";
import { FormattedMessage as FormattedMessage47 } from "react-intl";
import { AddressContent } from "@printdeal/address-frontend";
import { LineItemHelper as LineItemHelper10 } from "@printdeal/ecommerce-helpers";
import { hasSplitShipment as hasSplitShipment3, hasPickupPoint as hasPickupPoint3, isSpecificOrchestration } from "@printdeal/business-logic";
import { useQueryClient as useQueryClient4 } from "@tanstack/react-query";

// src/library/components/line-item/shipping-address/ShippingAddressButton.tsx
import { Button as Button12 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage43 } from "react-intl";
import { hasSplitShipment as hasSplitShipment2, hasPickupPoint as hasPickupPoint2 } from "@printdeal/business-logic";
import { jsx as jsx68, jsxs as jsxs45 } from "react/jsx-runtime";
var ShippingAddressButton = _ref110 => {
  let {
    lineItem,
    onClick
  } = _ref110;
  const hasSplitShipmentOnLineItem = hasSplitShipment2(lineItem);
  const hasPickupPointOnLineItem = hasPickupPoint2(lineItem);
  return /* @__PURE__ */jsxs45(Button12, {
    className: "pd:self-start",
    variant: "secondary",
    iconBefore: "edit",
    onClick,
    children: [/* @__PURE__ */jsx68(FormattedMessage43, {
      id: "checkout.changeShippingAddress",
      defaultMessage: "Change shipping address"
    }), (hasSplitShipmentOnLineItem || hasPickupPointOnLineItem) && " *"]
  });
};
var ShippingAddressButton_default = ShippingAddressButton;

// src/library/components/line-item/shipping-address/ShippingAddressPickupPointContent.tsx
import { FormattedMessage as FormattedMessage44 } from "react-intl";
import { Spinner as Spinner7 } from "@printdeal/ui-library";
import { LineItemHelper as LineItemHelper9 } from "@printdeal/ecommerce-helpers";
import { Fragment as Fragment20, jsx as jsx69, jsxs as jsxs46 } from "react/jsx-runtime";
var ShippingAddressPickupPointContent = _ref111 => {
  let {
    lineItem
  } = _ref111;
  const pickupPointId = LineItemHelper9.getLineItemPickupPointId(lineItem);
  const pickupPointQuery = useGetPickupPointQuery({
    pickupPointId
  });
  return /* @__PURE__ */jsxs46(Fragment20, {
    children: [pickupPointQuery.isError && /* @__PURE__ */jsx69(ErrorAlert_default, {
      scrollIntoView: false,
      exception: {
        exception: pickupPointQuery.error,
        fingerprint: ["pickup-point-details"]
      },
      children: /* @__PURE__ */jsx69(FormattedMessage44, {
        id: "pickupPointDetails.error",
        defaultMessage: "Could not fetch pickup point details. If the problem persists, please try setting a new pickup point or delivery address."
      })
    }), pickupPointQuery.isLoading && /* @__PURE__ */jsx69(Spinner7, {}), pickupPointQuery.data && /* @__PURE__ */jsxs46(Fragment20, {
      children: [/* @__PURE__ */jsx69(FormattedMessage44, {
        id: "pickupPointDetails.pickupPoint",
        defaultMessage: "Pickup point"
      }), ":", /* @__PURE__ */jsx69("div", {
        children: pickupPointQuery.data.name
      }), /* @__PURE__ */jsx69("div", {
        children: pickupPointQuery.data.address.addressLine1
      }), /* @__PURE__ */jsxs46("div", {
        children: [pickupPointQuery.data.address.postalCode, " ", pickupPointQuery.data.address.city]
      })]
    })]
  });
};
var ShippingAddressPickupPointContent_default = ShippingAddressPickupPointContent;

// src/library/components/line-item/shipping-address/ShippingAddressModal.tsx
import { Button as Button14, LinkAsButton as LinkAsButton12, Modal as Modal4 } from "@printdeal/ui-library";
import { useState as useState20 } from "react";
import clsx3 from "clsx";
import { AddressFormSubmitButton, AddressListView, CreateAddressView, UpdateAddressView } from "@printdeal/address-frontend";
import { FormattedMessage as FormattedMessage46, useIntl as useIntl26 } from "react-intl";

// src/library/components/line-item/shipping-address/ShippingAddressPanel.tsx
import { useIntl as useIntl25 } from "react-intl";
import { AddressDeleteModal, AddressPanel } from "@printdeal/address-frontend";
import clsx2 from "clsx";
import { Fragment as Fragment21, jsx as jsx70, jsxs as jsxs47 } from "react/jsx-runtime";
var ShippingAddressPanel = _ref112 => {
  let {
    address,
    isDefaultBillingAddress,
    isDefaultShippingAddress,
    focusedAddressId,
    setView,
    setMutatingAddressId,
    setShowSuccessAlertForCreatedAddressId,
    setShowSuccessAlertForUpdatedAddressId,
    deleteAddressModalIsOpen,
    setDeleteAddressModalIsOpen,
    footer
  } = _ref112;
  const intl = useIntl25();
  return /* @__PURE__ */jsxs47(Fragment21, {
    children: [/* @__PURE__ */jsx70(AddressPanel, {
      address,
      isDefaultBillingAddress,
      isDefaultShippingAddress,
      className: clsx2({
        "pd:border-info-500": focusedAddressId === address.id
      }),
      dropdownItems: [{
        title: intl.formatMessage({
          id: "checkout.editAddress",
          defaultMessage: "Edit address"
        }),
        iconBefore: "edit",
        onClick: () => {
          setMutatingAddressId(address.id);
          setShowSuccessAlertForCreatedAddressId(void 0);
          setShowSuccessAlertForUpdatedAddressId(void 0);
          setView("edit");
        }
      }, ...(!isDefaultBillingAddress && !isDefaultShippingAddress ? [{
        title: intl.formatMessage({
          id: "checkout.deleteAddress",
          defaultMessage: "Delete address"
        }),
        iconBefore: "trashcan",
        onClick: () => {
          setDeleteAddressModalIsOpen(address.id);
        }
      }] : [])],
      footer
    }, address.id), /* @__PURE__ */jsx70(AddressDeleteModal, {
      addressId: address.id,
      isModalOpen: deleteAddressModalIsOpen === address.id,
      setIsModalOpen: setDeleteAddressModalIsOpen,
      onSuccess: () => {
        setShowSuccessAlertForCreatedAddressId(void 0);
        setShowSuccessAlertForUpdatedAddressId(void 0);
        setMutatingAddressId(void 0);
      }
    })]
  });
};
var ShippingAddressPanel_default = ShippingAddressPanel;

// src/library/components/line-item/shipping-address/ShippingAddressPanelFooter.tsx
import { Alert as Alert9, Button as Button13 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage45 } from "react-intl";
import { EntityHelper as EntityHelper11 } from "@printdeal/ecommerce-helpers";

// src/library/hooks/address/useValidateAddress.ts
import { addressSchema } from "@printdeal/address-frontend";
import { useEffect as useEffect29, useState as useState19 } from "react";
import { ValidationError } from "yup";
function useValidateAddress(_ref113) {
  let {
    address,
    requireEmail
  } = _ref113;
  const [validationErrors, setValidationErrors] = useState19([]);
  useEffect29(() => {
    setValidationErrors([]);
    try {
      addressSchema({
        required: requireEmail
      }).validateSync(address, {
        abortEarly: false
      });
      setValidationErrors([]);
    } catch (error) {
      if (error instanceof ValidationError) {
        setValidationErrors(error.inner);
      }
    }
  }, [address, requireEmail]);
  return validationErrors;
}

// src/library/components/design-system/address/AddressError.tsx
import { useTranslatedAddressYupErrorMessage } from "@printdeal/address-frontend";
var AddressError = _ref114 => {
  let {
    error
  } = _ref114;
  const translatedError = useTranslatedAddressYupErrorMessage({
    fieldName: error.path,
    errorMessage: error.message
  });
  return translatedError;
};
var AddressError_default = AddressError;

// src/library/components/line-item/shipping-address/ShippingAddressPanelFooter.tsx
import { Fragment as Fragment22, jsx as jsx71, jsxs as jsxs48 } from "react/jsx-runtime";
var ShippingAddressPanelFooter = _ref115 => {
  let {
    lineItem,
    address,
    patchCartMutation,
    updateLineItemMutation,
    mutatingAddressId,
    setView,
    setMutatingAddressId,
    setDeleteAddressModalIsOpen,
    onClose
  } = _ref115;
  const {
    cart
  } = useCart();
  const validationErrors = useValidateAddress({
    address,
    requireEmail: false
  });
  const totalLineItemsQuantity = cart ? EntityHelper11.getMainLineItems(cart).length : 0;
  return validationErrors.length === 0 ? /* @__PURE__ */jsxs48(Fragment22, {
    children: [totalLineItemsQuantity > 1 && /* @__PURE__ */jsx71(Button13, {
      variant: "secondary",
      className: "pd:w-full pd:md:w-auto",
      isLoading: patchCartMutation.isPending && mutatingAddressId === address.id,
      onClick: () => {
        setMutatingAddressId(address.id);
        patchCartMutation.mutateAsync({
          action: {
            name: "setShippingAddress",
            value: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
              id: address.id.trim(),
              firstName: address.firstName.trim(),
              lastName: address.lastName.trim()
            }, address.email && {
              email: address.email.trim()
            }), address.phone && {
              phone: address.phone.trim()
            }), address.company && {
              company: address.company.trim()
            }), {
              country: address.country.trim(),
              postalCode: address.postalCode.trim(),
              streetNumber: address.streetNumber.trim(),
              streetName: address.streetName.trim(),
              city: address.city.trim()
            }), address.additionalStreetInfo && {
              additionalStreetInfo: address.additionalStreetInfo.trim()
            })
          }
        }).then(() => {
          patchCartMutation.reset();
          onClose();
        });
      },
      children: /* @__PURE__ */jsx71(FormattedMessage45, {
        id: "checkout.button.selectAddressForAllProducts",
        defaultMessage: "Select address for all products"
      })
    }), /* @__PURE__ */jsx71(Button13, {
      className: "pd:w-full pd:md:w-auto",
      isLoading: updateLineItemMutation.isPending && mutatingAddressId === address.id,
      onClick: () => {
        setMutatingAddressId(address.id);
        updateLineItemMutation.mutateAsync({
          lineItemId: lineItem.id,
          payload: {
            shippingAddresses: [{
              address: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
                id: address.id.trim(),
                firstName: address.firstName.trim(),
                lastName: address.lastName.trim()
              }, address.email && {
                email: address.email.trim()
              }), address.phone && {
                phone: address.phone.trim()
              }), address.company && {
                company: address.company.trim()
              }), {
                country: address.country.trim(),
                postalCode: address.postalCode.trim(),
                streetNumber: address.streetNumber.trim(),
                streetName: address.streetName.trim(),
                city: address.city.trim()
              }), address.additionalStreetInfo && {
                additionalStreetInfo: address.additionalStreetInfo.trim()
              }),
              quantity: lineItem.quantity
            }]
          }
        }).then(() => {
          updateLineItemMutation.reset();
          onClose();
        });
      },
      children: totalLineItemsQuantity > 1 ? /* @__PURE__ */jsx71(FormattedMessage45, {
        id: "checkout.button.selectAddressForOneProduct",
        defaultMessage: "Select address for only this product"
      }) : /* @__PURE__ */jsx71(FormattedMessage45, {
        id: "checkout.button.selectAddress",
        defaultMessage: "Select address"
      })
    })]
  }) : /* @__PURE__ */jsx71(Alert9, {
    variant: "error",
    children: /* @__PURE__ */jsxs48("div", {
      className: "pd:flex pd:flex-col pd:gap-2",
      children: [/* @__PURE__ */jsx71(FormattedMessage45, {
        id: "checkout.invalidAddress",
        defaultMessage: "This address can currently not be selected, because it is missing certain data or contains invalid data. To make the address usable again, you can edit the address and fix the validation errors. Alternatively, if you no longer need this address, you can delete it."
      }), /* @__PURE__ */jsx71("ul", {
        children: validationErrors.map(error => /* @__PURE__ */jsx71("li", {
          children: /* @__PURE__ */jsx71(AddressError_default, {
            error
          })
        }, error.path))
      }), /* @__PURE__ */jsxs48("div", {
        className: "pd:flex pd:gap-2",
        children: [/* @__PURE__ */jsx71(Button13, {
          variant: "secondary",
          iconBefore: "edit",
          onClick: () => {
            setMutatingAddressId(address.id);
            setView("edit");
          },
          children: /* @__PURE__ */jsx71(FormattedMessage45, {
            id: "checkout.editAddress",
            defaultMessage: "Edit address"
          })
        }), /* @__PURE__ */jsx71(Button13, {
          variant: "secondary",
          iconBefore: "trashcan",
          onClick: () => setDeleteAddressModalIsOpen(address.id),
          children: /* @__PURE__ */jsx71(FormattedMessage45, {
            id: "checkout.deleteAddress",
            defaultMessage: "Delete address"
          })
        })]
      })]
    })
  });
};
var ShippingAddressPanelFooter_default = ShippingAddressPanelFooter;

// src/library/components/line-item/shipping-address/ShippingAddressModal.tsx
import { jsx as jsx72, jsxs as jsxs49 } from "react/jsx-runtime";
var ShippingAddressModal = _ref116 => {
  let {
    lineItem,
    isOpen,
    onClose
  } = _ref116;
  const intl = useIntl26();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "setShippingAddress" /* setShippingAddress */
  });
  const updateCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setShippingAddress" /* setShippingAddress */
    }
  });
  const [view, setView] = useState20("list");
  const [mutatingAddressId, setMutatingAddressId] = useState20();
  const [showSuccessAlertForCreatedAddressId, setShowSuccessAlertForCreatedAddressId] = useState20();
  const [showSuccessAlertForUpdatedAddressId, setShowSuccessAlertForUpdatedAddressId] = useState20();
  const [deleteAddressModalIsOpen, setDeleteAddressModalIsOpen] = useState20();
  return /* @__PURE__ */jsxs49(Modal4, {
    isOpen,
    onClose: () => {
      updateLineItemMutation.reset();
      updateCartMutation.reset();
      setView("list");
      setMutatingAddressId(void 0);
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      onClose();
    },
    size: "lg",
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    title: intl.formatMessage({
      id: "checkout.selectShippingAddress",
      defaultMessage: "Select shipping address"
    }),
    children: [/* @__PURE__ */jsxs49(Modal4.Content, {
      className: clsx3("pd:h-[90vh]", {
        "pd:p-0": view === "list"
      }),
      children: [view === "list" && /* @__PURE__ */jsx72(AddressListView, {
        className: "pd:p-4",
        showSuccessAlertForCreatedAddressId,
        showSuccessAlertForUpdatedAddressId,
        renderAddressPanel: (_a, focusedAddressId) => {
          var _b = _a,
            {
              address
            } = _b,
            data = __objRest(_b, ["address"]);
          return /* @__PURE__ */jsx72(ShippingAddressPanel_default, {
            address,
            isDefaultBillingAddress: data.isDefaultBillingAddress,
            isDefaultShippingAddress: data.isDefaultShippingAddress,
            focusedAddressId,
            setView,
            setMutatingAddressId,
            setShowSuccessAlertForCreatedAddressId,
            setShowSuccessAlertForUpdatedAddressId,
            deleteAddressModalIsOpen,
            setDeleteAddressModalIsOpen,
            footer: /* @__PURE__ */jsx72(ShippingAddressPanelFooter_default, {
              lineItem,
              address,
              patchCartMutation: updateCartMutation,
              updateLineItemMutation,
              mutatingAddressId,
              setView,
              setMutatingAddressId,
              setDeleteAddressModalIsOpen,
              onClose
            })
          });
        },
        alert: (updateLineItemMutation.isError || updateCartMutation.isError) && /* @__PURE__ */jsx72(ErrorAlert_default, {
          className: "pd:m-0",
          scrollIntoView: true,
          exception: {
            exception: updateLineItemMutation.error || updateCartMutation.error,
            tags: {
              fileLocation: "ShippingAddressModal.tsx",
              featureFunction: "ShippingAddressModal"
            },
            fingerprint: ["checkout", "update-shipping-address"]
          },
          children: /* @__PURE__ */jsx72(FormattedMessage46, {
            id: "checkout.shippingAddress.error",
            defaultMessage: "An error occurred while updating the shipping address. Please try again."
          })
        })
      }), view === "create" && /* @__PURE__ */jsx72(CreateAddressView, {
        onSubmitSuccess: address => {
          setShowSuccessAlertForCreatedAddressId(address.id);
          setView("list");
        }
      }), view === "edit" && /* @__PURE__ */jsx72(UpdateAddressView, {
        mutatingAddressId,
        onSubmitSuccess: () => {
          setShowSuccessAlertForUpdatedAddressId(mutatingAddressId);
          setView("list");
        }
      })]
    }), /* @__PURE__ */jsxs49(Modal4.Footer, {
      children: [view === "list" && /* @__PURE__ */jsx72("div", {
        className: "pd:flex pd:justify-end",
        children: /* @__PURE__ */jsx72(Button14, {
          variant: "secondary",
          iconBefore: "plus",
          onClick: () => setView("create"),
          children: /* @__PURE__ */jsx72(FormattedMessage46, {
            id: "checkout.addAddress",
            defaultMessage: "Add address"
          })
        })
      }), (view === "create" || view === "edit") && /* @__PURE__ */jsxs49("div", {
        className: "pd:flex pd:items-center pd:justify-between",
        children: [/* @__PURE__ */jsx72(LinkAsButton12, {
          className: "pd:text-sm",
          iconBefore: "chevron-left",
          variant: "secondary",
          onClick: () => {
            setShowSuccessAlertForCreatedAddressId(void 0);
            setShowSuccessAlertForUpdatedAddressId(void 0);
            setView("list");
          },
          children: /* @__PURE__ */jsx72(FormattedMessage46, {
            id: "checkout.backToAddressList",
            defaultMessage: "Back to address list"
          })
        }), /* @__PURE__ */jsx72(AddressFormSubmitButton, {})]
      })]
    })]
  });
};
var ShippingAddressModal_default = ShippingAddressModal;

// src/library/components/design-system/line-item/LineItemShippingAddress.tsx
import { jsx as jsx73, jsxs as jsxs50 } from "react/jsx-runtime";
var LineItemShippingAddress = _ref117 => {
  let {
    lineItem
  } = _ref117;
  const queryClient = useQueryClient4();
  const {
    cartId,
    invalidateCart,
    cart
  } = useCart();
  const shippingAddresses = LineItemHelper10.getLineItemShippingAddresses(lineItem);
  const shippingAddress = shippingAddresses && shippingAddresses[0];
  const hasSplitShipmentOnLineItem = hasSplitShipment3(lineItem);
  const hasPickupPointOnLineItem = hasPickupPoint3(lineItem);
  const totalQuantity = hasSplitShipmentOnLineItem && cart ? shippingAddress == null ? void 0 : shippingAddress.quantity : LineItemHelper10.getLineItemQuantity(cart, lineItem);
  const [isModalOpen, setIsModalOpen] = useState21(false);
  return /* @__PURE__ */jsxs50("div", {
    className: "pd:flex pd:flex-col pd:gap-3",
    children: [/* @__PURE__ */jsx73(Heading12, {
      as: "h4",
      children: isSpecificOrchestration(lineItem, "Direct mailing") ? /* @__PURE__ */jsx73(FormattedMessage47, {
        id: "checkout.shippingAddress.extraQuantities",
        defaultMessage: "Shipping address for extra quantities"
      }) : /* @__PURE__ */jsx73(FormattedMessage47, {
        id: "checkout.shippingAddress",
        defaultMessage: "Shipping address"
      })
    }), /* @__PURE__ */jsxs50("div", {
      children: [hasPickupPointOnLineItem ? /* @__PURE__ */jsx73(ShippingAddressPickupPointContent_default, {
        lineItem
      }) : /* @__PURE__ */jsx73("div", {
        children: shippingAddress ? /* @__PURE__ */jsx73(AddressContent, {
          address: shippingAddress,
          showFirstAndLastName: true
        }) : /* @__PURE__ */jsx73(Alert10, {
          variant: "error",
          children: /* @__PURE__ */jsx73(FormattedMessage47, {
            id: "checkout.shippingAddressNotSet",
            defaultMessage: "Please select a shipping address"
          })
        })
      }), /* @__PURE__ */jsxs50("div", {
        className: "pd:text-sm pd:text-dim-600",
        children: ["(", /* @__PURE__ */jsx73(FormattedMessage47, {
          id: "checkout.lineItem.quantityCount",
          defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
          values: {
            quantity: totalQuantity
          }
        }), ")"]
      })]
    }), /* @__PURE__ */jsx73(ShippingAddressButton_default, {
      lineItem,
      onClick: () => setIsModalOpen(true)
    }), /* @__PURE__ */jsx73(ShippingAddressModal_default, {
      lineItem,
      isOpen: isModalOpen,
      onClose: () => {
        queryClient.resetQueries({
          queryKey: ["getShippingOptions" /* getShippingOptions */, lineItem.id, cartId]
        });
        invalidateCart();
        setIsModalOpen(false);
      }
    }), (hasSplitShipmentOnLineItem || hasPickupPointOnLineItem) && /* @__PURE__ */jsxs50("div", {
      className: "pd:text-xs pd:text-dim-600",
      children: ["*", " ", hasSplitShipmentOnLineItem ? /* @__PURE__ */jsx73(FormattedMessage47, {
        id: "cart.address.replaceSplitShipmentWithShippingAddressExplanation",
        defaultMessage: "If you change to a different shipping address, it will automatically replace the extra addresses you have currently selected."
      }) : /* @__PURE__ */jsx73(FormattedMessage47, {
        id: "cart.address.replacePickupPointWithShippingAddressExplanation",
        defaultMessage: "If you change to a different shipping address, it will automatically replace the pickup point you have currently selected."
      })]
    })]
  });
};
var LineItemShippingAddress_default = LineItemShippingAddress;

// src/library/components/line-item/split-shipment/SplitShipmentSelector.tsx
import { Heading as Heading13, Tooltip as Tooltip5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage51, useIntl as useIntl29 } from "react-intl";
import { useEffect as useEffect31, useState as useState23 } from "react";
import { AddressContent as AddressContent2, countries as countries2 } from "@printdeal/address-frontend";
import { configurationProvider as configurationProvider10 } from "@printdeal/configuration";
import { hasPickupPoint as hasPickupPoint4 } from "@printdeal/business-logic";
import { CustomLineItemHelper as CustomLineItemHelper6, LineItemHelper as LineItemHelper13 } from "@printdeal/ecommerce-helpers";

// src/library/components/line-item/split-shipment/SplitShipmentButton.tsx
import { LinkAsButton as LinkAsButton13 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage48 } from "react-intl";
import { LineItemHelper as LineItemHelper11 } from "@printdeal/ecommerce-helpers";
import { Fragment as Fragment23, jsx as jsx74, jsxs as jsxs51 } from "react/jsx-runtime";
var SplitShipmentButton = _ref118 => {
  let {
    lineItem,
    unavailableReason,
    className,
    onClick
  } = _ref118;
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const shippingAddresses = LineItemHelper11.getLineItemShippingAddresses(lineItem);
  return /* @__PURE__ */jsxs51(LinkAsButton13, {
    iconBefore: shippingAddresses && shippingAddresses.length > 1 ? "edit" : "plus",
    variant: "secondary",
    className,
    onClick: () => {
      if (unavailableReason !== void 0 || shippingOptionsQuery.isLoading) {
        return;
      }
      onClick();
    },
    "aria-disabled": Boolean(unavailableReason !== void 0 || shippingOptionsQuery.isLoading),
    disabled: shippingOptionsQuery.isLoading,
    isLoading: shippingOptionsQuery.isLoading,
    children: [shippingAddresses && shippingAddresses.length > 1 ? /* @__PURE__ */jsx74(FormattedMessage48, {
      id: "checkout.splitshipment.changeExtraShippingAddresses",
      defaultMessage: "Change extra shipping addresses"
    }) : /* @__PURE__ */jsx74(FormattedMessage48, {
      id: "checkout.splitshipment.addExtraShippingAddresses",
      defaultMessage: "Add extra shipping addresses"
    }), shippingOptionsQuery.data && shippingOptionsQuery.data.splitShipment.price && /* @__PURE__ */jsxs51(Fragment23, {
      children: [" (", /* @__PURE__ */jsx74(Money_default, {
        value: shippingOptionsQuery.data.splitShipment.price.centAmount,
        currency: shippingOptionsQuery.data.splitShipment.price.currencyCode
      }), ")"]
    })]
  });
};
var SplitShipmentButton_default = SplitShipmentButton;

// src/library/components/line-item/split-shipment/SplitShipmentModal.tsx
import { Alert as Alert12, Button as Button15, Checkbox, Label, LinkAsButton as LinkAsButton14, Modal as Modal6, TextInput as TextInput2, Transition, ValidationMessage } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage50, useIntl as useIntl28 } from "react-intl";
import { useCallback as useCallback4, useEffect as useEffect30, useMemo as useMemo9, useState as useState22 } from "react";
import clsx4 from "clsx";
import { AddressDeleteModal as AddressDeleteModal2, AddressFormSubmitButton as AddressFormSubmitButton2, AddressListView as AddressListView2, AddressPanel as AddressPanel2, countries, CreateAddressView as CreateAddressView2, UpdateAddressView as UpdateAddressView2 } from "@printdeal/address-frontend";
import { LineItemHelper as LineItemHelper12 } from "@printdeal/ecommerce-helpers";

// src/library/components/line-item/split-shipment/SplitShipmentAlertModal.tsx
import { Alert as Alert11, Modal as Modal5 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage49, useIntl as useIntl27 } from "react-intl";
import { jsx as jsx75, jsxs as jsxs52 } from "react/jsx-runtime";
var SplitShipmentAlertModal = _ref119 => {
  let {
    isModalOpen,
    setIsModalOpen,
    submitButton
  } = _ref119;
  const intl = useIntl27();
  return /* @__PURE__ */jsxs52(Modal5, {
    isOpen: isModalOpen,
    onClose: () => setIsModalOpen(!isModalOpen),
    dismissLabel: "Close",
    size: "sm",
    title: intl.formatMessage({
      id: "checkout.splitShipment.alertModal.title",
      defaultMessage: "Pay attention"
    }),
    children: [/* @__PURE__ */jsx75(Modal5.Content, {
      children: /* @__PURE__ */jsx75(Alert11, {
        variant: "warning",
        children: /* @__PURE__ */jsx75(FormattedMessage49, {
          id: "checkout.splitShipment.alertModal.content",
          defaultMessage: "You have changed one or more addresses. These changes have not yet been applied to your shopping cart. Apply these address changes to your shopping cart."
        })
      })
    }), /* @__PURE__ */jsx75(Modal5.Footer, {
      className: "pd:flex pd:flex-col pd:gap-2",
      children: submitButton
    })]
  });
};
var SplitShipmentAlertModal_default = SplitShipmentAlertModal;

// src/library/components/line-item/split-shipment/SplitShipmentModal.tsx
import { Fragment as Fragment24, jsx as jsx76, jsxs as jsxs53 } from "react/jsx-runtime";
var SplitShipmentModal = _ref120 => {
  let {
    lineItem,
    isOpen,
    onClose
  } = _ref120;
  const intl = useIntl28();
  const updateLineItemMutation = useUpdateLineItemMutation({
    context: "setSplitShipment" /* setSplitShipment */
  });
  const removeSplitShipmentMutation = useUpdateLineItemMutation({
    context: "setShippingAddress" /* setShippingAddress */
  });
  const shippingAddresses = LineItemHelper12.getLineItemShippingAddresses(lineItem);
  const defaultShippingAddress = shippingAddresses && shippingAddresses[0];
  const transformedShippingAddresses = useMemo9(() => {
    if (!shippingAddresses) return [];
    return shippingAddresses.map(shippingAddress => {
      const _a = shippingAddress,
        {
          quantity
        } = _a,
        address = __objRest(_a, ["quantity"]);
      return {
        address,
        quantity: Number(quantity)
      };
    });
  }, [shippingAddresses]);
  const [view, setView] = useState22("list");
  const [mutatingAddressId, setMutatingAddressId] = useState22();
  const [showSuccessAlertForCreatedAddressId, setShowSuccessAlertForCreatedAddressId] = useState22();
  const [showSuccessAlertForUpdatedAddressId, setShowSuccessAlertForUpdatedAddressId] = useState22();
  const [deleteAddressModalIsOpen, setDeleteAddressModalIsOpen] = useState22();
  const [selectedItems, setSelectedItems] = useState22([]);
  const [isAlertModalOpen, setIsAlertModalOpen] = useState22(false);
  const [submitCount, setSubmitCount] = useState22(0);
  useEffect30(() => {
    const lineItemShippingAddresses = LineItemHelper12.getLineItemShippingAddresses(lineItem);
    if (lineItemShippingAddresses) {
      setSelectedItems(lineItemShippingAddresses.map(shippingAddress => {
        const _a = shippingAddress,
          {
            quantity
          } = _a,
          address = __objRest(_a, ["quantity"]);
        return {
          address,
          quantity: Number(quantity)
        };
      }));
    }
  }, [lineItem]);
  const itemsWithoutQuantity = selectedItems.filter(item => !item.quantity);
  const invalidQuantityFields = useMemo9(() => selectedItems.filter(item => {
    if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
      return false;
    }
    if (item.quantity && item.quantity >= lineItem.quantity) {
      return true;
    }
    const totalSelectedQuantity = selectedItems.reduce((total, selectedItem) => total + (selectedItem.quantity || 0), 0);
    return totalSelectedQuantity > lineItem.quantity;
  }), [selectedItems, lineItem, defaultShippingAddress]);
  const calculateTotalQuantityForOthers = useCallback4((items, excludeAddressId) => items.reduce((total, item) => {
    if (defaultShippingAddress && item.address.id !== defaultShippingAddress.id && item.address.id !== excludeAddressId) {
      return total + (item.quantity || 0);
    }
    return total;
  }, 0), [defaultShippingAddress]);
  const deleteSelectedItem = useCallback4(addressId => {
    const updatedItems = selectedItems.filter(item => item.address.id !== addressId).map(item => {
      if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
        return __spreadProps(__spreadValues({}, item), {
          quantity: Math.max(lineItem.quantity - calculateTotalQuantityForOthers(selectedItems, addressId), 1)
        });
      }
      return item;
    });
    setSelectedItems(updatedItems);
  }, [selectedItems, defaultShippingAddress, lineItem, calculateTotalQuantityForOthers]);
  const closeModal = () => {
    onClose();
    updateLineItemMutation.reset();
    removeSplitShipmentMutation.reset();
    setView("list");
    setMutatingAddressId(void 0);
    setShowSuccessAlertForCreatedAddressId(void 0);
    setShowSuccessAlertForUpdatedAddressId(void 0);
    setSelectedItems(transformedShippingAddresses);
  };
  const handleSetSplitShipmentAddresses = () => {
    updateLineItemMutation.mutateAsync({
      lineItemId: lineItem.id,
      payload: {
        shippingAddresses: selectedItems.map(item => {
          var _a;
          return {
            address: __spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
              id: item.address.id.trim(),
              firstName: item.address.firstName.trim(),
              lastName: item.address.lastName.trim()
            }, item.address.email && {
              email: item.address.email.trim()
            }), item.address.phone && {
              phone: item.address.phone.trim()
            }), item.address.company && {
              company: item.address.company.trim()
            }), {
              country: item.address.country.trim(),
              postalCode: item.address.postalCode.trim(),
              streetNumber: item.address.streetNumber.trim(),
              streetName: item.address.streetName.trim(),
              city: item.address.city.trim()
            }), item.address.additionalStreetInfo && {
              additionalStreetInfo: item.address.additionalStreetInfo.trim()
            }),
            quantity: (_a = item.quantity) != null ? _a : 0
          };
        })
      }
    }).then(() => {
      onClose();
      setMutatingAddressId(void 0);
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      setSubmitCount(0);
      setIsAlertModalOpen(false);
      updateLineItemMutation.reset();
    }).catch(() => {
      setIsAlertModalOpen(false);
    });
  };
  return /* @__PURE__ */jsxs53(Modal6, {
    isOpen,
    onClose: () => {
      const hasUpdatedAddress = selectedItems.some(item => {
        const originalItem = transformedShippingAddresses.find(original => original.address.id === item.address.id);
        if (!originalItem) {
          return false;
        }
        return item.address.firstName !== originalItem.address.firstName || item.address.lastName !== originalItem.address.lastName || item.address.country !== originalItem.address.country || item.address.postalCode !== originalItem.address.postalCode || item.address.streetName !== originalItem.address.streetName || item.address.streetNumber !== originalItem.address.streetNumber || item.address.city !== originalItem.address.city || item.address.company !== originalItem.address.company || item.address.email !== originalItem.address.email || item.address.phone !== originalItem.address.phone || item.address.additionalStreetInfo !== originalItem.address.additionalStreetInfo;
      });
      if (hasUpdatedAddress) {
        setIsAlertModalOpen(true);
      } else {
        closeModal();
      }
    },
    size: "lg",
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    title: shippingAddresses && shippingAddresses.length > 1 ? /* @__PURE__ */jsx76(FormattedMessage50, {
      id: "checkout.splitShipment.changeExtraShippingAddresses",
      defaultMessage: "Change extra shipping addresses"
    }) : /* @__PURE__ */jsx76(FormattedMessage50, {
      id: "checkout.splitShipment.addExtraShippingAddresses",
      defaultMessage: "Add extra shipping addresses"
    }),
    children: [/* @__PURE__ */jsxs53(Modal6.Content, {
      className: clsx4("pd:h-[90vh]", {
        "pd:p-0": view === "list"
      }),
      children: [view === "list" && /* @__PURE__ */jsx76(AddressListView2, {
        className: "pd:p-4",
        showSuccessAlertForCreatedAddressId,
        showSuccessAlertForUpdatedAddressId,
        renderAddressPanel: (_a, focusedAddressId) => {
          var _b = _a,
            {
              address
            } = _b,
            data = __objRest(_b, ["address"]);
          const disabled = defaultShippingAddress && address.id === defaultShippingAddress.id;
          const currentSelectedItem = selectedItems.find(item => item.address.id === address.id);
          const checked = currentSelectedItem !== void 0;
          const minQuantityPerField = 1;
          const maxQuantityPerField = lineItem.quantity - (selectedItems.length - 1);
          const dropdownItems = [{
            title: intl.formatMessage({
              id: "checkout.editAddress",
              defaultMessage: "Edit address"
            }),
            iconBefore: "edit",
            onClick: () => {
              setMutatingAddressId(address.id);
              setShowSuccessAlertForCreatedAddressId(void 0);
              setShowSuccessAlertForUpdatedAddressId(void 0);
              setView("edit");
            }
          }];
          if (!data.isDefaultBillingAddress && !data.isDefaultShippingAddress) {
            dropdownItems.push({
              title: intl.formatMessage({
                id: "checkout.deleteAddress",
                defaultMessage: "Delete address"
              }),
              iconBefore: "trashcan",
              onClick: () => {
                setDeleteAddressModalIsOpen(address.id);
              }
            });
          }
          return /* @__PURE__ */jsxs53(Fragment24, {
            children: [/* @__PURE__ */jsx76(AddressPanel2, {
              address,
              isDefaultBillingAddress: data.isDefaultBillingAddress,
              isDefaultShippingAddress: data.isDefaultShippingAddress,
              className: focusedAddressId === address.id ? "pd:border-info-500" : void 0,
              dropdownItems,
              footer: /* @__PURE__ */jsxs53("div", {
                className: "pd:flex pd:w-full pd:flex-col pd:gap-4 pd:py-2",
                children: [/* @__PURE__ */jsxs53(Label, {
                  className: "pd:flex pd:items-center pd:gap-2 pd:self-start",
                  htmlFor: "split-shipment-checkbox-".concat(address.id),
                  children: [/* @__PURE__ */jsx76(Checkbox, {
                    id: "split-shipment-checkbox-".concat(address.id),
                    disabled,
                    checked: selectedItems.find(item => item.address.id === address.id) !== void 0,
                    onChange: () => {
                      if (selectedItems.find(item => item.address.id === address.id) !== void 0) {
                        deleteSelectedItem(address.id);
                      } else {
                        const newSelectedItems = [...selectedItems, {
                          address,
                          quantity: minQuantityPerField
                        }];
                        const updatedSelectedItems = newSelectedItems.map(item => {
                          if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
                            return __spreadProps(__spreadValues({}, item), {
                              quantity: lineItem.quantity - calculateTotalQuantityForOthers(newSelectedItems)
                            });
                          }
                          return item;
                        });
                        setSelectedItems(updatedSelectedItems);
                      }
                    }
                  }), /* @__PURE__ */jsx76(FormattedMessage50, {
                    id: "checkout.button.selectAddress",
                    defaultMessage: "Select address"
                  })]
                }), /* @__PURE__ */jsx76(Transition, {
                  show: checked,
                  variant: "appear",
                  children: /* @__PURE__ */jsx76(Label, {
                    htmlFor: "split-shipment-quantity-".concat(address.id),
                    className: "pd:font-normal",
                    children: /* @__PURE__ */jsx76(FormattedMessage50, {
                      id: "checkout.splitShipment.quantityPerShippingAddress",
                      defaultMessage: "Ship {quantityField} {quantity, plural, one {piece} other {pieces}} to this address (of {total} total)",
                      values: {
                        total: lineItem.quantity,
                        quantity: (currentSelectedItem == null ? void 0 : currentSelectedItem.quantity) || 0,
                        quantityField: /* @__PURE__ */jsx76(TextInput2, {
                          id: "split-shipment-quantity-".concat(address.id),
                          type: "number",
                          disabled,
                          value: currentSelectedItem && currentSelectedItem.quantity && (currentSelectedItem.quantity < minQuantityPerField ? minQuantityPerField : currentSelectedItem.quantity),
                          onChange: event => {
                            const trimmedValue = event.target.value.trim();
                            const parsedValue = trimmedValue === "" ? void 0 : Number.parseInt(trimmedValue, 10);
                            const updatedItems = selectedItems.map(item => {
                              if (defaultShippingAddress && item.address.id === defaultShippingAddress.id) {
                                const totalQuantityForOthers = calculateTotalQuantityForOthers(selectedItems, address.id);
                                const remainingQuantity = lineItem.quantity - totalQuantityForOthers - (parsedValue || 0);
                                return __spreadProps(__spreadValues({}, item), {
                                  quantity: remainingQuantity < 1 ? 1 : remainingQuantity
                                });
                              }
                              if (item.address.id === address.id) {
                                return __spreadProps(__spreadValues({}, item), {
                                  quantity: parsedValue
                                });
                              }
                              return item;
                            });
                            setSelectedItems(updatedItems);
                          },
                          min: minQuantityPerField,
                          max: maxQuantityPerField,
                          step: 1,
                          className: "pd:inline-flex pd:w-40",
                          validation: currentSelectedItem && (invalidQuantityFields.includes(currentSelectedItem) || submitCount > 0 && itemsWithoutQuantity.includes(currentSelectedItem)) ? "error" : void 0
                        })
                      }
                    })
                  })
                }), currentSelectedItem && invalidQuantityFields.includes(currentSelectedItem) && /* @__PURE__ */jsx76(ValidationMessage, {
                  variant: "error",
                  htmlFor: "split-shipment-quantity-".concat(address.id),
                  children: /* @__PURE__ */jsx76(FormattedMessage50, {
                    id: "checkout.splitShipment.invalidQuantity",
                    defaultMessage: "The quantity entered is {quantityTooHigh} {quantityTooHigh, plural, one {piece} other {pieces}} too high.{br} Reduce the quantity to stay within the total ({total} {total, plural, one {piece} other {pieces}})",
                    values: {
                      total: lineItem.quantity,
                      quantityTooHigh: Math.max(selectedItems.reduce((total, selectedItem) => total + (selectedItem.quantity || 0), 0) - lineItem.quantity, 0),
                      br: /* @__PURE__ */jsx76("br", {})
                    }
                  })
                })]
              })
            }, address.id), /* @__PURE__ */jsx76(AddressDeleteModal2, {
              addressId: address.id,
              isModalOpen: deleteAddressModalIsOpen === address.id,
              setIsModalOpen: setDeleteAddressModalIsOpen,
              onSuccess: () => {
                deleteSelectedItem(address.id);
                setShowSuccessAlertForCreatedAddressId(void 0);
                setShowSuccessAlertForUpdatedAddressId(void 0);
                setMutatingAddressId(void 0);
              }
            })]
          });
        },
        filterByCountry: defaultShippingAddress == null ? void 0 : defaultShippingAddress.country,
        alert: /* @__PURE__ */jsxs53("div", {
          className: "pd:flex pd:flex-col pd:gap-4",
          children: [/* @__PURE__ */jsx76("div", {
            className: "pd:self-end",
            children: /* @__PURE__ */jsx76(Button15, {
              variant: "secondary",
              iconBefore: "plus",
              onClick: () => setView("create"),
              children: /* @__PURE__ */jsx76(FormattedMessage50, {
                id: "checkout.addAddress",
                defaultMessage: "Add address"
              })
            })
          }), defaultShippingAddress && /* @__PURE__ */jsx76(Alert12, {
            variant: "info",
            children: defaultShippingAddress.country in countries ? /* @__PURE__ */jsx76(FormattedMessage50, {
              id: "checkout.splitShipment.filteredByCountryExplanation",
              defaultMessage: "Note: at this moment you can only select addresses within the following country: {country}.",
              values: {
                country: intl.formatMessage(countries[defaultShippingAddress.country])
              }
            }) : /* @__PURE__ */jsx76(FormattedMessage50, {
              id: "checkout.splitShipment.filteredByCountryExplanation",
              defaultMessage: "Note: at this moment you can only select addresses within the following country: {country}.",
              values: {
                country: defaultShippingAddress.country
              }
            })
          }), (updateLineItemMutation.isError || removeSplitShipmentMutation.isError) && /* @__PURE__ */jsx76(ErrorAlert_default, {
            className: "pd:m-0",
            scrollIntoView: true,
            exception: {
              exception: updateLineItemMutation.error || removeSplitShipmentMutation.error,
              tags: {
                fileLocation: "SplitShipmentModal.tsx",
                featureFunction: "SplitShipmentModal"
              },
              fingerprint: ["checkout", "splitShipment"]
            },
            children: /* @__PURE__ */jsx76(FormattedMessage50, {
              id: "checkout.splitShipment.error",
              defaultMessage: "An error occurred while updating the shipping addresses. Please try again."
            })
          }), itemsWithoutQuantity.length > 0 && submitCount > 0 && /* @__PURE__ */jsx76(ErrorAlert_default, {
            className: "pd:m-0",
            scrollIntoView: true,
            children: /* @__PURE__ */jsx76(FormattedMessage50, {
              id: "checkout.splitShipment.quantityRequired",
              defaultMessage: "You have not yet entered a quantity for all your selected addresses. Make sure all addresses have a quantity entered."
            })
          })]
        })
      }), view === "create" && /* @__PURE__ */jsx76(CreateAddressView2, {
        onSubmitSuccess: address => {
          setShowSuccessAlertForCreatedAddressId(address.id);
          setView("list");
        }
      }), view === "edit" && /* @__PURE__ */jsx76(UpdateAddressView2, {
        mutatingAddressId,
        onSubmitSuccess: address => {
          const items = selectedItems.map(item => {
            if (item.address.id === mutatingAddressId) {
              return {
                address,
                quantity: item.quantity
              };
            }
            return item;
          });
          setSelectedItems(items);
          setShowSuccessAlertForUpdatedAddressId(mutatingAddressId);
          setView("list");
        }
      }), /* @__PURE__ */jsx76(SplitShipmentAlertModal_default, {
        isModalOpen: isAlertModalOpen,
        setIsModalOpen: setIsAlertModalOpen,
        submitButton: /* @__PURE__ */jsx76(Button15, {
          className: "pd:w-full",
          isLoading: updateLineItemMutation.isPending,
          disabled: invalidQuantityFields.length > 0,
          onClick: () => {
            setSubmitCount(submitCount + 1);
            if (itemsWithoutQuantity.length === 0) {
              handleSetSplitShipmentAddresses();
            } else {
              setIsAlertModalOpen(false);
            }
          },
          children: /* @__PURE__ */jsx76(FormattedMessage50, {
            id: "checkout.splitShipment.confirmSelectedAddresses",
            defaultMessage: "Confirm selected addresses ({count})",
            values: {
              count: selectedItems.length
            }
          })
        })
      })]
    }), /* @__PURE__ */jsxs53(Modal6.Footer, {
      children: [view === "list" && /* @__PURE__ */jsxs53("div", {
        className: "pd:flex pd:justify-end pd:gap-2",
        children: [shippingAddresses && shippingAddresses.length > 1 && defaultShippingAddress && /* @__PURE__ */jsx76(Button15, {
          variant: "secondary",
          isLoading: removeSplitShipmentMutation.isPending,
          onClick: () => {
            const items = [{
              address: (_a => {
                var _b = _a,
                  {
                    quantity
                  } = _b,
                  rest = __objRest(_b, ["quantity"]);
                return rest;
              })(defaultShippingAddress),
              quantity: lineItem.quantity
            }];
            removeSplitShipmentMutation.mutateAsync({
              lineItemId: lineItem.id,
              // @ts-expect-error
              payload: {
                shippingAddresses: items
              }
            }).then(() => {
              onClose();
              setMutatingAddressId(void 0);
              setShowSuccessAlertForCreatedAddressId(void 0);
              setShowSuccessAlertForUpdatedAddressId(void 0);
              setSelectedItems(items);
              removeSplitShipmentMutation.reset();
            });
          },
          children: /* @__PURE__ */jsx76(FormattedMessage50, {
            id: "checkout.splitShipment.deleteExtraShippingAddresses",
            defaultMessage: "Delete extra shipping addresses"
          })
        }), /* @__PURE__ */jsx76(Button15, {
          isLoading: updateLineItemMutation.isPending,
          disabled: invalidQuantityFields.length > 0,
          onClick: () => {
            setSubmitCount(submitCount + 1);
            if (itemsWithoutQuantity.length === 0) {
              handleSetSplitShipmentAddresses();
            }
          },
          children: /* @__PURE__ */jsx76(FormattedMessage50, {
            id: "checkout.splitShipment.confirmSelectedAddresses",
            defaultMessage: "Confirm selected addresses ({count})",
            values: {
              count: selectedItems.length
            }
          })
        })]
      }), (view === "create" || view === "edit") && /* @__PURE__ */jsxs53("div", {
        className: "pd:flex pd:items-center pd:justify-between",
        children: [/* @__PURE__ */jsx76(LinkAsButton14, {
          className: "pd:text-sm",
          iconBefore: "chevron-left",
          variant: "secondary",
          onClick: () => {
            setShowSuccessAlertForCreatedAddressId(void 0);
            setShowSuccessAlertForUpdatedAddressId(void 0);
            setView("list");
          },
          children: /* @__PURE__ */jsx76(FormattedMessage50, {
            id: "checkout.backToAddressList",
            defaultMessage: "Back to address list"
          })
        }), /* @__PURE__ */jsx76(AddressFormSubmitButton2, {})]
      })]
    })]
  });
};
var SplitShipmentModal_default = SplitShipmentModal;

// src/library/components/line-item/split-shipment/SplitShipmentSelector.tsx
import { jsx as jsx77, jsxs as jsxs54 } from "react/jsx-runtime";
var SplitShipmentSelector = _ref121 => {
  let {
    lineItem
  } = _ref121;
  const intl = useIntl29();
  const shippingOptionsQuery = useGetLineItemOptionsQuery({
    lineItemId: lineItem.id
  });
  const shippingAddresses = LineItemHelper13.getLineItemShippingAddresses(lineItem);
  const defaultShippingAddress = (shippingAddresses == null ? void 0 : shippingAddresses.length) ? shippingAddresses[0] : void 0;
  const extraShippingAddresses = (shippingAddresses == null ? void 0 : shippingAddresses.length) ? shippingAddresses.slice(1) : [];
  const {
    cart
  } = useCart();
  const [unavailableReason, setUnavailableReason] = useState23();
  const [isModalOpen, setIsModalOpen] = useState23(false);
  useEffect31(() => {
    if (shippingOptionsQuery.data) {
      if (shippingOptionsQuery.data.splitShipment.isAllowed === false) {
        setUnavailableReason(1 /* NotPossibleForProduct */);
      } else if (shippingAddresses && shippingAddresses.length && defaultShippingAddress && !configurationProvider10.getValueAsArray("SPLIT_SHIPPING_COUNTRIES").includes(defaultShippingAddress.country)) {
        setUnavailableReason(0 /* NotPossibleForCountry */);
      } else if (LineItemHelper13.hasLineItemTimedDelivery(lineItem)) {
        setUnavailableReason(2 /* HasDeliveryOptionsOnLineItem */);
      } else if (hasPickupPoint4(lineItem)) {
        setUnavailableReason(3 /* HasPickupPointOnLineItem */);
      } else if (shippingAddresses && !shippingAddresses.length) {
        setUnavailableReason(4 /* HasNoDefaultAddressOnLineItem */);
      } else if ((cart == null ? void 0 : cart.customLineItems) && CustomLineItemHelper6.getAssociatedCustomLineItems(cart.customLineItems, lineItem.id, "courierService").length) {
        setUnavailableReason(5 /* HasCourierOnLineItem */);
      } else {
        setUnavailableReason(void 0);
      }
    }
    if (shippingOptionsQuery.error) {
      setUnavailableReason(6 /* CouldNotFetchSplitShipmentOptions */);
    }
  }, [defaultShippingAddress, lineItem, shippingAddresses, shippingOptionsQuery.data, shippingOptionsQuery.error, cart == null ? void 0 : cart.customLineItems]);
  const getTooltipText = reason => {
    switch (reason) {
      case 0 /* NotPossibleForCountry */:
        return intl.formatMessage({
          id: "splitShipment.notPossibleForCountry",
          defaultMessage: "Extra addresses are currently not possible for this country: {country}"
        }, {
          country: intl.formatMessage(countries2[defaultShippingAddress == null ? void 0 : defaultShippingAddress.country])
        });
      case 1 /* NotPossibleForProduct */:
        return intl.formatMessage({
          id: "splitShipment.notPossibleWithProduct",
          defaultMessage: "Extra addresses are currently not possible for this product"
        });
      case 2 /* HasDeliveryOptionsOnLineItem */:
        return intl.formatMessage({
          id: "splitShipment.cannotBeCombinedWithDeliveryOptions",
          defaultMessage: "Extra addresses cannot be combined with a delivery options"
        });
      case 3 /* HasPickupPointOnLineItem */:
        return intl.formatMessage({
          id: "splitShipment.cannotBeCombinedWithPickupPoint",
          defaultMessage: "Extra addresses cannot be combined with a pickup point"
        });
      case 4 /* HasNoDefaultAddressOnLineItem */:
        return intl.formatMessage({
          id: "splitShipment.hasNoDefaultAddressOnLineItem",
          defaultMessage: "Set a default shipping address first"
        });
      case 5 /* HasCourierOnLineItem */:
        return intl.formatMessage({
          id: "splitShipment.cannotBeCombinedWithCourier",
          defaultMessage: "Extra addresses cannot be combined with a courier"
        });
      case 6 /* CouldNotFetchSplitShipmentOptions */:
      default:
        return intl.formatMessage({
          id: "splitShipment.couldNotFetchSplitShipmentOptions",
          defaultMessage: "Could not fetch split shipment options"
        });
    }
  };
  return /* @__PURE__ */jsxs54("div", {
    className: "pd:flex pd:flex-col pd:gap-2",
    children: [/* @__PURE__ */jsx77(Heading13, {
      as: "h4",
      className: "pd:mb-2",
      children: /* @__PURE__ */jsx77(FormattedMessage51, {
        id: "checkout.extraDeliveryAddresses",
        defaultMessage: "Extra delivery addresses"
      })
    }), extraShippingAddresses.map((shippingAddress, index) => /* @__PURE__ */jsxs54("div", {
      children: [/* @__PURE__ */jsxs54("span", {
        className: "pd:font-bold",
        children: [/* @__PURE__ */jsx77(FormattedMessage51, {
          id: "checkout.extraDeliveryAddress",
          defaultMessage: "Address {number}",
          values: {
            number: index + 2
          }
        }), ":"]
      }), /* @__PURE__ */jsx77(AddressContent2, {
        address: shippingAddress,
        showFirstAndLastName: true
      }), /* @__PURE__ */jsxs54("div", {
        className: "pd:text-sm pd:text-dim-600",
        children: ["(", /* @__PURE__ */jsx77(FormattedMessage51, {
          id: "checkout.lineItem.quantityCount",
          defaultMessage: "{quantity} {quantity, plural, one {piece} other {pieces}}",
          values: {
            quantity: shippingAddress.quantity
          }
        }), ")"]
      })]
    }, shippingAddress.id)), unavailableReason === void 0 ? /* @__PURE__ */jsx77(SplitShipmentButton_default, {
      lineItem,
      unavailableReason,
      className: "pd:self-start pd:text-sm",
      onClick: () => setIsModalOpen(true)
    }) : /* @__PURE__ */jsx77(Tooltip5, {
      placement: "top",
      trigger: /* @__PURE__ */jsx77(Tooltip5.Trigger, {
        as: SplitShipmentButton_default,
        lineItem,
        unavailableReason,
        className: "pd:self-start pd:text-sm",
        onClick: () => setIsModalOpen(true)
      }),
      children: getTooltipText(unavailableReason)
    }), /* @__PURE__ */jsx77(SplitShipmentModal_default, {
      lineItem,
      isOpen: isModalOpen,
      onClose: () => setIsModalOpen(false)
    })]
  });
};
var SplitShipmentSelector_default = SplitShipmentSelector;

// src/library/components/line-item/DirectMailing.tsx
import { useMemo as useMemo10 } from "react";
import { FormattedMessage as FormattedMessage52 } from "react-intl";
import { Alert as Alert13, DescriptionList as DescriptionList3, Heading as Heading14 } from "@printdeal/ui-library";
import { Fragment as Fragment25, jsx as jsx78, jsxs as jsxs55 } from "react/jsx-runtime";
var DirectMailing = _ref122 => {
  let {
    lineItem
  } = _ref122;
  var _a;
  const userSelection = (_a = lineItem.custom) == null ? void 0 : _a.fields.userSelection;
  const {
    withinNetherlands,
    outsideNetherlands
  } = useMemo10(() => {
    var _a2;
    return (_a2 = userSelection == null ? void 0 : userSelection.reduce((acc, attribute) => {
      const [key, value] = attribute.split(":");
      switch (key) {
        case "Addresses Within The Netherlands":
          acc.withinNetherlands = value != null ? value : "";
          break;
        case "Addresses Outside The Netherlands":
          acc.outsideNetherlands = value != null ? value : "";
          break;
        default:
          break;
      }
      return acc;
    }, {})) != null ? _a2 : {};
  }, [userSelection]);
  const extraAddresses = useMemo10(() => {
    if (!withinNetherlands || !outsideNetherlands) {
      return lineItem.quantity;
    }
    return lineItem.quantity - (Number(withinNetherlands) + Number(outsideNetherlands));
  }, [lineItem.quantity, withinNetherlands, outsideNetherlands]);
  return /* @__PURE__ */jsxs55("div", {
    className: "pd:mt-4 pd:grid pd:grid-cols-2 pd:gap-4",
    children: [/* @__PURE__ */jsxs55("div", {
      className: "pd:col-span-2 pd:md:col-span-1",
      children: [/* @__PURE__ */jsx78(LineItemShippingAddress_default, {
        lineItem
      }), /* @__PURE__ */jsx78("hr", {
        className: "pd:my-5 pd:sm:hidden"
      })]
    }), /* @__PURE__ */jsxs55("div", {
      className: "pd:col-span-2 pd:md:col-span-1 pd:flex pd:flex-col pd:gap-3",
      children: [/* @__PURE__ */jsx78(Heading14, {
        as: "h4",
        children: /* @__PURE__ */jsx78(FormattedMessage52, {
          id: "checkout.lineItem.directMailing.title",
          defaultMessage: "Direct mailing"
        })
      }), (withinNetherlands || outsideNetherlands || extraAddresses > 0) && /* @__PURE__ */jsxs55(DescriptionList3, {
        className: "pd:grid-cols-[80%_auto]",
        children: [withinNetherlands && /* @__PURE__ */jsxs55(Fragment25, {
          children: [/* @__PURE__ */jsx78(DescriptionList3.Title, {
            children: /* @__PURE__ */jsx78(FormattedMessage52, {
              id: "checkout.lineItem.directMailing.withinNetherlands",
              defaultMessage: "Addresses within the Netherlands"
            })
          }), /* @__PURE__ */jsx78(DescriptionList3.Content, {
            children: withinNetherlands
          })]
        }), outsideNetherlands && /* @__PURE__ */jsxs55(Fragment25, {
          children: [/* @__PURE__ */jsx78(DescriptionList3.Title, {
            children: /* @__PURE__ */jsx78(FormattedMessage52, {
              id: "checkout.lineItem.directMailing.outsideNetherlands",
              defaultMessage: "Addresses outside the Netherlands"
            })
          }), /* @__PURE__ */jsx78(DescriptionList3.Content, {
            children: outsideNetherlands
          })]
        }), extraAddresses > 0 && /* @__PURE__ */jsxs55(Fragment25, {
          children: [/* @__PURE__ */jsx78(DescriptionList3.Title, {
            children: /* @__PURE__ */jsx78(FormattedMessage52, {
              id: "checkout.lineItem.directMailing.extraAddresses",
              defaultMessage: "Extra addresses"
            })
          }), /* @__PURE__ */jsx78(DescriptionList3.Content, {
            children: extraAddresses
          })]
        })]
      }), /* @__PURE__ */jsx78(Alert13, {
        variant: "info",
        hasIcon: false,
        children: /* @__PURE__ */jsx78(FormattedMessage52, {
          id: "checkout.lineItem.directMailing.info",
          defaultMessage: "Upload your address list for the direct mailing after you have confirmed your order and we take over the mailing process."
        })
      })]
    })]
  });
};
var DirectMailing_default = DirectMailing;

// src/library/components/design-system/checkout/delivery-page/DeliveryLineItem.tsx
import { Fragment as Fragment26, jsx as jsx79, jsxs as jsxs56 } from "react/jsx-runtime";
var DeliveryLineItem = _ref123 => {
  let {
    lineItem
  } = _ref123;
  const {
    cart
  } = useCart();
  usePrefetchAddresses2();
  const {
    featureToggle: {
      isEnabled: isSplitshipmentEnabled
    }
  } = useFeatureToggle("checkout_split_shipment_toggle");
  const {
    featureToggle: {
      isEnabled: isPickuppointEnabled
    }
  } = useFeatureToggle("checkout_pickuppoint_toggle");
  const [isProductDetailsOpen, setIsProductDetailsOpen] = useState24(false);
  return /* @__PURE__ */jsxs56(LineItemPanel_default, {
    lineItem,
    showLineItemActions: false,
    children: [/* @__PURE__ */jsxs56("div", {
      className: "pd:mb-3 pd:flex pd:justify-between pd:gap-4",
      children: [/* @__PURE__ */jsx79(LineItemTitle_default, {
        lineItem
      }), /* @__PURE__ */jsx79(Transition2, {
        show: isProductDetailsOpen,
        variant: "appear",
        children: /* @__PURE__ */jsx79(LineItemPrice_default, {
          lineItem
        })
      })]
    }), cart && /* @__PURE__ */jsx79(Transition2, {
      show: isProductDetailsOpen,
      variant: "appear",
      children: /* @__PURE__ */jsxs56("div", {
        className: "pd:mb-2 pd:flex pd:justify-between pd:gap-4",
        children: [/* @__PURE__ */jsx79("div", {
          className: "pd:grow",
          children: /* @__PURE__ */jsx79(LineItemDescription_default, {
            lineItem,
            entity: cart
          })
        }), /* @__PURE__ */jsx79(LineItemArtwork_default, {
          lineItem,
          entity: cart
        })]
      })
    }), /* @__PURE__ */jsx79(LinkAsButton15, {
      variant: "secondary",
      onClick: () => {
        setIsProductDetailsOpen(!isProductDetailsOpen);
        addDataLayerEntry16("show_product_details");
      },
      iconAfter: isProductDetailsOpen ? "double-chevron-up" : "double-chevron-down",
      className: "pd:text-xs",
      children: isProductDetailsOpen ? /* @__PURE__ */jsx79(FormattedMessage53, {
        id: "checkout.hideProductDetails",
        defaultMessage: "Hide product details"
      }) : /* @__PURE__ */jsx79(FormattedMessage53, {
        id: "checkout.showProductDetails",
        defaultMessage: "Show product details"
      })
    }), isProductDetailsOpen && /* @__PURE__ */jsx79("hr", {
      className: "pd:mt-4"
    }), isSpecificOrchestration2(lineItem, "Direct mailing") ? /* @__PURE__ */jsx79(DirectMailing_default, {
      lineItem
    }) : /* @__PURE__ */jsxs56("div", {
      className: "pd:mt-4 pd:grid pd:grid-cols-2 pd:gap-4",
      children: [/* @__PURE__ */jsxs56("div", {
        className: "pd:col-span-2 pd:md:col-span-1",
        children: [/* @__PURE__ */jsx79(LineItemShippingAddress_default, {
          lineItem
        }), /* @__PURE__ */jsx79("hr", {
          className: "pd:my-5 pd:sm:hidden"
        })]
      }), /* @__PURE__ */jsxs56("div", {
        className: "pd:col-span-2 pd:md:col-span-1",
        children: [configurationProvider11.getValueAsBoolean("DELIVERY_OPTIONS_ENABLED") && /* @__PURE__ */jsxs56(Fragment26, {
          children: [/* @__PURE__ */jsx79(DeliveryOptionSelector_default, {
            lineItem
          }), (isSplitshipmentEnabled || isPickuppointEnabled) && /* @__PURE__ */jsx79("hr", {
            className: "pd:my-5"
          })]
        }), configurationProvider11.getValueAsBoolean("SPLIT_SHIPPING_ENABLED") && /* @__PURE__ */jsxs56(Fragment26, {
          children: [/* @__PURE__ */jsx79(SplitShipmentSelector_default, {
            lineItem
          }), isPickuppointEnabled && /* @__PURE__ */jsx79("hr", {
            className: "pd:my-5"
          })]
        }), configurationProvider11.getValueAsBoolean("PICKUP_POINTS_ENABLED") && /* @__PURE__ */jsx79(PickupPointSelector_default, {
          lineItem
        })]
      })]
    })]
  }, lineItem.id);
};
var DeliveryLineItem_default = DeliveryLineItem;

// src/library/components/cart/billing-address/BillingAddressSelector.tsx
import { useState as useState26 } from "react";

// src/library/components/cart/billing-address/BillingAddressButton.tsx
import { Button as Button16 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage54 } from "react-intl";
import { jsx as jsx80 } from "react/jsx-runtime";
var BillingAddressButton = _ref124 => {
  let {
    onClick
  } = _ref124;
  return /* @__PURE__ */jsx80(Button16, {
    className: "pd:self-start",
    variant: "secondary",
    iconBefore: "edit",
    onClick,
    children: /* @__PURE__ */jsx80(FormattedMessage54, {
      id: "checkout.changeBillingAddress",
      defaultMessage: "Change billing address"
    })
  });
};
var BillingAddressButton_default = BillingAddressButton;

// src/library/components/cart/billing-address/BillingAddressModal.tsx
import { Button as Button18, LinkAsButton as LinkAsButton16, Modal as Modal7 } from "@printdeal/ui-library";
import { useState as useState25 } from "react";
import clsx6 from "clsx";
import { AddressFormSubmitButton as AddressFormSubmitButton3, AddressListView as AddressListView3, CreateAddressView as CreateAddressView3, UpdateAddressView as UpdateAddressView3 } from "@printdeal/address-frontend";
import { FormattedMessage as FormattedMessage56, useIntl as useIntl31 } from "react-intl";

// src/library/components/cart/billing-address/BillingAddressPanel.tsx
import { useIntl as useIntl30 } from "react-intl";
import { AddressDeleteModal as AddressDeleteModal3, AddressPanel as AddressPanel3 } from "@printdeal/address-frontend";
import clsx5 from "clsx";
import { Fragment as Fragment27, jsx as jsx81, jsxs as jsxs57 } from "react/jsx-runtime";
var BillingAddressPanel = _ref125 => {
  let {
    address,
    isDefaultBillingAddress,
    isDefaultShippingAddress,
    focusedAddressId,
    setView,
    setMutatingAddressId,
    setShowSuccessAlertForCreatedAddressId,
    setShowSuccessAlertForUpdatedAddressId,
    deleteAddressModalIsOpen,
    setDeleteAddressModalIsOpen,
    footer
  } = _ref125;
  const intl = useIntl30();
  const validationErrors = useValidateAddress({
    address,
    requireEmail: true
  });
  return /* @__PURE__ */jsxs57(Fragment27, {
    children: [/* @__PURE__ */jsx81(AddressPanel3, {
      address,
      isDefaultBillingAddress,
      isDefaultShippingAddress,
      className: clsx5({
        "pd:border-info-500": focusedAddressId === address.id,
        "pd:border-error-500": validationErrors.length > 0
      }),
      dropdownItems: [{
        title: intl.formatMessage({
          id: "checkout.editAddress",
          defaultMessage: "Edit address"
        }),
        iconBefore: "edit",
        onClick: () => {
          setMutatingAddressId(address.id);
          setShowSuccessAlertForCreatedAddressId(void 0);
          setShowSuccessAlertForUpdatedAddressId(void 0);
          setView("edit");
        }
      }, ...(!isDefaultBillingAddress && !isDefaultShippingAddress ? [{
        title: intl.formatMessage({
          id: "checkout.deleteAddress",
          defaultMessage: "Delete address"
        }),
        iconBefore: "trashcan",
        onClick: () => {
          setDeleteAddressModalIsOpen(address.id);
        }
      }] : [])],
      footer
    }, address.id), /* @__PURE__ */jsx81(AddressDeleteModal3, {
      addressId: address.id,
      isModalOpen: deleteAddressModalIsOpen === address.id,
      setIsModalOpen: setDeleteAddressModalIsOpen,
      onSuccess: () => {
        setShowSuccessAlertForCreatedAddressId(void 0);
        setShowSuccessAlertForUpdatedAddressId(void 0);
        setMutatingAddressId(void 0);
      }
    })]
  });
};
var BillingAddressPanel_default = BillingAddressPanel;

// src/library/components/cart/billing-address/BillingAddressPanelFooter.tsx
import { Button as Button17, Alert as Alert14 } from "@printdeal/ui-library";
import { FormattedMessage as FormattedMessage55 } from "react-intl";
import { jsx as jsx82, jsxs as jsxs58 } from "react/jsx-runtime";
var BillingAddressPanelFooter = _ref126 => {
  let {
    address,
    patchCartMutation,
    mutatingAddressId,
    setView,
    setMutatingAddressId,
    setDeleteAddressModalIsOpen,
    onSuccess
  } = _ref126;
  const validationErrors = useValidateAddress({
    address,
    requireEmail: true
  });
  return validationErrors.length === 0 ? /* @__PURE__ */jsx82(Button17, {
    className: "pd:w-full pd:md:w-auto",
    isLoading: patchCartMutation.isPending && mutatingAddressId === address.id,
    onClick: () => {
      setMutatingAddressId(address.id);
      patchCartMutation.mutateAsync({
        action: {
          name: "setBillingAddress",
          value: __spreadValues(__spreadValues(__spreadValues(__spreadProps(__spreadValues(__spreadValues(__spreadValues({
            id: address.id.trim(),
            firstName: address.firstName.trim(),
            lastName: address.lastName.trim()
          }, address.email && {
            email: address.email.trim()
          }), address.phone && {
            phone: address.phone.trim()
          }), address.company && {
            company: address.company.trim()
          }), {
            country: address.country.trim(),
            postalCode: address.postalCode.trim(),
            streetNumber: address.streetNumber.trim(),
            streetName: address.streetName.trim(),
            city: address.city.trim()
          }), address.additionalStreetInfo && {
            additionalStreetInfo: address.additionalStreetInfo.trim()
          }), address.vatId && {
            vatId: address.vatId.trim()
          }), address.invoiceDispatcher && {
            invoiceDispatcher: address.invoiceDispatcher.trim()
          })
        }
      }).then(() => {
        patchCartMutation.reset();
        onSuccess();
      });
    },
    children: /* @__PURE__ */jsx82(FormattedMessage55, {
      id: "checkout.button.selectAddress",
      defaultMessage: "Select address"
    })
  }) : /* @__PURE__ */jsx82(Alert14, {
    variant: "error",
    children: /* @__PURE__ */jsxs58("div", {
      className: "pd:flex pd:flex-col pd:gap-2",
      children: [/* @__PURE__ */jsx82(FormattedMessage55, {
        id: "checkout.invalidAddress",
        defaultMessage: "This address can currently not be selected, because it is missing certain data or contains invalid data. To make the address usable again, you can edit the address and fix the validation errors. Alternatively, if you no longer need this address, you can delete it."
      }), /* @__PURE__ */jsx82("ul", {
        children: validationErrors.map(error => /* @__PURE__ */jsx82("li", {
          children: /* @__PURE__ */jsx82(AddressError_default, {
            error
          })
        }, error.path))
      }), /* @__PURE__ */jsxs58("div", {
        className: "pd:flex pd:gap-2",
        children: [/* @__PURE__ */jsx82(Button17, {
          variant: "secondary",
          iconBefore: "edit",
          onClick: () => {
            setMutatingAddressId(address.id);
            setView("edit");
          },
          children: /* @__PURE__ */jsx82(FormattedMessage55, {
            id: "checkout.editAddress",
            defaultMessage: "Edit address"
          })
        }), /* @__PURE__ */jsx82(Button17, {
          variant: "secondary",
          iconBefore: "trashcan",
          onClick: () => setDeleteAddressModalIsOpen(address.id),
          children: /* @__PURE__ */jsx82(FormattedMessage55, {
            id: "checkout.deleteAddress",
            defaultMessage: "Delete address"
          })
        })]
      })]
    })
  });
};
var BillingAddressPanelFooter_default = BillingAddressPanelFooter;

// src/library/components/cart/billing-address/BillingAddressModal.tsx
import { jsx as jsx83, jsxs as jsxs59 } from "react/jsx-runtime";
var BillingAddressModal = _ref127 => {
  let {
    isOpen,
    onClose
  } = _ref127;
  const intl = useIntl31();
  const patchCartMutation = usePatchCartMutation({
    context: {
      mutationKey: "setBillingAddress" /* setBillingAddress */
    }
  });
  const [view, setView] = useState25("list");
  const [mutatingAddressId, setMutatingAddressId] = useState25();
  const [showSuccessAlertForCreatedAddressId, setShowSuccessAlertForCreatedAddressId] = useState25();
  const [showSuccessAlertForUpdatedAddressId, setShowSuccessAlertForUpdatedAddressId] = useState25();
  const [deleteAddressModalIsOpen, setDeleteAddressModalIsOpen] = useState25();
  return /* @__PURE__ */jsxs59(Modal7, {
    isOpen,
    onClose: () => {
      patchCartMutation.reset();
      setView("list");
      setMutatingAddressId(void 0);
      setShowSuccessAlertForCreatedAddressId(void 0);
      setShowSuccessAlertForUpdatedAddressId(void 0);
      onClose();
    },
    size: "lg",
    dismissLabel: intl.formatMessage({
      id: "general.modal.close",
      defaultMessage: "Close"
    }),
    title: intl.formatMessage({
      id: "checkout.selectBillingAddress",
      defaultMessage: "Select billing address"
    }),
    children: [/* @__PURE__ */jsxs59(Modal7.Content, {
      className: clsx6("pd:h-[90vh]", {
        "pd:p-0": view === "list"
      }),
      children: [view === "list" && /* @__PURE__ */jsx83(AddressListView3, {
        className: "pd:p-4",
        showSuccessAlertForCreatedAddressId,
        showSuccessAlertForUpdatedAddressId,
        renderAddressPanel: (_a, focusedAddressId) => {
          var _b = _a,
            {
              address
            } = _b,
            data = __objRest(_b, ["address"]);
          return /* @__PURE__ */jsx83(BillingAddressPanel_default, {
            address,
            isDefaultBillingAddress: data.isDefaultBillingAddress,
            isDefaultShippingAddress: data.isDefaultShippingAddress,
            focusedAddressId,
            setView,
            setMutatingAddressId,
            setShowSuccessAlertForCreatedAddressId,
            setShowSuccessAlertForUpdatedAddressId,
            deleteAddressModalIsOpen,
            setDeleteAddressModalIsOpen,
            footer: /* @__PURE__ */jsx83(BillingAddressPanelFooter_default, {
              address,
              patchCartMutation,
              mutatingAddressId,
              setView,
              setMutatingAddressId,
              setDeleteAddressModalIsOpen,
              onSuccess: () => onClose()
            })
          });
        },
        alert: patchCartMutation.isError && /* @__PURE__ */jsx83(ErrorAlert_default, {
          className: "pd:m-0",
          scrollIntoView: true,
          exception: {
            exception: patchCartMutation.error,
            tags: {
              fileLocation: "BillingAddressModal.tsx",
              featureFunction: "BillingAddressModal"
            },
            fingerprint: ["checkout", "update-billing-address"]
          },
          children: /* @__PURE__ */jsx83(FormattedMessage56, {
            id: "checkout.billingAddress.error",
            defaultMessage: "An error occurred while updating the billing address. Please try again."
          })
        })
      }), view === "create" && /* @__PURE__ */jsx83(CreateAddressView3, {
        onSubmitSuccess: address => {
          setShowSuccessAlertForCreatedAddressId(address.id);
          setView("list");
        }
      }), view === "edit" && /* @__PURE__ */jsx83(UpdateAddressView3, {
        mutatingAddressId,
        onSubmitSuccess: () => {
          setShowSuccessAlertForUpdatedAddressId(mutatingAddressId);
          setView("list");
        }
      })]
    }), /* @__PURE__ */jsxs59(Modal7.Footer, {
      children: [view === "list" && /* @__PURE__ */jsx83("div", {
        className: "pd:flex pd:justify-end",
        children: /* @__PURE__ */jsx83(Button18, {
          variant: "secondary",
          iconBefore: "plus",
          onClick: () => setView("create"),
          children: /* @__PURE__ */jsx83(FormattedMessage56, {
            id: "checkout.addAddress",
            defaultMessage: "Add address"
          })
        })
      }), (view === "create" || view === "edit") && /* @__PURE__ */jsxs59("div", {
        className: "pd:flex pd:items-center pd:justify-between",
        children: [/* @__PURE__ */jsx83(LinkAsButton16, {
          className: "pd:text-sm",
          iconBefore: "chevron-left",
          variant: "secondary",
          onClick: () => {
            setShowSuccessAlertForCreatedAddressId(void 0);
            setShowSuccessAlertForUpdatedAddressId(void 0);
            setView("list");
          },
          children: /* @__PURE__ */jsx83(FormattedMessage56, {
            id: "checkout.backToAddressList",
            defaultMessage: "Back to address list"
          })
        }), /* @__PURE__ */jsx83(AddressFormSubmitButton3, {})]
      })]
    })]
  });
};
var BillingAddressModal_default = BillingAddressModal;

// src/library/components/cart/billing-address/BillingAddressSelector.tsx
import { Fragment as Fragment28, jsx as jsx84, jsxs as jsxs60 } from "react/jsx-runtime";
var BillingAddressSelector = () => {
  const [isModalOpen, setIsModalOpen] = useState26(false);
  return /* @__PURE__ */jsxs60(Fragment28, {
    children: [/* @__PURE__ */jsx84(BillingAddressButton_default, {
      onClick: () => setIsModalOpen(true)
    }), /* @__PURE__ */jsx84(BillingAddressModal_default, {
      isOpen: isModalOpen,
      onClose: () => setIsModalOpen(false)
    })]
  });
};
var BillingAddressSelector_default = BillingAddressSelector;

// src/library/views/DeliveryView.tsx
import { jsx as jsx85, jsxs as jsxs61 } from "react/jsx-runtime";
var DeliveryView = () => {
  const {
    cartId,
    cart: cartObject
  } = useCart();
  const {
    navigate,
    paths
  } = useContext15(CheckoutViewContext_default);
  usePrefetchedPaymentMethodsForCart();
  useValidateCartRedirectHook();
  usePrefetchAddresses3();
  useEffect32(() => {
    EcommerceObjectHelper.clearEcommerceObject();
    addDataLayerEntry17("begin_checkout", __spreadProps(__spreadValues({}, EcommerceObjectHelper.createEcommerceObject(cartObject)), {
      cartId,
      lineItemIds: cartObject == null ? void 0 : cartObject.lineItems.map(lineItem => lineItem.id)
    }));
    addDataLayerEntry17("view_delivery");
  }, [cartId, cartObject]);
  return /* @__PURE__ */jsxs61(Container3, {
    className: "pd:py-6",
    children: [/* @__PURE__ */jsx85(CheckoutStepper_default, {}), /* @__PURE__ */jsx85(Heading15, {
      as: "h1",
      className: "pd:mb-5",
      children: /* @__PURE__ */jsx85(FormattedMessage57, {
        id: "checkout.deliveryView.title",
        defaultMessage: "Delivery"
      })
    }), /* @__PURE__ */jsx85(CartQuery_default, {
      children: cart => {
        const lineItems = EntityHelper12.getMainGroupedLineItems(cart);
        return /* @__PURE__ */jsxs61("div", {
          className: "pd:grid pd:grid-cols-3 pd:items-start pd:gap-4",
          children: [/* @__PURE__ */jsx85("div", {
            className: "pd:col-span-3 pd:md:col-span-2",
            children: /* @__PURE__ */jsxs61("div", {
              className: "pd:grid pd:gap-4",
              children: [/* @__PURE__ */jsx85(CheckoutDevOnly_default, {
                jsonObject: {
                  cartId: cart.id,
                  cartVersion: cart.version
                }
              }), /* @__PURE__ */jsx85(DeliveryAlerts_default, {}), lineItems.map(lineItem => /* @__PURE__ */jsx85(DeliveryLineItem_default, {
                lineItem
              }, lineItem.id))]
            })
          }), /* @__PURE__ */jsxs61("div", {
            className: "pd:sticky pd:top-3 pd:col-span-3 pd:flex pd:flex-col pd:gap-4 pd:md:col-span-1",
            children: [/* @__PURE__ */jsx85("div", {
              className: "pd:order-1 pd:md:order-none",
              children: /* @__PURE__ */jsx85(CheckoutSummary_default, {
                nextStepButton: /* @__PURE__ */jsx85(Button19, {
                  className: "pd:w-full",
                  iconAfter: "chevron-right",
                  onClick: () => {
                    navigate(paths.paymentMethodPage.path).catch(() => {});
                    addDataLayerEntry17("delivery_next");
                  },
                  children: /* @__PURE__ */jsx85(FormattedMessage57, {
                    id: "checkout.nextStepToPaymentMethod",
                    defaultMessage: "To payment method"
                  })
                })
              })
            }), /* @__PURE__ */jsx85("div", {
              className: "pd:order-none pd:md:order-1",
              children: /* @__PURE__ */jsxs61(Panel11, {
                className: "pd:flex pd:flex-col pd:gap-3",
                children: [/* @__PURE__ */jsx85(Heading15, {
                  as: "h4",
                  children: /* @__PURE__ */jsx85(FormattedMessage57, {
                    id: "checkout.billingAddress",
                    defaultMessage: "Billing address"
                  })
                }), cart.billingAddress && AddressHelper2.isAddressComplete(cart.billingAddress) ? /* @__PURE__ */jsx85(AddressContent3, {
                  address: cart.billingAddress,
                  showFirstAndLastName: true,
                  showEmail: true
                }) : /* @__PURE__ */jsx85(Alert15, {
                  variant: "error",
                  children: /* @__PURE__ */jsx85(FormattedMessage57, {
                    id: "checkout.billingAddressNotSet",
                    defaultMessage: "Please select a billing address"
                  })
                }), /* @__PURE__ */jsx85(BillingAddressSelector_default, {})]
              })
            })]
          })]
        });
      }
    })]
  });
};
var DeliveryView_default = DeliveryView;

// src/library/queries/order/usePatchOrderMutation.ts
import { useMutation as useMutation13, useQueryClient as useQueryClient5 } from "@tanstack/react-query";
import { addDataLayerEntry as addDataLayerEntry18 } from "@printdeal/data-layer-manager";
import { useFeatureToggle as useFeatureToggle2 } from "@printdeal/feature-management/react";

// src/library/http-clients/OrderHttpClient.ts
import axios6 from "axios";
import { configurationProvider as configurationProvider12 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor5 } from "@printdeal/authentication";
import { getFeatureManagementUserId as getFeatureManagementUserId2 } from "@printdeal/feature-management/react";
var OrderHttpClient = class {
  get client() {
    var _a;
    if (!this.httpClient) {
      const baseURL = configurationProvider12.getValue("ECOMMERCE_ORDER_API_BASE_URL");
      this.httpClient = axios6.create({
        baseURL,
        headers: {
          "Feature-Management-User-Id": (_a = getFeatureManagementUserId2()) != null ? _a : ""
        }
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor5);
    }
    return this.httpClient;
  }
  patchLineItem(_0, _1) {
    return __async(this, arguments, function (orderId, _ref128) {
      var _this2 = this;
      let {
        payload,
        lineItemId
      } = _ref128;
      return function* () {
        return _this2.client.patch("order/".concat(orderId, "/lineitems/").concat(lineItemId), payload);
      }();
    });
  }
  getOrder(orderId) {
    return __async(this, null, function* () {
      return this.client.get("order/".concat(orderId));
    });
  }
  patchOrder(orderId, payload) {
    return __async(this, null, function* () {
      return this.client.patch("order/".concat(orderId), payload);
    });
  }
  getOrders(_a) {
    return __async(this, null, function* () {
      var _b = _a,
        {
          where,
          mappedStates: _
        } = _b,
        props = __objRest(_b, ["where", "mappedStates"]);
      return this.client.get("order", {
        params: __spreadValues(__spreadValues({}, (where == null ? void 0 : where.length) && {
          where
        }), Object.entries(props).reduce((previousValue, _ref129) => {
          let [key, value] = _ref129;
          return __spreadValues(__spreadValues({}, previousValue), value && {
            [key]: value
          });
        }, {}))
      });
    });
  }
  getOrderStats() {
    return __async(this, null, function* () {
      return this.client.get("order/stats");
    });
  }
  cancelOrder(_0, _1) {
    return __async(this, arguments, function (orderId, _ref130) {
      var _this3 = this;
      let {
        lineItemIds
      } = _ref130;
      return function* () {
        return _this3.client.patch("order/".concat(orderId, "/cancel"), {
          lineItemIds
        });
      }();
    });
  }
};
var orderHttpClient = new OrderHttpClient();
var OrderHttpClient_default = orderHttpClient;

// src/library/http-clients/LegacyOrderHttpClient.ts
import axios7 from "axios";
import { configurationProvider as configurationProvider13 } from "@printdeal/configuration";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor6 } from "@printdeal/authentication";
var LegacyOrderHttpClient = class {
  get client() {
    if (!this.httpClient) {
      const baseURL = configurationProvider13.getValue("ORDER_API_BASE_URL");
      this.httpClient = axios7.create({
        baseURL
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor6);
    }
    return this.httpClient;
  }
  setBillingAddress(_0) {
    return __async(this, arguments, function (_ref131) {
      var _this4 = this;
      let {
        address,
        orderId
      } = _ref131;
      return function* () {
        const {
          data: {
            message
          }
        } = yield _this4.client.post("/order/setBillingAddress?id=".concat(orderId), {
          address
        });
        return message;
      }();
    });
  }
  setShippingAddress(orderId, lineItems, address) {
    return __async(this, null, function* () {
      const {
        data: {
          message
        }
      } = yield this.client.post("/order/setShippingAddress?id=".concat(orderId), {
        lineItems,
        address
      }, {
        headers: {
          "Accept-version": "v2"
        }
      });
      return message;
    });
  }
  cancelEntity(_0) {
    return __async(this, arguments, function (_ref132) {
      var _this5 = this;
      let {
        orderId,
        lineItemIds: cancelLineItems,
        customLineItemIds: cancelCustomLineItems
      } = _ref132;
      return function* () {
        const {
          data
        } = yield _this5.client.post("/order/cancelEntity", {
          orderId,
          cancelLineItems,
          cancelCustomLineItems
        });
        return data;
      }();
    });
  }
};
var legacyOrderHttpClient = new LegacyOrderHttpClient();
var LegacyOrderHttpClient_default = legacyOrderHttpClient;

// src/library/queries/order/usePatchOrderMutation.ts
function usePatchOrderMutation(_ref133) {
  let {
    context
  } = _ref133;
  const {
    featureToggle: {
      isEnabled: useEcommerceAPI
    }
  } = useFeatureToggle2("ecommerce_migrate_set_billing_address");
  const queryClient = useQueryClient5();
  return useMutation13({
    mutationKey: ["patchOrder" /* patchOrder */, context],
    mutationFn: _a => __async(this, null, function* () {
      var _b = _a,
        {
          orderId
        } = _b,
        payload = __objRest(_b, ["orderId"]);
      if (!orderId) {
        throw new Error("Cannot update an order without an order id");
      }
      switch (context) {
        case "orderSetPoNumber" /* orderSetPoNumber */:
          return OrderHttpClient_default.patchOrder(orderId, payload).then(response => response.data);
        case "orderSetReference" /* orderSetReference */:
          return OrderHttpClient_default.patchOrder(orderId, payload).then(response => response.data);
        case "setBillingAddress" /* setBillingAddress */:
          if (useEcommerceAPI) {
            return OrderHttpClient_default.patchOrder(orderId, payload).then(response => response.data);
          }
          return LegacyOrderHttpClient_default.setBillingAddress({
            orderId,
            address: payload.action.value
          });
        default:
          throw new Error("Unsupported context");
      }
    }),
    onSuccess: order => {
      queryClient.setQueryData(["getOrder" /* getOrder */, order.id], order);
      switch (context) {
        case "orderSetPoNumber" /* orderSetPoNumber */:
          addDataLayerEntry18("order_detail_interaction", {
            action: "edit_po_number"
          });
          break;
        case "orderSetReference" /* orderSetReference */:
          addDataLayerEntry18("order_detail_interaction", {
            action: "edit_reference"
          });
          break;
        case "setBillingAddress" /* setBillingAddress */:
          addDataLayerEntry18("order_detail_interaction", {
            action: "edit_billing_address"
          });
          break;
        default:
          break;
      }
    },
    onError: () => {
      switch (context) {
        case "orderSetPoNumber" /* orderSetPoNumber */:
          addDataLayerEntry18("order_detail_api_failure", {
            action: "error_edit_po_number"
          });
          break;
        case "orderSetReference" /* orderSetReference */:
          addDataLayerEntry18("order_detail_api_failure", {
            action: "error_edit_reference"
          });
          break;
        default:
          break;
      }
    }
  });
}

// src/library/queries/order/usePatchOrderLineItemMutation.ts
import { useMutation as useMutation14, useQueryClient as useQueryClient6 } from "@tanstack/react-query";
import { addDataLayerEntry as addDataLayerEntry19 } from "@printdeal/data-layer-manager";
import { useFeatureToggle as useFeatureToggle3 } from "@printdeal/feature-management/react";
function usePatchOrderLineItemMutation(_ref134) {
  let {
    context,
    onSuccess,
    onError,
    replaceOrderOnSuccess = true
  } = _ref134;
  const {
    featureToggle: {
      isEnabled: useEcommerceAPI
    }
  } = useFeatureToggle3("ecommerce_migrate_set_shipping_address");
  const queryClient = useQueryClient6();
  return useMutation14({
    mutationKey: ["patchLineItem" /* patchLineItem */, context],
    mutationFn: _a => __async(this, null, function* () {
      var _b = _a,
        {
          orderId
        } = _b,
        requestData = __objRest(_b, ["orderId"]);
      if (!orderId) {
        throw new Error("Cannot update a line item without an order id");
      }
      if (!requestData.lineItemId) {
        throw new Error("Cannot update a line item without a line item id");
      }
      if ("removeFile" in requestData) {
        delete requestData.removeFile;
      }
      if (context === "orderLineItemSetShippingAddress" /* orderLineItemSetShippingAddress */ && !useEcommerceAPI) {
        return LegacyOrderHttpClient_default.setShippingAddress(orderId,
        // @ts-expect-error intermediate
        requestData.lineItemIds,
        // @ts-expect-error intermediate
        requestData.payload.shippingAddresses[0].address);
      }
      const {
        data: order
      } = yield OrderHttpClient_default.patchLineItem(orderId, requestData);
      return order;
    }),
    onSuccess: order => {
      if (replaceOrderOnSuccess && "id" in order) {
        queryClient.setQueryData(["getOrder" /* getOrder */, order.id], order);
      }
      if (context === "orderLineItemSetShippingAddress" /* orderLineItemSetShippingAddress */) {
        addDataLayerEntry19("order_detail_interaction", {
          action: "edit_shipping_address"
        });
      }
      if (typeof onSuccess === "function") {
        onSuccess(order);
      }
    },
    onError: error => {
      if (typeof onError === "function") {
        onError(error);
      }
    }
  });
}

// src/library/queries/order/useGetOrderQuery.ts
import { useQuery as useQuery9 } from "@tanstack/react-query";
function useGetOrderQuery(_ref135) {
  let {
    orderId,
    orderNumber,
    enabled = true
  } = _ref135;
  return useQuery9({
    // eslint-disable-next-line
    queryKey: ["getOrder" /* getOrder */, orderId],
    queryFn: () => __async(this, null, function* () {
      if (!orderId && !orderNumber) {
        throw new Error("Cannot get order without an id or an orderNumber");
      }
      const id = orderId || orderNumber;
      const {
        data
      } = yield OrderHttpClient_default.getOrder(id);
      return data;
    }),
    retry: false,
    enabled: enabled && Boolean(orderId)
  });
}

// src/library/components/order/OrderReferenceField.tsx
import { useIntl as useIntl32 } from "react-intl";
import { jsx as jsx86 } from "react/jsx-runtime";
var OrderReferenceField = _ref136 => {
  let {
    order,
    disabled = false
  } = _ref136;
  var _a;
  const intl = useIntl32();
  const patchOrderMutation = usePatchOrderMutation({
    context: "orderSetReference" /* orderSetReference */
  });
  return /* @__PURE__ */jsx86(DebounceField_default, {
    initialValue: ((_a = order.custom) == null ? void 0 : _a.fields.referenceLabel) || "",
    mutationStatus: patchOrderMutation.status,
    onUpdate: value => patchOrderMutation.mutate({
      orderId: order.id,
      action: {
        name: "setReferenceLabel",
        value
      }
    }),
    name: "reference",
    id: "reference",
    label: intl.formatMessage({
      id: "checkout.label.reference",
      defaultMessage: "Reference/Description"
    }),
    disabled
  });
};
var OrderReferenceField_default = OrderReferenceField;

// src/library/components/order/OrderPoNumberField.tsx
import { useIntl as useIntl33 } from "react-intl";
import { jsx as jsx87 } from "react/jsx-runtime";
var OrderPoNumberField = _ref137 => {
  let {
    order,
    disabled = false
  } = _ref137;
  var _a;
  const intl = useIntl33();
  const patchOrderMutation = usePatchOrderMutation({
    context: "orderSetPoNumber" /* orderSetPoNumber */
  });
  return /* @__PURE__ */jsx87(DebounceField_default, {
    initialValue: ((_a = order.custom) == null ? void 0 : _a.fields.PONumber) || "",
    mutationStatus: patchOrderMutation.status,
    onUpdate: value => patchOrderMutation.mutate({
      orderId: order.id,
      action: {
        name: "setPurchaseOrderNumber",
        value
      }
    }),
    name: "poNumber",
    id: "poNumber",
    label: intl.formatMessage({
      id: "checkout.label.poNumber",
      defaultMessage: "PO number"
    }),
    disabled
  });
};
var OrderPoNumberField_default = OrderPoNumberField;

// src/library/queries/order/useGetOrdersQuery.ts
import { useQuery as useQuery10, useQueryClient as useQueryClient7 } from "@tanstack/react-query";
function useGetOrdersQuery(_a, options) {
  var _b = _a,
    {
      page = 0
    } = _b,
    params = __objRest(_b, ["page"]);
  const queryClient = useQueryClient7();
  const queryParams = __spreadProps(__spreadValues({}, params), {
    offset: page <= 1 ? 0 : (page - 1) * (params.limit || 10)
  });
  return useQuery10(__spreadProps(__spreadValues({
    queryKey: ["getOrders" /* getOrders */, queryParams],
    queryFn: () => __async(this, null, function* () {
      const {
        data
      } = yield OrderHttpClient_default.getOrders(queryParams);
      data.results.forEach(order => queryClient.setQueryData(["getOrder" /* getOrder */, order.id], order));
      return data;
    })
  }, options), {
    placeholderData: {
      count: 0,
      limit: 10,
      offset: 0,
      results: [],
      total: 0
    }
  }));
}

// src/library/queries/discount/useGetDiscountCodes.ts
import { useQuery as useQuery11 } from "@tanstack/react-query";

// src/library/http-clients/DiscountHttpClient.ts
import axios8 from "axios";
import { authenticateHttpRequestInterceptor as authenticateHttpRequestInterceptor7 } from "@printdeal/authentication";
import { configurationProvider as configurationProvider14 } from "@printdeal/configuration";
import { getFeatureManagementUserId as getFeatureManagementUserId3 } from "@printdeal/feature-management/react";
var DiscountHttpClient = class {
  get client() {
    var _a;
    if (!this.httpClient) {
      const baseURL = configurationProvider14.getValue("ECOMMERCE_API_BASE_URL");
      this.httpClient = axios8.create({
        baseURL,
        headers: {
          "Feature-Management-User-Id": (_a = getFeatureManagementUserId3()) != null ? _a : ""
        }
      });
      this.httpClient.interceptors.request.use(authenticateHttpRequestInterceptor7);
    }
    return this.httpClient;
  }
  getDiscount() {
    return __async(this, null, function* () {
      return this.client.get("discount");
    });
  }
};
var discountHttpClient = new DiscountHttpClient();
var DiscountHttpClient_default = discountHttpClient;

// src/library/queries/discount/useGetDiscountCodes.ts
function useGetDiscountCodesQuery(options) {
  return useQuery11(__spreadValues({
    queryKey: ["getDiscountCodes"],
    queryFn: () => __async(this, null, function* () {
      const {
        data
      } = yield DiscountHttpClient_default.getDiscount();
      return data;
    })
  }, options));
}

// src/library/queries/order/useGetOrderStatsQuery.ts
import { useQuery as useQuery12 } from "@tanstack/react-query";
function useGetOrderStatsQuery(_ref138) {
  let {
    enabled
  } = _ref138;
  return useQuery12({
    queryKey: ["getOrderStats" /* getOrderStats */],
    queryFn: () => __async(this, null, function* () {
      const {
        data
      } = yield OrderHttpClient_default.getOrderStats();
      return data;
    }),
    placeholderData: {
      inProduction: 0,
      openInvoices: 0,
      waitingForArtwork: 0,
      waitingForPayment: 0
    },
    enabled
  });
}

// src/library/queries/order/useCancelOrderMutation.ts
import { useMutation as useMutation15, useQueryClient as useQueryClient8 } from "@tanstack/react-query";
import { addDataLayerEntry as addDataLayerEntry20 } from "@printdeal/data-layer-manager";
import { useFeatureToggle as useFeatureToggle4 } from "@printdeal/feature-management/react";
function useCancelOrderMutation() {
  const {
    featureToggle: {
      isEnabled: useEcommerceAPI
    }
  } = useFeatureToggle4("ecommerce_migrate_cancel_order");
  const queryClient = useQueryClient8();
  return useMutation15({
    mutationKey: ["cancelOrder" /* cancelOrder */],
    mutationFn: _0 => __async(this, [_0], function (_ref139) {
      let {
        orderId,
        lineItemIds = [],
        customLineItemIds = []
      } = _ref139;
      return function* () {
        if (!orderId) {
          throw new Error("Cannot delete an order without an id");
        }
        if (useEcommerceAPI) {
          const {
            data
          } = yield OrderHttpClient_default.cancelOrder(orderId, {
            lineItemIds
          });
          return data;
        }
        return LegacyOrderHttpClient_default.cancelEntity({
          orderId,
          lineItemIds,
          customLineItemIds
        });
      }();
    }),
    onSuccess: (data, _ref140) => {
      let {
        orderId
      } = _ref140;
      addDataLayerEntry20("order_detail_interaction", {
        action: "cancel_line_item"
      });
      if ("id" in data) {
        queryClient.setQueryData(["getOrder" /* getOrder */, orderId], data);
        return;
      }
      queryClient.invalidateQueries({
        queryKey: ["getOrder" /* getOrder */, orderId]
      });
    },
    onError: () => {
      addDataLayerEntry20("order_detail_api_failure", {
        action: "cancel_line_item"
      });
    },
    retry: false
  });
}

// src/library/queries/order/useGetLatestSelectionQuery.ts
import { useQuery as useQuery13 } from "@tanstack/react-query";
function useGetLatestSelectionQuery(_ref141, options) {
  let {
    productKey
  } = _ref141;
  return useQuery13(__spreadValues({
    queryKey: ["getLatestSelection" /* getLatestSelection */, productKey],
    queryFn: () => __async(this, null, function* () {
      var _a, _b;
      const {
        data: {
          results
        }
      } = yield OrderHttpClient_default.getOrders({
        where: ["lineItems(productKey = \"".concat(productKey, "\")")],
        withTotal: false,
        limit: 1,
        offset: 0
      });
      if (!results.length) {
        return void 0;
      }
      const [order] = results;
      if (!order) {
        return void 0;
      }
      return (_b = (_a = order.lineItems.find(_ref142 => {
        let {
          productKey: lineItemProductKey
        } = _ref142;
        return lineItemProductKey === productKey;
      })) == null ? void 0 : _a.custom) == null ? void 0 : _b.fields.merchProductURL;
    })
  }, options));
}
export { AddressError_default as AddressError, BillingAddressPanel_default as BillingAddressPanel, CartPoNumberField_default as CartPoNumberField, CartProvider_default as CartProvider, CartQueryMutationKey, CartReferenceField_default as CartReferenceField, CartView_default as CartView, CheckoutDevOnly_default as CheckoutDevOnly, CheckoutStepper_default as CheckoutStepper, CheckoutViewProvider_default as CheckoutViewProvider, DeliveryOptionDescription_default as DeliveryOptionDescription, DeliveryOptionPriceBadge_default as DeliveryOptionPriceBadge, DeliveryView_default as DeliveryView, DiscountSummary_default as DiscountSummary, EditLineItemModal_default as EditLineItemModal, ErrorAlert_default as ErrorAlert, LineItemArtwork_default as LineItemArtwork, LineItemDescription_default as LineItemDescription, OrderPoNumberField_default as OrderPoNumberField, OrderQueryMutationKey, OrderReferenceField_default as OrderReferenceField, PaymentMethodIconGrid_default as PaymentMethodIconGrid, PaymentMethodView_default as PaymentMethodView, ShippingAddressPanel_default as ShippingAddressPanel, useAddLineItemMutation, useAddQuoteToCartMutation, useCancelOrderMutation, useCart, useEntityTotals, useGetDiscountCodesQuery, useGetLatestSelectionQuery, useGetOrderQuery, useGetOrderStatsQuery, useGetOrdersQuery, useGetPickupPointQuery, usePatchCartMutation, usePatchOrderLineItemMutation, usePatchOrderMutation, useReOrderLineItemsMutation, useRemoveLineItemMutation, useUpdateLineItemMutation, useValidateAddress };